{
  "locales": { "en": "English", "zh-TW": "繁體中文", "ja": "日本語" },
  "common": {
    "titles": {
      "error": "エラー",
      "warning": "警告",
      "remind": "思い出させる",
      "hint": "ヒント",
      "checkYourSettings": "設定内容を確認してください"
    },
    "buttons": {
      "ok": "確認する",
      "confirm": "確認",
      "cancel": "キャンセル",
      "submit": "送信",
      "publish": "公開",
      "delete": "削除",
      "activate": "有効にする",
      "deactivate": "無効化",
      "replace": "上書きする",
      "close": "閉鎖",
      "leave": "閉じる",
      "apply": "適用する",
      "edit": "編集",
      "search": "検索",
      "save": "保存",
      "completeAndCheck": "完了してチェック",
      "back": "前のステップに戻る",
      "next": "次のステップ",
      "nextPage": "次のページ",
      "reject": "拒否する",
      "goSummary": "変更のプレビュー",
      "backModify": "編集に戻る",
      "review": "確認する",
      "archive": "アーカイブ",
      "restore": "復元",
      "download": "ダウンロード",
      "goBack": "戻る"
    },
    "messages": {
      "succeeded": "成功",
      "failed": "失敗",
      "loading": "コーヒーブレイクを",
      "permissionDenied": "この操作を実行する権限がありません"
    },
    "units": {
      "seconds": "秒",
      "secs": "秒",
      "device": "台",
      "devices": "台",
      "day": "日",
      "days": "日",
      "hour": "時間",
      "hours": "時間",
      "minutes": "分"
    },
    "timeZone": {
      "taipei": "アジア/台北",
      "tokyo": "アジア/東京",
      "hochiminh": "アジア/UTC+7 (ホーチミン市、ジャカルタなど)"
    },
    "currency": {
      "twd": "台湾ドル（TWD）",
      "ntd": "台湾ドル（NTD）",
      "usd": "米ドル",
      "myr": "マレーシア・リンギット MYR",
      "jpy": "日本円 JPY",
      "vnd": "ベトナムドン（VND）",
      "idr": "インドネシアルピア（IDR）",
      "eur": "ユーロ（EUR）"
    },
    "language": { "zhtw": "繁中", "enus": "英語", "jajp": "日本語" },
    "placeholder": { "pleaseSelect": "選択してください", "all": "全て" },
    "labels": {
      "noData": "なし",
      "yes": "はい",
      "no": "いいえ",
      "can": "はい",
      "cannot": "いいえ",
      "default": "デフォルト",
      "copyToClipBoard": "クリップボードにコピー",
      "total": "合計",
      "showMore": "もっと見る",
      "open": "開ける",
      "close": "閉鎖",
      "optional": "オプション",
      "comingSoon": "近日公開予定の機能",
      "edit": "編集"
    },
    "notice": "知らせ",
    "valuePerDay": "{{value}} / 日",
    "day": "日",
    "joinSeparator": "、",
    "duration": "{{開始}}}1/>から<3/>{{終了}}",
    "warning": "警告する"
  },
  "actor": {
    "types": {
      "system": "システム",
      "agency": "広告代理店",
      "advertiser": "広告主"
    },
    "roles": {
      "admin": "管理者（Admin）",
      "manager": "キャンペーンディレクター",
      "account": "アカウントと承認",
      "sales": "広告営業担当者",
      "report": "広告クライアント"
    },
    "roleNames": {
      "admin": "システム管理者",
      "agencyAdmin": "広告代理店 | 管理者（Admin）",
      "agencyManager": "広告代理店 | 広告マネージャー",
      "agencyOperator": "広告代理店 | 広告オペレーター",
      "agencySales": "広告代理店 | 広告マネージャー",
      "agencyReport": "広告代理店 | 広告オプティマイザー",
      "advertiserAdmin": "広告主 | 広告マネージャー",
      "advertiserSales": "広告主 | 広告営業担当者",
      "advertiserReport": "広告主 | 広告クライアント",
      "reconciliationOfficer": "財務スタッフ",
      "beaconAdmin": "Beacon マネージャー",
      "beaconExecutive": "Beacon オペレーター"
    },
    "descriptions": {
      "agencyAdmin": "代理店アカウントの権限管理/広告の管理・審査",
      "agencyManager": "代理店内の広告の管理・審査",
      "agencyOperator": "広告キャンペーンの作成・運営・クライアントへの成果レポートを提供",
      "agencyAccount": "広告主を作成し、広告代理店の営業担当者を広告主の権限に割り当てる",
      "agencySales": "代理店が担当する全広告案件の閲覧",
      "agencyReport": "注文詳細と成果レポートの閲覧",
      "advertiserAdmin": "担当する広告主の案件を管理する",
      "advertiserSales": "キャンペーンの作成と管理",
      "advertiserReport": "広告主の広告結果を表示する",
      "reconciliationOfficer": "財務スタッフ",
      "beaconAdmin": "システム管理者",
      "beaconExecutive": "広告配信と beacon のメンテナンスに重点を置き、プッシュコンテンツの設定を担当します"
    }
  },
  "appHeader": {
    "logout": "サインアウト",
    "changePassword": "パスワードを変更する",
    "sudo": { "title": "アカウントを変更する" },
    "changeLanguage": {
      "message": "言語を変更するにはページを更新する必要があります。続行してもよろしいですか？"
    }
  },
  "login": {
    "form": {
      "title": "PerforMaxにログイン",
      "placeholders": {
        "email": "あなたのアカウント",
        "password": "パスワード",
        "confirmPassword": "パスワードをもう一度入力してください"
      },
      "buttons": { "login": "ログイン" }
    }
  },
  "agencies": {
    "home": {
      "title": "広告代理店",
      "addAgency": "+ 広告代理店",
      "searchPlaceholder": "広告代理店を探す…"
    },
    "status": {
      "all": "すべて",
      "active": "有効",
      "archived": "アーカイブ済み"
    },
    "headers": {
      "id": "シリアルナンバー",
      "name": "広告代理店名",
      "loginTitle": "ログインページのタイトル",
      "loginDomain": "ログインページのドメイン",
      "oemAgency": "OEM 広告代理店",
      "currency": "通貨",
      "timeZone": "タイムゾーン",
      "status": "ステータス"
    },
    "filter": {
      "statusFilter": "広告代理店ステータス",
      "statusTag": "ステータス",
      "statusFilterMenuTitle": "ステータスを選択"
    },
    "noDataAvailable": "一致する広告代理店が見つかりません"
  },
  "accounts": {
    "home": {
      "searchPlaceholder": "アカウントを検索...",
      "title": "アカウント設定",
      "addAccount": "+ アカウント"
    },
    "headers": {
      "email": "電子メール",
      "name": "アカウント名",
      "status": "状態",
      "isAdmin": "システム管理者",
      "companyName": "広告代理店",
      "company": "会社名",
      "permission": "権限",
      "pending": "有効にするには"
    },
    "tabs": { "agencies": "広告代理店", "advertisers": "広告主" },
    "summary": {
      "title": "アカウント設定",
      "labels": {
        "email": "電子メール",
        "name": "アカウント名",
        "status": "状態",
        "isAdmin": "システム管理者",
        "edit": "編集",
        "isPending": "有効にするには"
      }
    },
    "detail": { "title": "アカウント情報" },
    "inactive": "無効化",
    "active": "有効にする",
    "placeholder": {
      "noDataAvailable": "一致する情報が見つかりません",
      "pleaseSearch": "変換したいアカウントを検索してください"
    },
    "form": {
      "titles": {
        "new": "新しいアカウントを追加する",
        "edit": "アカウントを編集",
        "permission": "権限設定"
      },
      "labels": {
        "email": "電子メール",
        "name": "アカウント名",
        "currentPassword": "パスワード",
        "status": "状態",
        "activated": "有効にする",
        "isAdmin": "システム管理者",
        "account-email": "アカウント - メール:",
        "permission": "権限",
        "agency": "広告代理店",
        "role": "アカウントの役割",
        "password": "新しいパスワード",
        "confirmPassword": "パスワードをもう一度入力してください"
      },
      "messages": {
        "nameRequired": "アカウント名を入力してください",
        "emailRequired": "メールアドレスを入力してください",
        "invalidEmail": "@ と . を含むメール形式を入力してください",
        "currentPasswordRequired": "現在のパスワードを入力してください",
        "passwordRequired": "パスワードを入力してください",
        "confirmPasswordRequired": "パスワードをもう一度確認してください",
        "passwordNotMatched": "入力したパスワードは以前のものと一致しません"
      },
      "buttons": { "deletePermission": "削除権限" },
      "hints": {
        "assignRole": "<1>注意:</1> ユーザーは、代理店または広告主の役割が割り当てられるまでログインできません。"
      }
    },
    "labels": { "activate": "有効にする", "deactivate": "無効化" },
    "messages": {
      "activateSuccess": "アカウントを有効化しました",
      "deactivateSuccess": "アカウントを無効化しました"
    }
  },
  "agencyDetail": {
    "archiveModal": {
      "content": "アーカイブすると、この広告代理店の実行中および未実行の広告キャンペーンが一時停止され、この広告代理店に所属するすべてのメンバーの権限が削除されます。アーカイブしてもよろしいですか？",
      "title": "広告代理店をアーカイブ"
    },
    "labels": {
      "editAgency": "ディーラーを編集",
      "otherSettingsTab": "その他の設定",
      "auditLogTab": "操作履歴記録",
      "adDeclarationTab": "広告宣伝文",
      "priceModelTab": "価格モデル",
      "bidPriceSettingsTab": "入札設定",
      "adTypeTab": "キャンペーンタイプ",
      "title": "ディーラー",
      "basicTab": "基本設定",
      "addonFeatureTab": "追加機能",
      "campaignTargetingTab": "広告キャンペーンの目標",
      "memberTab": "メンバー設定",
      "adLogoTab": "広告ロゴ"
    },
    "buttons": { "back": "戻る", "edit": "ディーラーを編集" }
  },
  "serverResponse": {
    "400000": "要求の形式が正しくありません",
    "400010": "このメールアドレスはすでに登録されています",
    "400013": "パスワードリセットリンクが記載されたメールが迷惑メールフォルダに届いていないかご確認ください。パスワードを再度リセットするには、24時間お待ちください。",
    "400030": "無効な操作",
    "400031": "ディーラー値が無効です",
    "400033": "この広告代理店はアーカイブされているため、メンバーの権限を追加・変更できません。",
    "400050": "信用限度額が不足しています",
    "400061": "すでに開始されているキャンペーンやクリエイティブにバインドされているキャンペーンは削除できません",
    "400070": "無効な材料パラメータ",
    "400071": "サポートされていない材料比率サイズ",
    "400072": "ファイルサイズが2Mを超えています",
    "400073": "無効なマテリアルファイル形式",
    "400075": "屋外素材に使用されている署名は違法です。動画を再度アップロードしてください。",
    "400076": "検出されたエンコードは{{codec}}です。このチャネルは{{allowed}}のみ対応しています。",
    "400077": "素材の再生サイズ設定に誤りがあります。システム管理者に販売チャネル設定の確認を依頼してください。",
    "400080": "提出された資料が不完全です",
    "400100": "サポートされていないファイル形式",
    "400106": "このアカウントは無効になっています",
    "400120": "キャンペーンが確立されている広告グループは削除できません",
    "400600": "無効な操作",
    "401000": "権限のないユーザー",
    "401010": "アカウントにログインしていません",
    "401500": "この機能を使用する権限がありません",
    "401900": "サードパーティAPI認証に失敗しました",
    "401950": "Yahoo API認証に失敗しました",
    "401970": "Azure認証に失敗しました",
    "402500": "無効な役割",
    "403000": "アクセス禁止",
    "403010": "アカウントにはこのリソースにアクセスする権限がありません",
    "403030": "この広告代理店はアーカイブされ利用できません。ログアウトします。",
    "404000": "指定されたリソースが見つかりませんでした",
    "404010": "このアカウントは存在しません",
    "404012": "このアカウントは存在しません",
    "404020": "この会社は存在しません",
    "404030": "このディーラーは存在しません",
    "404040": "この広告主は存在しません",
    "404050": "この注文は存在しません",
    "404060": "このキャンペーンは存在しません",
    "404062": "このキャンペーンの広告ロゴは存在しません",
    "404070": "この資料は存在しません",
    "404090": "このオーディエンスは存在しません",
    "404091": "この操作では親オーディエンスを指定する必要があります",
    "404110": "無効なコンバージョン トラッキング タイプ",
    "404111": "このコンバージョントラッカーは存在しません",
    "404120": "広告グループが見つかりません",
    "404600": "このリソースは存在しません",
    "405000": "権限が不十分です",
    "406010": "アカウントが無効になりました",
    "408000": "接続タイムアウト",
    "408080": "送信接続に失敗しました",
    "409000": "リクエストはサーバーの現在の状態と競合しています",
    "409050": "重複注文外部番号",
    "500000": "不明なエラー",
    "500080": "JSON解析に失敗しました",
    "500081": "URL解析に失敗しました",
    "500910": "不明なPVMaxエラーが発生しました",
    "500920": "IMaxにログインできません",
    "500921": "IMaxオーディエンスの構築失敗",
    "500922": "IMaxCollector の作成に失敗しました",
    "500923": "IMaxコードの取得に失敗しました",
    "500951": "Yahoo API接続に失敗しました",
    "500952": "Yahooレポートを取得できません",
    "500960": "Google API接続に失敗しました",
    "500961": "Googleドライブのファイルを取得できません",
    "500970": "Azure サービス接続に失敗しました",
    "500971": "Azure MediaService の接続に失敗しました",
    "500980": "DMPはオーディエンス構築に失敗する",
    "500981": "DMPオーディエンス更新失敗",
    "500982": "DMP はオーディエンスを削除できませんでした",
    "500983": "DMP はオーディエンスのインポートに失敗しました",
    "500984": "DMPオーディエンスのエクスポートに失敗しました",
    "500985": "DMPオーディエンスコードを取得できません",
    "500986": "指定された期間内に視聴者がこの広告を見た最大回数",
    "500987": "コンバージョントラッキングコードを取得できません",
    "4001605": "ブランド名の形式が正しくありません。内容を確認して再度お試しください。",
    "4001606": "ブランドリンクの形式が正しくありません。http:// または https:// で始まる有効なURLを入力してください。",
    "4001607": "地図マーカー画像はSVGまたはPNG形式である必要があります。もう一度アップロードしてください。",
    "4001608": "地図マーカー画像のファイルサイズは200KB未満である必要があります。",
    "4001609": "地図マーカー画像（SVG）に、スクリプトや外部リンクなど許可されていない内容が含まれています。削除してからもう一度アップロードしてください。",
    "4001700": "ハードウェアIDの形式が正しくありません。設定を再確認してください。",
    "4001701": "チャネルアクセストークンの形式が正しくありません。設定を再度確認してください。"
  },
  "auditLog": {
    "company": {
      "archiveAgency": "ディーラーをアーカイブ",
      "restoreAgency": "ディーラーを復元",
      "createAgency": "ディーラーを設立する",
      "updateAgency": "ディーラーを更新"
    },
    "headers": {
      "ctime": "日付",
      "srcID": "操作オブジェクト",
      "email": "ユーザーメールボックス",
      "funcType": "イベント"
    },
    "adsOrder": {
      "create": "ニュー・オーダー",
      "update": "注文の更新",
      "approve": "注文を承認する",
      "reject": "注文を拒否する"
    },
    "l1Object": {
      "create": "広告グループを作成する",
      "update": "広告グループを更新する"
    },
    "campaign": {
      "create": "新しいキャンペーンを追加する",
      "update": "キャンペーンを更新",
      "delete": "キャンペーンを削除する",
      "activate": "キャンペーンを有効にする",
      "deactivate": "キャンペーンを無効にする",
      "saveCampaign": "店舗キャンペーン",
      "bindCreatives": "既存ものを使用",
      "bindedCreatives": {
        "activate": "マテリアルを有効にする",
        "deactivate": "マテリアルを非アクティブ化する"
      },
      "split": "キャンペーンを分割する",
      "paused": "キャンペーンが無効になっています"
    },
    "agency": { "updateRebateRate": "メディアボーナスを更新" },
    "companyRoleMap": {
      "createAgencyRole": "メンバーのディーラー権限の割り当て",
      "updateAgencyRole": "メンバーのディーラー権限を更新する",
      "suspendAgencyRole": "メンバーの再販業者権限を削除する",
      "agencyArchivedSuspendAgencyRole": "アーカイブに伴いメンバーの再販業者権限を削除する"
    },
    "labels": {
      "srcAdsOrder": "注文",
      "srcL1Object": "広告グループ",
      "srcCampaign": "キャンペーン",
      "srcAdAgency": "ディーラー",
      "srcCompanyRoleMap": "権限",
      "from": "から",
      "to": "到着",
      "l1ObjectFilterTitle": "広告グループ",
      "campaignFilterTitle": "キャンペーン",
      "frequencyNoEnable": "持ち込み禁止品",
      "fieldFilterTitle": "分野",
      "autoOptimise": "CBO",
      "channel": "配信チャネル",
      "l1ChannelId": "RTB 広告グループ ID",
      "l1ObjectLifetimeBudget": "予算",
      "dealIds": "取引IDを指定する",
      "frequency": "広告配信頻度と配信期限",
      "viewTrackingCodes": "サードパーティの追跡",
      "adType": "広告の種類",
      "bidPrice": "配送制限",
      "camName": "キャンペーン名",
      "convTrackEvent": "コンバージョントラッキングモード",
      "deliverType": "配信タイプ",
      "endDate": "終了日",
      "id": "シリアルナンバー",
      "optimize": "スマート入札モード",
      "planType": "価格モデル",
      "startDate": "開始日",
      "tags": "メモ",
      "targetBudget": "予算",
      "dayPart": "配信時間を指定する",
      "advertiserId": "広告主ID",
      "budget": "注文予算",
      "orderMargin": "ディーラーの利益",
      "projectName": "注文名",
      "agcPercent": "ディーラーの利益",
      "sysPercent": "システム利益",
      "state": "状態",
      "spentCheckpoints": "チェックポイント",
      "currencyRate": "為替レート",
      "selfBuyOnly": "独自のトラフィック",
      "bindCreatives": "既存ものを使用",
      "stopping": "キャンペーンは一時停止されています",
      "dailyTargetBudget": "1日の予算",
      "videoProgressTrackingCode": "リマーケティングトラッキング",
      "adLogo": "広告ロゴ",
      "conversionTracking": "コンバージョントラッキング",
      "orderPrice": "契約価格",
      "videoAdViewObjective": "ターゲットを見る",
      "externalId": "外部注文番号",
      "checkpoints": "チェックポイント",
      "expectedSpent": "予想される費用",
      "daterange": "日付範囲",
      "dealID": "取引IDを指定する",
      "creativeDeliverType": "材料の配送方法",
      "changeBudget": "予算の修正",
      "changeOrderMargin": "変更される注文の利益",
      "modifyReason": "変更理由",
      "ageMin": "最低年齢",
      "ageMax": "最大年齢",
      "gender": "性別",
      "creativeDuration": "素材秒數",
      "finalReportTargetType": "ターゲットタイプ",
      "finalReportTargetValue": "目標回数",
      "finalReportAdvertiserName": "広告主名",
      "targetImpressions": "目標インプレッション数",
      "goGanGroupId": "広告グループID",
      "orderNumber": "注文番号",
      "outdoorDeliverType": "機械による配送方法",
      "adminBidPrice": "入札設定",
      "Magnification": "重さ",
      "compositePixelWidth": "実際の再生幅",
      "compositePixelHeight": "実際の再生高さ",
      "clicks": "クリック数",
      "impres": "インプレッション数",
      "lastHourOlapActualSpent": "費やした時間",
      "olapActualSpent": "実費",
      "olapExpectedSpent": "予想される費用",
      "olapExpectSpent": "予想される費用",
      "spent": "消化金額",
      "uniqueUser": "リピーターなし",
      "viewable": "ビューアブルインプレッション数",
      "priceModel": "価格モデル",
      "spents": "消化金額",
      "isMonitorEnable": "キャンペーンの異常な進捗状況を監視する",
      "name": "名前",
      "createDate": "作成日",
      "campaignId": "キャンペーンID",
      "uniqueUsers": "リピーターなし",
      "orderId": "注文番号",
      "agencyId": "ディーラー番号",
      "bidPriceMin": "最低入札制限",
      "campaignConstraint": "キャンペーンの最小入札額",
      "externalType": "外部注文タイプ",
      "timezone": "タイムゾーン",
      "comments": "述べる",
      "currency": "通貨",
      "monitorEnable": "キャンペーンの異常な進捗状況を監視する",
      "rebateRate": "メディアインセンティブ",
      "companyId": "会社番号",
      "companyName": "会社名",
      "comComment": "その他の注意事項",
      "language": "言語",
      "loginEmail": "ログインページアカウント",
      "loginDomain": "ログインページのドメイン",
      "sysPercentIn": "システムコミッション（内部）",
      "sysPercentOut": "メディアインセンティブ（外部）",
      "maxOrderProfit": "ディーラーの利益上限",
      "taxPercent": "税金",
      "providerId": "プロバイダーID",
      "oem": "OEMディストリビューター",
      "logoUrl": "ロゴ",
      "priority": "配送優先度",
      "limitPublisher": "ウェブサイト所有者ID",
      "limitPublisherCountry": "出版社の国",
      "limitAdx": "広告取引プラットフォーム",
      "defaultCountry": "国家",
      "defaultSpace": "版位",
      "segmentCountry": "対象国",
      "segmentLabel": "オーディエンスタグ",
      "defaultCountryOp": "全国配送交通案内",
      "defaultSpaceOp": "配置配信トラフィック方向",
      "limitAdxOp": "広告交換プラットフォーム配信トラフィック方向",
      "interstitial": "許容カバーフロー",
      "credit": "信用限度額",
      "noLimitSelfBuyStatus": "非所有トラフィックの配信",
      "selfBuy": "独自のトラフィック",
      "timeZone": "タイムゾーン",
      "roleName": "権限",
      "account": "アカウント - メール",
      "agencyID": "ディーラー番号",
      "rate": "将来のメディアボーナス比率",
      "effectDate": "将来のボーナス発効日",
      "effectiveArchived": "チャネル停止ステータス",
      "pmaxArchiveReason": "PMax 停止理由",
      "pmaxArchived": "PMax 停止ステータス",
      "rmaxArchiveReason": "RMax 停止理由",
      "srcChannelGroup": "配信チャネル",
      "channelGroupStatus": "RMax 配信チャネルステータス",
      "channelGroupId": "配信チャネル ID",
      "channelGroupType": "配信チャネル種別",
      "campaignAdTypeSettings": "広告タイプ設定",
      "reportIgnoredDV360Items": "レポート除外 DV360 項目",
      "campaignBidPrice": "入札価格設定",
      "screenPixelWidth": "スクリーン幅 (px)",
      "screenPixelHeight": "スクリーン高さ (px)"
    },
    "placeholders": {
      "l1ObjectFilter": "表示する広告グループを選択してください",
      "campaignFilter": "表示するキャンペーンを選択してください",
      "fieldFilter": "表示する列を選択してください"
    },
    "limitation": { "create": "保存先設定" },
    "channelGroup": {
      "pmaxArchive": "配信チャネルを停止",
      "pmaxUnarchive": "配信チャネルを再開",
      "update": "配信チャネルを編集"
    }
  },
  "appMenus": {
    "report": {
      "title": "広告効果",
      "items": {
        "performance": "広告効果",
        "dataMarketplace": "データ市場",
        "video": "動画広告のパフォーマンス",
        "campaignDashboard": "キャンペーンダッシュボード",
        "reconciliation": "代理店突合表",
        "credit": "与信限度額",
        "storedValue": "入金残高",
        "salesChannelReconciliation": "配信チャネル別突合レポート"
      }
    },
    "comapnyManagement": {
      "title": "会社経営",
      "items": {
        "agencies": "広告代理店",
        "advertisers": "広告主",
        "accounts": "アカウント",
        "newAccount": "新しいアカウントを追加する",
        "oemAccounts": "ホワイトラベルアカウント",
        "pmp": "PMP注文"
      }
    },
    "system": {
      "title": "システム管理",
      "items": {
        "productGroups": "製品グループ管理",
        "roles": "官能基",
        "currencyRate": "為替レート設定",
        "auditLog": "操作ログ",
        "channelGroups": "配信チャネル管理",
        "streamingStatus": "ストリーミングステータス"
      }
    },
    "ads": {
      "title": "広告管理",
      "items": {
        "orders": "注文と広告",
        "creatives": "素材",
        "creativeTemplates": "マテリアルテンプレートライブラリ",
        "conversion": "コンバージョントラッキング"
      }
    },
    "data": {
      "title": "データ管理",
      "items": {
        "audienceSegments": "リターゲティング",
        "marketplace": "データ市場",
        "tenmaxSegments": "TenMaxのオーディエンス",
        "messageSegments": "ニュースレターの読者",
        "customLayouts": "手彫りバージョン",
        "deviceManagement": "端末管理"
      }
    },
    "eCommerce": {
      "title": "電子商取引",
      "items": {
        "products": "製品ライブラリ",
        "conversion": "セールスファネル",
        "events": "行動イベント",
        "strategies": "プログラマティック戦略"
      }
    },
    "other": {
      "title": "その他の機能",
      "items": {
        "doctor": "配送制限を確認する",
        "outdoorMonitor": "屋外広告トラフィック監視"
      }
    },
    "beaconComapnyManagement": {
      "title": "Beacon 経営",
      "items": { "merchants": "公式アカウント一覧", "restaurants": "商家一覧" }
    },
    "beaconMessageManagement": {
      "title": "Beacon メッセージ管理",
      "items": { "beaconMessages": "Beacon メッセージ設定" }
    },
    "announcement": {
      "title": "お知らせ",
      "items": { "siteAnnouncement": "通知センター" }
    }
  },
  "agency": {
    "companyAttribute": "会社種別",
    "currentRebateRate": "現在のメディアインセンティブ",
    "futureEffectDate": "有効日",
    "futureRebateRate": "未来メディア助成金",
    "id": "ディーラーID",
    "companyName": "会社名",
    "language": "言語",
    "currency": "通貨",
    "timeZone": "タイムゾーン",
    "targetBudgetMinimum": "最低配送金額",
    "taxPercent": "税金",
    "priority": "配送優先度",
    "limitPublisherCountryStr": "出版社の国",
    "selfBuy": "独自のトラフィック",
    "limitPublisherStr": "ウェブサイト所有者ID",
    "noLimitSelfBuyStatus": "非所有トラフィックの配信",
    "limitAdxStr": "広告取引プラットフォーム",
    "defaultCountryStr": "国家",
    "defaultSpaceStr": "版位",
    "segmentCountryStr": "対象国",
    "segmentLabelStr": "オーディエンスタグ",
    "campaignBudgetMinimum": "最低キャンペーン予算",
    "interstitial": "許容カバーフロー",
    "comComment": "その他の注意事項",
    "sysPercentIn": "システムコミッション（内部）",
    "sysPercentOut": "メディアインセンティブ（外部）",
    "margin": "利益",
    "information": "ディーラー情報",
    "marginSetting": "利益設定",
    "agcPercent": "ディーラーが設定した利益",
    "logo": "ロゴ",
    "yes": "はい",
    "no": "いいえ",
    "form": {
      "titles": {
        "new": "新規ディーラー",
        "edit": "ディーラーを編集",
        "deliverySetting": "配送設定",
        "rtbDeliverySetting": "RTB配信設定",
        "generalDeliverySetting": "一般的な配送設定"
      }
    },
    "member": {
      "addMember": "+ メンバー",
      "addAccount": "+ アカウント",
      "headers": {
        "index": "シリアルナンバー",
        "email": "電子メール",
        "name": "メンバー名",
        "status": "状態",
        "permission": "権限"
      },
      "active": "有効にする",
      "inactive": "無効化",
      "permissions": {
        "AGENCY_ADMIN": "広告代理店 - 管理者（Admin）",
        "AGENCY_MANAGER": "広告代理店 - 広告マネージャー",
        "AGENCY_OPERATOR": "広告代理店 - 広告オペレーター",
        "AGENCY_SALES": "広告代理店 - 広告マネージャー",
        "AGENCY_REPORT": "広告代理店 - 広告効果マネージャー",
        "BEACON_EXECUTIVE": "Beacon オペレーター"
      },
      "noDataAvailable": "現在メンバーがいません。「+ メンバー」をクリックして新しいメンバーを追加してください。"
    },
    "addonProps": { "maxOrderProfit": "ディーラーの利益上限" },
    "addonGroup": {
      "channel": "配信チャネル",
      "creatives": "材料の種類",
      "company": "会社経営",
      "adsOrder": "注文タイプ",
      "order": "注文タイプ",
      "campaign": "キャンペーン",
      "creative-studio": "マテリアルテンプレートライブラリ",
      "conversiontracking": "コンバージョントラッキング",
      "report": "報告",
      "monitor": "モニター",
      "campaignLimitation": "キャンペーンのターゲットの最適化",
      "creativeLimitation": "材料最適化の目標",
      "reconciliationAndBudget": "請求照合レポート・注文予算管理",
      "creativeReview": "素材審査管理",
      "adTypes": "広告の種類"
    },
    "addonItem": {
      "channel": {
        "openRTB": "OpenRTB",
        "pic": "PIC Outdoor",
        "salesChannelMargin": "ディーラーの利益",
        "message": "Message",
        "fridge": "WI Fridge",
        "matsukiyo": "Retail Beacon Network",
        "hwacom": "HwaCom",
        "salesChannelExpressPass": "これらの材料はすぐに通過できますか?"
      },
      "creatives": {
        "option_image": "イメージ広告",
        "option_html5": "HTML広告",
        "option_native": "ネイティブ広告",
        "option_video": "動画広告",
        "option_dynamic": "ダイナミック広告",
        "option_flash": "フラッシュ広告",
        "option_thirdParty": "サードパーティの広告",
        "option_combo": "ビデオ+画像広告",
        "option_oneForAll": "ワン・フォー・オール広告",
        "option_oneForAllDisplay": "ワンフォーオールディスプレイ広告",
        "option_oneForAllVideo": "ワン・フォー・オール動画広告",
        "option_ctv": "デジタルテレビ広告",
        "option_customRectangle": "手彫りの中型長方形広告",
        "option_customBottom": "手彫りの下部広告",
        "option_edimax": "エディマックス屋外広告",
        "option_picShort": "PIC屋外15秒広告",
        "option_picLong": "PIC屋外30秒広告",
        "option_picExtended": "PIC屋外60秒広告",
        "option_picBroad": "PIC屋外60秒以上の広告",
        "option_fridgeBroad": "60秒以上の屋外冷凍庫広告",
        "option_fridgeLong": "30秒の屋外冷凍庫広告",
        "option_fridgeExtended": "60秒の屋外冷凍庫広告",
        "option_outdoorLineMessage": "Outdoor Line Message 広告",
        "option_lineMessage": "Line Message 広告",
        "option_sandboxOutdoor": "R&Dテストユーザー屋外広告",
        "option_hwacomShort": "HwaCom15秒広告",
        "option_hwacomLong": "HwaCom30秒広告",
        "option_hwacomExtended": "HwaCom60秒広告",
        "option_hwacomBroad": "HwaCom60秒以上の広告",
        "adType_one_for_all_display": "ワンフォーオールディスプレイ広告",
        "adType_display": "ディスプレイ広告",
        "adType_third_party": "サードパーティの広告",
        "adType_third_party_bottom": "モバイル下部広告",
        "adType_third_party_rectangle": "中サイズの長方形広告",
        "adType_video": "視聴覚広告",
        "adType_combo": "ビデオ+画像広告",
        "adType_ctv": "デジタルテレビ広告",
        "adType_keyword": "キーワード広告",
        "adType_pic_short": "PIC屋外15秒広告",
        "adType_pic_long": "PIC屋外30秒広告",
        "adType_pic_extended": "PIC屋外60秒広告",
        "adType_pic_broad": "PIC屋外60秒以上の広告",
        "adType_fridge_broad": "60秒以上の屋外冷凍庫広告",
        "adType_fridge_long": "30秒の屋外冷凍庫広告",
        "adType_fridge_extended": "60秒の屋外冷凍庫広告",
        "adType_pmp_pic": "PMP PIC 屋外広告",
        "adType_pmp_fridge": "PMP冷凍庫屋外広告",
        "adType_sandbox_outdoor": "R&Dテストユーザー屋外広告",
        "adType_outdoor_line_message": "Outdoor Line Message 広告",
        "adType_line_message": "Line Message 広告",
        "adType_sandbox_movable_outdoor": "R&Dテストユーザー移動式屋外広告",
        "adType_hwacom_short": "HwaCom15秒広告",
        "adType_hwacom_long": "HwaCom30秒広告",
        "adType_hwacom_extended": "HwaCom60秒広告",
        "adType_hwacom_broad": "HwaCom60秒以上の広告",
        "landingPage": "対象ページ",
        "customizeAdLogo": "カスタム広告ロゴ"
      },
      "order": { "showOrderExternalType": "外部注文タイプメニュー" },
      "company": {
        "agencyProfit": "ディーラーの利益設定",
        "rebate": "メディアインセンティブ",
        "incentive": "ボーナスターゲット/ターゲットボーナス",
        "provideReportToWorkflow": "ディーラー調整レポート",
        "singleOrderBudgetConstraint": "1回の注文の予算制限",
        "productGroup": "製品グループ",
        "orderBudgetMaximum": "最高",
        "useAgencyProfitOnRebateReport": "ディーラー月次レポートのディーラー利益を使用して利益を計算する",
        "showOutComeOnRebateReport": "ディーラーの月次レポートに過剰支出が表示される",
        "creditLimit": "信用限度額",
        "creditLimitMaximum": "信用限度額",
        "allowOrderSettlement": "注文決済の実行を許可する",
        "allowOrderAutoSettlement": "注文の自動決済を許可する",
        "modifyOrderBudgetAfterSettlement": "決済機能で注文予算を変更できるようにする",
        "fixedExchangeRate": "広告配信では固定為替レートを使用する",
        "ExchangeRate": "為替レート",
        "showOrderExternalType": "注文作成ページと編集ページに外部タイプメニューを表示する",
        "advertiserViewSpentInReport": "広告主はレポートページで支出を閲覧できる",
        "lookalikeAudienceCreation": "類似オーディエンスの作成が可能",
        "allowBidPriceMoreThenContractPrice": "契約価格を超える入札上限を許可する",
        "outdoorAgency": "屋外広告販売業者",
        "outdoorMachineCount": "屋外広告機の数",
        "storedValue": "保存価値の制限",
        "advAdminInfoRestriction": "広告主 | 広告マネージャーは個人情報のみ閲覧可能",
        "directlyApproveCreative": "資料をRMaxに提出してレビューを受けると、レビューなしで自動的に承認されます。",
        "agencySegment": "ディーラーオーディエンスパックの使用",
        "agencySegmentLimitationName": "ディーラーオーディエンスパックのターゲット名"
      },
      "dependenceHint": "必要な依存関係: {{addon}}",
      "campaign": {
        "bid_weight_setting": "配送重量設定",
        "admin_bid_price_setting": "配送金額設定",
        "orderAgcProfitSetting": "注文時にディーラーの利益を設定できます",
        "bidPriceMin": "{{type}} 最低配送金額",
        "enableOptimizedPrice": "スマート入札モードを許可する",
        "revenueSharing": "ダイナミック入札課金モデルを使用できる",
        "budgetDominate": "日次予算配分を使用できますか?",
        "roadblock": "ロードブロッキング課金モデルが利用可能",
        "videoAdViewObjective": "動画広告視聴目標",
        "thirdparty_tracking": "サードパーティの追跡",
        "retargeting_tracker": "リマーケティングトラッキング",
        "ignoreVideoAdViewConstraint": "視聴率を無視",
        "fix_cpc": "固定クリック単価課金モデルが利用可能",
        "fix_cpm": "固定CPM課金モデルが利用可能",
        "fix_cpv": "固定CPV課金モデルを使用できる",
        "fix_vcpm": "固定vCPM課金モデルが利用可能",
        "fix_acpm": "固定aCPM課金モデルが使用可能",
        "fix_wcpm": "固定wCPM課金モデルを使用できる",
        "bidPriceConstraint": "配送量制限",
        "dynamic_cpm": "ダイナミックCPM課金モデルを使用できる",
        "frequencyCapping": "周波数制御可能"
      },
      "creative-studio": {
        "creative-studio": "マテリアルテンプレートライブラリ"
      },
      "product": { "index": "製品ライブラリ" },
      "conversiontracking": { "TrackingList": "コンバージョントラッキング" },
      "report": {
        "viewableCtr": "視覚的露出計算の使用",
        "campaign_dashboard": "キャンペーンダッシュボード",
        "booking_calendar": "ネイティブ広告の配信期間設定",
        "yahooAd": "Verizonレポート統合",
        "closingReport": "事件終結報告書",
        "restrictFinalReport": "制限付きケースクローズレポート",
        "campaignDashboard": "キャンペーンダッシュボード",
        "bookingCalendar": "広告配信期間",
        "orderCustom": "カスタマイズされた注文レポート",
        "cantDownloadOutdoorFinalReport": "Outdoor 決算報告書",
        "deliveryBriefReport": "配信データ簡易レポート"
      },
      "monitor": {
        "campaignUnderBidFloor": "入札最低額を下回るキャンペーンを監視する",
        "campaignBehindProgress": "キャンペーンの異常な進捗状況を監視する"
      },
      "creativeLimitation": {
        "country": "国家",
        "spaceType": "配置タイプ",
        "device": "デバイスタイプ",
        "target_audience": "リターゲティング",
        "habits": "消費習慣",
        "adexchange": "広告取引プラットフォーム",
        "asiamax_space": "版位",
        "domain": "ドメイン",
        "space_category": "ウェブサイトのカテゴリ",
        "tenmax_audience": "TenMaxのオーディエンス",
        "city": "市",
        "gender": "性別",
        "age": "年",
        "carrier": "通信事業者",
        "enablePMPDeal": "指定取引",
        "keyword": "キーワード",
        "unicornkeywords": "ユニコーンキーワード",
        "content_language": "ウェブページの言語",
        "content_category": "記事のカテゴリ"
      },
      "campaignLimitation": {
        "country": "国家",
        "spaceType": "配置タイプ",
        "device": "デバイスタイプ",
        "target_audience": "リターゲティング",
        "habits": "消費習慣",
        "adexchange": "広告取引プラットフォーム",
        "asiamax_space": "版位",
        "domain": "ドメイン",
        "space_category": "ウェブサイトのカテゴリ",
        "tenmax_audience": "TenMaxのオーディエンス",
        "city": "市",
        "gender": "性別",
        "age": "年",
        "carrier": "通信事業者",
        "enablePMPDeal": "指定取引",
        "testMode": "テストモード",
        "keyword": "キーワード",
        "unicornkeywords": "ユニコーンキーワード",
        "content_language": "ウェブページの言語",
        "content_category": "記事のカテゴリ",
        "storeNum": "店舗情報",
        "cityGroup": "地理区分",
        "administrativeArea": "行政区",
        "outdoorPlaceCategories": "エリア特性",
        "deviceCharacteristic": "端末情報",
        "systemRecommendOutdoorDevice": "システム推奨セット"
      }
    },
    "placeholders": {
      "addon": "{child}}を設定する前に、対応する{{parent}}を有効にしてください。"
    },
    "currentRate": "現在のメディアボーナス比率",
    "effectDate": "将来のボーナス発効日",
    "futureRate": "将来のメディアボーナス比率",
    "rebateRate": "報酬設定",
    "gogan": {
      "targetBudgetMinimum": "キャンペーンの1日あたりの最低予算",
      "addonItem": {
        "campaignLimitation": {
          "target_audience": "カスタマイズされたオーディエンス"
        }
      },
      "addonGroup": { "campaignLimitation": "RTBキャンペーンターゲティング" }
    },
    "labels": {
      "role_agency_admin": "広告代理店│管理者（Admin）-代理店アカウントの権限管理/広告の管理・審査",
      "role_agency_operator": "広告代理店│広告運用担当者(AD Operator)-広告キャンペーンの作成・運営・クライアントへの成果レポートを提供",
      "role_agency_manager": "広告代理店│アカウントマネージャー(AM Manager)-代理店内の広告の管理・審査",
      "role_agency_sales": "広告代理店│広告営業マネージャー（AE Manager）ー-代理店が担当する全広告案件の閲覧",
      "role_agency_report": "広告代理店│レポート閲覧担当者ー-注文詳細と成果レポートの閲覧"
    }
  },
  "geography": {
    "country": {
      "vnm": "ベトナム",
      "twn": "台湾",
      "usa": "アメリカ合衆国",
      "tha": "タイ",
      "can": "カナダ",
      "sgp": "シンガポール",
      "mys": "マレーシア",
      "hkg": "香港",
      "kor": "韓国",
      "jpn": "日本",
      "idn": "インドネシア",
      "chn": "中国",
      "phl": "フィリピン"
    },
    "region": {
      "twn": {
        "changhua": "彰化",
        "chiayi": "いいえ",
        "chiayi_county": "嘉義県",
        "hsinchu": "新竹",
        "hsinchu_county": "新竹県",
        "hualien": "花蓮",
        "kaohsiung": "高雄",
        "keelung": "基隆",
        "miaoli": "苗栗県",
        "nantou": "南投",
        "new_taipei": "新北",
        "penghu": "澎湖",
        "pingtung": "屏東",
        "taichung_city": "台中市",
        "tainan": "私は思う",
        "taipei_city": "台北市",
        "taitung": "台東",
        "taoyuan": "桃園",
        "yilan": "蛇",
        "yunlin_county": "雲林県"
      },
      "vnm": {
        "an_giang": "アンザン",
        "dak_nong": "水",
        "gia_lai": "ジアライ",
        "hau_giang": "ハウザン",
        "ho_chi_minh_city": "ホーチミン市",
        "kon_tum": "コントゥム",
        "long_an": "ロンアン",
        "thanh_pho_can_tho": "カントー市",
        "thanh_pho_gja_nang": "ジャナン市",
        "thanh_pho_ha_noi": "ハノイ市",
        "thanh_pho_hai_phong": "ハイフォン市",
        "tinh_ba_ria-vung_tau": "バリア・ブンタウ省",
        "tinh_bac_giang": "バクザン省",
        "tinh_bac_kan": "バクカン省",
        "tinh_bac_lieu": "バクリウ省",
        "tinh_bac_ninh": "バクニン省",
        "tinh_ben_tre": "ベンチェ省",
        "tinh_binh_duong": "ビンズオン省",
        "tinh_binh_gjinh": "Gジンエリート",
        "tinh_binh_phuoc": "ビンフオック省",
        "tinh_binh_thuan": "ビントゥアン省",
        "tinh_ca_mau": "カマウ省",
        "tinh_cao_bang": "カオバン省",
        "tinh_dien_bien": "ディエンビエン省",
        "tinh_gjak_lak": "ジャクラク省",
        "tinh_gjong_nai": "チョンナイ省",
        "tinh_gjong_thap": "ジョンタップ省",
        "tinh_ha_giang": "ハザン省",
        "tinh_ha_nam": "ハナム省",
        "tinh_ha_tinh": "ハティン省",
        "tinh_hai_duong": "ハイズオン省",
        "tinh_hoa_binh": "エリート兵士",
        "tinh_hung_yen": "フンイエン省",
        "tinh_khanh_hoa": "カインホア省",
        "tinh_kien_giang": "キエンザン省",
        "tinh_lai_chau": "ライチャウ省",
        "tinh_lam_gjong": "ティン・ラム・ジョン",
        "tinh_lang_son": "ティン・ラン・ソン",
        "tinh_lao_cai": "ラオカイ省",
        "tinh_nam_gjinh": "南部ジン省",
        "tinh_nghe_an": "ゲアン省",
        "tinh_ninh_binh": "ニンビン省",
        "tinh_ninh_thuan": "ニントゥアン省",
        "tinh_phu_tho": "フート省",
        "tinh_phu_yen": "フーイエン省",
        "tinh_quang_binh": "クアンビン省",
        "tinh_quang_nam": "クアンナム省",
        "tinh_quang_ngai": "ティン・クアン・ガイ",
        "tinh_quang_ninh": "クアンニン省",
        "tinh_quang_tri": "クアンチ省",
        "tinh_soc_trang": "ソクチャン省",
        "tinh_son_la": "ソンラ省",
        "tinh_tay_ninh": "タイニン省",
        "tinh_thai_binh": "タイビン省",
        "tinh_thai_nguyen": "タイグエン省",
        "tinh_thanh_hoa": "タンホアエッセンス",
        "tinh_thua_thien-hue": "トゥアティエン・フエ省",
        "tinh_tien_giang": "ティエンザン省",
        "tinh_tra_vinh": "チャヴィン省",
        "tinh_tuyen_quang": "ティン・トゥエン・クアン",
        "tinh_vinh_long": "ヴィンロン省",
        "tinh_vinh_phuc": "ヴィンフック省",
        "tinh_yen_bai": "イエンバイ省",
        "thanh_pho_da_nang": "ダナン市"
      },
      "mys": {
        "johor": "ジョホール",
        "kedah": "ケダ州",
        "kelantan": "ケランタン",
        "kuala_lumpur": "クアラルンプール",
        "labuan": "ラブアン",
        "melaka": "マラッカ",
        "negeri_sembilan": "ネグリ・スンビラン州",
        "pahang": "パハン州",
        "penang": "ペナン",
        "perak": "銀",
        "perlis": "ペルリス",
        "putrajaya": "プトラジャヤ",
        "sabah": "サバ州",
        "sarawak": "サラワク",
        "selangor": "セランゴール",
        "terengganu": "トレンガヌ州"
      },
      "jpn": {
        "aichi": "愛知",
        "akita": "秋田",
        "aomori": "Aomori",
        "chiba": "千葉",
        "ehime": "愛媛",
        "fukui": "福井",
        "fukuoka": "Fukuoka",
        "fukushima-ken": "Fukushima-ken",
        "gifu": "肝臓",
        "gunma": "群馬",
        "hiroshima": "広島",
        "hokkaido": "Hokkaido",
        "hyōgo": "兵庫県",
        "ibaraki": "茨城",
        "ishikawa": "石川",
        "iwate": "岩手",
        "kagawa": "香川",
        "kagoshima": "Kagoshima",
        "kanagawa": "神奈川",
        "kochi": "高知",
        "kumamoto": "熊本",
        "kyoto": "京都",
        "mie": "私の",
        "miyagi": "Miyagi",
        "miyazaki": "宮崎",
        "nagano": "長野",
        "nagasaki": "長崎",
        "nara": "奈良",
        "niigata": "新潟",
        "oita": "そしてそれをやる",
        "okayama": "Okayama",
        "okinawa": "沖縄",
        "Ōsaka": "大阪",
        "saga": "佐賀",
        "saitama": "埼玉",
        "shiga": "入力",
        "shimane": "島根",
        "shizuoka": "静岡",
        "tochigi": "Tochigi",
        "tokushima": "徳島",
        "tokyo": "東京",
        "tottori": "Tottori",
        "toyama": "富山",
        "wakayama": "和歌山",
        "yamagata": "山形",
        "yamaguchi": "山口",
        "yamanashi": "山梨"
      },
      "armm": "ARMM",
      "bicol": "ビコール",
      "cagayan_valley": "カガヤンバレー",
      "calabarzon": "カラバルゾン",
      "caraga": "見て",
      "central_luzon": "中部ルソン",
      "central_visayas": "中央ビサヤ地方",
      "cordillera": "コルディレラ",
      "davao": "ダバオ",
      "eastern_visayas": "東ビサヤ",
      "ilocos": "イロコス",
      "mimaropa": "ミマロパ",
      "national_capital_region": "首都圏",
      "northern_mindanao": "北ミンダナオ",
      "province_of_negros_occidental": "ネグロス・オクシデンタル州",
      "province_of_negros_oriental": "東ネグロス州",
      "soccsksargen": "ソックサーゲン",
      "western_visayas": "西ビサヤ",
      "zamboanga_peninsula": "サンボアンガ半島",
      "idn": {
        "aceh": {
          "banda_aceh": "バンダ・アチェ",
          "bireun": "ビルエン",
          "langsa": "ランサ",
          "lhokseumawe": "ロクスマウェ",
          "pasir": "砂",
          "pondok": "コテージ",
          "sigli": "シグリ",
          "tanjung_balai": "タンジュン・バライ"
        },
        "bali": {
          "badung": "バドゥン",
          "bangli": "バンリ",
          "banjar_asem": "バンジャル・アセム",
          "candi_dasa": "チャンディ・ダサ",
          "canggu": "チャングー",
          "denpasar": "デンパサール",
          "gianyar": "ギャニャール",
          "karangasem": "カランガセム",
          "kartika": "カルティカ",
          "kecamatan_buleleng": "ブレレン地区",
          "kedunganan": "コンテンツ",
          "kerobokan": "クロボカン",
          "klungkung": "クルンクン",
          "padang": "パダン",
          "padangsambian": "パダンサンビアン",
          "sanur": "サヌール",
          "seminyak_town": "スミニャックの町",
          "singaraja": "シンガラジャ",
          "tabanan": "タバナン",
          "ubud": "ウブド"
        },
        "bangka–belitung_islands": {
          "kotawaringin": "コタワリンギン",
          "pangkalpinang": "パンカルピナン"
        },
        "banten": {
          "baratjaya": "西ジャヤ",
          "cakung": "チャクン",
          "cibubur": "チブブール",
          "cilegon": "チレゴン",
          "cipare": "参加",
          "kramatwatu": "クラマトワトゥ",
          "pandeglang": "パンデグラン",
          "pasir": "砂",
          "rangkasbitung": "ランカスビトゥン",
          "serang": "攻撃",
          "tangerang": "タンゲラン"
        },
        "bengkulu": { "bengkulu": "ベンクル" },
        "central_java": {
          "adiwarno": "アディワルノ",
          "asinan": "アジア人",
          "badran": "バドラン",
          "bandung": "バンドン",
          "bandungrejo": "バンドングレホ",
          "bangkok": "バンコク",
          "bangkong": "蛙",
          "banguntapan": "バンガンタパン",
          "banjarnegara": "バンジャルネガラ",
          "bantarwuni": "バンタルウニ",
          "banyuasin": "バンユアシン",
          "banyumas": "バニュマス",
          "banyuurip": "バニュリップ",
          "baru": "新しい",
          "beji": "ベジ",
          "bintaro": "ビンタロ",
          "blora": "ブロラ",
          "blorong": "廊下",
          "bojongsalaman": "ボジョンサラマン",
          "boyolali": "ボヨラリ",
          "brebes": "ブレベス",
          "bringin": "持ち込む",
          "bulupayung": "傘の羽根",
          "buniayu": "ブニアユ",
          "cilacap": "チラチャプ",
          "comal": "コマル",
          "demak": "それで",
          "donoharjo": "Donoharjo",
          "duren": "最後まで",
          "gajahan": "象",
          "grobogan": "グロボガン",
          "grogol": "グロゴル",
          "jati": "チーク材",
          "jepara": "ジェパラ",
          "kalimantan": "カリマンタン",
          "karanganyar": "カランガニャール",
          "kartasura": "カルタスラ",
          "kebon": "庭",
          "kebumen": "ケブメン",
          "kendal": "ケンダル",
          "klaten": "クラテン",
          "kudus": "聖なる",
          "kuta": "壁",
          "lebak": "レバック",
          "magelang": "マゲラン",
          "malang": "貧しい",
          "manggung": "パフォーマンス",
          "menteng": "メンテン",
          "mungkid": "マンキッド",
          "pati": "また",
          "pekalongan": "ペカロンガン",
          "pemalang": "ペマラン",
          "plalangan": "植物",
          "purbalingga": "プルバリンガ",
          "purwodadi_grobogan": "プルウォダディ・グロボガン",
          "purwokerto": "プルウォケルト",
          "purworejo": "プルウォレジョ",
          "salatiga": "サラティガ",
          "sawahbesar": "サワ・ベサール",
          "sedayu": "セダユ",
          "semarang": "スマラン",
          "slawi": "スラヴィ",
          "sragen": "スラゲン",
          "sukoharjo": "スコハルジョ",
          "surakarta": "スラカルタ",
          "tegal": "テガル",
          "tlogosari": "トロゴサリ",
          "umbulharjo": "ウンブルハルジョ",
          "ungaran": "ウンガラン",
          "weleri": "ウェレリ",
          "wonogiri": "ウォノギリ",
          "wonosobo": "ウォノソボ"
        },
        "central_kalimantan": {
          "lampeong": "ランペオン",
          "palangkaraya": "パランカラヤ",
          "sampit": "サンピット"
        },
        "central_sulawesi": {
          "palu": "ハンマー",
          "pengawu": "ガーディアン",
          "tolitoli": "トリトリ"
        },
        "east_java": {
          "alassumur": "アラスムール",
          "andongrejo": "アンドングレホ",
          "ardirejo": "アルディレホ",
          "argosari": "アルゴサリ",
          "babat": "くだらない話",
          "bacem": "バセム",
          "badal": "バダル",
          "bajang": "バジャン",
          "bajulan": "バズラン",
          "bakalan": "未来",
          "baleturi": "バレエ",
          "balongdowo": "バロンドウォ",
          "balung": "骨",
          "bandulan": "振り子",
          "bandung_barat": "西バンドン",
          "bangil": "バンギル",
          "bangkal": "バンカル",
          "bangkalan": "バンカラン",
          "banjarejo": "バンジャレホ",
          "banjarsari": "バンジャルサリ",
          "banyuwangi": "バニュワンギ",
          "baratan": "彼らは学んだ",
          "bataan": "バターン",
          "batokan": "抵抗する",
          "batu": "ロック",
          "bayeman": "ベイマン",
          "bebekan": "アヒル",
          "bedah": "手術",
          "bendo": "テープ",
          "beton": "コンクリート",
          "blimbing": "スターフルーツ",
          "blitar": "ブリタール",
          "bojonegoro": "ボジョネゴロ",
          "bondowoso": "ボンドウォソ",
          "bulukerto": "ブルケルト",
          "dukuh_kupang": "クパン村",
          "genteng": "屋根瓦",
          "glenmore": "グレンモア",
          "gresik": "グレシック",
          "gubeng": "グベン",
          "indragiri": "インドラギリ",
          "jatirejo": "ジャティレホ",
          "jember": "ジェンベル",
          "jombang": "ジョンバン",
          "kademangan": "カデマンガン",
          "kanigaran": "カニガラン",
          "karang": "コーラル",
          "kauman": "カウマン",
          "kebonsari": "ケボンサリ",
          "kebonsari_kulon": "西ケボンサリ",
          "kediri": "ケディリ",
          "kembangbilo": "ケンバンビロ",
          "ketanon": "ハンセン病",
          "ketintang": "ケティンタン",
          "kutai": "クタイ",
          "lamongan": "ラモンガン",
          "lawang": "メース",
          "legian": "レギャン",
          "lumajang": "ルマジャン",
          "madiun": "マディウン",
          "magetan": "マゲタン",
          "malang": "貧しい",
          "medokan": "メドカン",
          "mojo": "モジョ",
          "mojokerto": "モジョケルト",
          "nganjuk": "ンガンジュク",
          "ngronggot": "根こそぎにされた",
          "nyamplungan": "ニャンプルンガン",
          "pacitan": "パチタン",
          "pare": "思われる",
          "pasuruan": "パスルアン",
          "polerejo": "ポリッシャー",
          "ponorogo": "ポノロゴ",
          "probolinggo": "プロボリンゴ",
          "puri": "プリ",
          "rungkut_kidul": "ルングクット南",
          "sanur": "サヌール",
          "selatan": "南",
          "senori": "シニア",
          "sidoarjo": "シドアルジョ",
          "sidomoro": "特に",
          "situbondo": "シトゥボンド",
          "sumenep": "スメネプ",
          "surabaya": "スラバヤ",
          "tebas": "テーベ",
          "trenggalek": "トレングレック",
          "tuban": "トゥバン",
          "tulungagung": "トゥルンガグン",
          "tulungrejo": "トゥルングレホ",
          "utara": "北",
          "waru": "八",
          "wates": "制限",
          "yosowilangun": "ヨソウィラングン"
        },
        "east_kalimantan": {
          "balikpapan": "バリクパパン",
          "bontang": "ボンタン",
          "nunukan": "ヌヌカン",
          "samarinda": "サマリンダ"
        },
        "east_nusa_tenggara": {
          "ende": "終わり",
          "fontein": "噴水",
          "kota": "市",
          "kupang": "クパン",
          "maumere": "マウメレ",
          "naikolan": "わかった"
        },
        "gorontalo": { "damai": "平和", "gorontalo": "ゴロンタロ" },
        "jakarta": {
          "batuampar": "バトゥアンパール",
          "bendungan_hilir": "下流ダム",
          "bintaro": "ビンタロ",
          "cawang": "カワン",
          "cempaka_baru": "新しいチェンパカ",
          "cengkareng": "チェンカレン",
          "ciganjur": "チガンジュール",
          "cilandak": "チランダック",
          "cipayung": "チパユン",
          "cipete": "シペテ",
          "cipinang": "チピナン",
          "ciracas": "シラカス",
          "gambir": "ガンビエ",
          "grogol": "グロゴル",
          "gunung": "山",
          "jagakarsa": "ジャガカルサ",
          "jakarta": "ジャカルタ",
          "jelambar": "ジェランバー",
          "joglo": "ジョグロ",
          "karet": "ゴム",
          "kebayoran_baru": "ケバヨラン・バル",
          "kebayoran_lama_selatan": "南ケバヨラン・ラマ",
          "kebon_baru": "新しい庭",
          "kedoya_selatan": "南ケドヤ",
          "kemanggisan": "マンゴスチン",
          "kramat": "神聖",
          "kuningan_barat": "西クニンガン",
          "kwitang": "クウィタン",
          "malaka": "マラッカ",
          "pademangan_barat": "西パデマンガン",
          "pasar_baru": "ニューマーケット",
          "pegadungan": "ペガドゥンガン",
          "pegangsaan_dua": "ペガンサーン2",
          "penggilingan": "フライス加工",
          "penjaringan": "スクリーニング",
          "petukangan_selatan": "南ペトゥカンガン",
          "petukangan_utara": "北ペトゥカンガン",
          "pisangan_lama": "老夫婦",
          "rorotan": "ロロタン",
          "serdang": "セルダン",
          "setiabudi": "セティアブディ",
          "sukabumi_selatan": "南スカブミ",
          "tambun_selatan": "南タンブン"
        },
        "jambi": { "bangko": "銀行", "jambi_city": "ジャンビ市" },
        "lampung": {
          "natar": "ナタール",
          "ogan": "オガン",
          "pringsewu": "プリンセウ",
          "teluk_betung": "ベトゥン湾"
        },
        "maluku": {
          "ambon_city": "アンボン市",
          "ternate": "テルナテ島",
          "timoer": "ティモール"
        },
        "north_kalimantan": { "lingkas": "まとめ", "tarakan": "タラカン" },
        "north_maluku": { "ternate": "テルナテ島" },
        "north_sulawesi": {
          "bitung": "ビトゥン",
          "lolak": "ロラク",
          "manado": "マナド",
          "tomohon": "トモホン",
          "tondano": "トンダノ"
        },
        "north_sumatra": {
          "adiantorop": "アディアントロップ",
          "amplas": "広い",
          "asahan": "期待してください",
          "bali": "バリ島",
          "balige": "バリゲ",
          "bandar": "市",
          "binjai": "ビンジャイ",
          "bukit_tinggi": "ハイヒル",
          "gunungsitoli": "グヌンシトリ",
          "helvetia": "ヘルベティア",
          "kabanjahe": "カバンジャヘ",
          "kampung_dalam": "インナービレッジ",
          "kisaran": "範囲",
          "lubuk_pakam": "ルブク・パカム",
          "mabar": "一緒に遊ぶ",
          "medan": "その間",
          "nangka": "ジャックフルーツ",
          "padang_bulan": "月の野原",
          "pancuran": "シャワー",
          "pasar_baru": "ニューマーケット",
          "pematangsiantar": "ペマタンシアンタル",
          "sepinggan": "皿",
          "serdang": "セルダン",
          "sibolga": "シボルガ",
          "simalungun": "シマルングン",
          "stabat": "彼は立っていた",
          "sunggal": "スンガル",
          "tanah_enam_ratus": "六百の土地",
          "tanjung_gusta": "グスタ岬",
          "tebingtinggi": "テビン・ティンギ",
          "titi_papan": "ティティ・パパン"
        },
        "papua": {
          "jayapura": "ジャヤプラ",
          "merauke": "メラウケ",
          "serui": "セルイ",
          "tembagapura": "テンバガプラ",
          "timika": "ティミカ",
          "wamena": "ワメナ"
        },
        "riau": {
          "bengkalis": "ベンカリス",
          "dumai": "ドゥマイ",
          "karanganunggi": "カランガヌンギ",
          "pekanbaru": "ペカンバル",
          "siak_sri_indrapura": "シアク・スリ・インドラプラ",
          "tangkerang": "貝"
        },
        "riau_islands": {
          "batam": "バタム",
          "sekupang": "セクパン",
          "tanjung_balai": "タンジュン・バライ",
          "tanjungpinang": "タンジュンピナン",
          "tengah": "真ん中"
        },
        "south_kalimantan": {
          "alabio": "アラビオ",
          "amuntai": "アムンタイ",
          "banjarbaru": "バンジャルバル",
          "banjarmasin": "バンジャルマシン",
          "belandean": "オランダ",
          "kotabaru_hilir": "下コタバル",
          "martapura": "マルタプラ",
          "sungkai": "ソンカイ"
        },
        "south_sulawesi": {
          "ballaparang": "バラパラン",
          "baranti": "保証",
          "batang": "男の子",
          "bombong": "ボンボン",
          "daya": "1つ",
          "duri": "ドゥリ",
          "jaya": "ジャヤ",
          "jempang": "ジェムパン",
          "karampuang": "カランプアン",
          "makale": "記事",
          "makassar": "マカッサル",
          "malili": "いいね",
          "maros": "モロス",
          "masamba": "ページ",
          "melayu": "マレー語",
          "palangka": "パランカ",
          "palopo": "パロポ",
          "parepare": "パレパレ",
          "salupontu": "サルポント",
          "sidenreng": "シデンレング",
          "sinjai": "シンジャイ",
          "solo": "一人で"
        },
        "south_sumatra": {
          "baturaja": "バトゥラジャ",
          "lubuklinggau": "ルブクリンガウ",
          "palembang": "パレンバン"
        },
        "southeast_sulawesi": {
          "kendari": "ケンダリ",
          "kolaka": "コラカ",
          "muara": "河口",
          "poanaha": "木曜日"
        },
        "west_java": {
          "andir": "アンディル",
          "antapani": "アンタパニ",
          "babakan": "章",
          "babakan_ciparay": "ババカン・チパライ",
          "babakan_sari": "ババカン・サリ",
          "balaraja": "バララジャ",
          "bandung": "バンドン",
          "banjar": "バンジャル",
          "barengkok": "腰をかがめる",
          "bekasi": "ブカシ",
          "bogor": "ボゴール",
          "bojong": "ボジョン",
          "bungursari": "ブングルサリ",
          "cempaka": "チェンパカ",
          "ciamis": "シアミス",
          "cianjur": "チアンジュール",
          "ciapus": "シアプス",
          "ciateul": "シアテウル",
          "cibabat": "チババット",
          "cibadung": "チバドゥン",
          "cibinong": "チビノン",
          "cibiru": "シビル",
          "cigadung": "チガドゥン",
          "cikampek": "チカンペック",
          "cikarang": "チカラン",
          "cikiwul": "チクウル",
          "cilegon": "チレゴン",
          "cileungsir": "チレウンシル",
          "cimahi": "チマヒ",
          "cindogo": "Cindogo",
          "cinere": "シネレ",
          "cipageran": "チパゲラン",
          "cipondoh": "シポンド",
          "ciporeat": "シポレート",
          "ciputat": "シプタット",
          "cirangrang": "元気づける",
          "cirebon": "チルボン",
          "cisaranten_kulon": "チサランテン・ウェスト",
          "cisarua": "チサルア",
          "ciseureuh": "ピーク",
          "citeureup": "シテュールアップ",
          "depok": "デポック",
          "garut": "ガルト",
          "hegarmanah": "ヘガルマナ",
          "indramayu": "インドラマユ",
          "jatiasih": "ジャティアシ",
          "jatibening": "ジャティベニング",
          "karangtawang": "ドゥアール",
          "karawang": "カラワン",
          "kertasari": "ケルタサリ",
          "kunciran": "ポニーテール",
          "kuningan": "真鍮",
          "majalengka": "マジャレンカ",
          "melong": "見て",
          "ngawi": "ンガウィ",
          "padalarang": "パダララン",
          "padasuka": "みんなが好き",
          "pajajaran": "イベント",
          "pakulonan_barat": "西パクロン",
          "pamanukan": "パマヌカン",
          "pamulang": "パムラン",
          "pamulang_barat": "西パムラン",
          "purwakarta": "プルワカルタ",
          "rahayu": "グレース",
          "sawangan": "サワンガン",
          "sentul": "感じる",
          "serang": "攻撃",
          "serpong": "セルポン",
          "sindangrasa": "シンダングラサ",
          "subang": "イヤリング",
          "sukabumi": "スカブミ",
          "sukamaju": "スカマジュ",
          "sumedang": "スメダン",
          "tangsel": "南タンゲラン",
          "tasikmalaya": "タシクマラヤ",
          "utama": "主要"
        },
        "west_kalimantan": {
          "bengkayang": "詰め物",
          "pontianak": "ポンティアナック",
          "singkawang": "シンカワン",
          "sintang": "シンタン"
        },
        "west_nusa_tenggara": {
          "gunungsari": "グヌンサリ",
          "labuan_lombok": "ラブアン・ロンボク",
          "leneng": "アーム",
          "luk": "弓",
          "mataram": "マタラム",
          "sandubaya": "サンドイッチショップ",
          "selong": "セロン",
          "sumbawa_besar": "グレーター・スンバワ",
          "tanjung": "ケープ"
        },
        "west_papua": { "sorong": "ソロン" },
        "west_sulawesi": {
          "mamuju": "マムジュ",
          "panasuan": "パナスアン",
          "polewali": "ポレワリ"
        },
        "west_sumatra": {
          "batusangkar": "バトゥサンカル",
          "bukittinggi": "ブキティンギ",
          "gadang": "タワー",
          "karang": "コーラル",
          "padang": "パダン",
          "payakumbuh": "パヤクンブ",
          "solok": "ソロク"
        },
        "yogyakarta": {
          "baciro": "バシロ",
          "bantul": "バントゥル",
          "canden": "キャンデン",
          "condong": "傾く",
          "pandeyan": "パンディ",
          "panggung": "ステージ",
          "panjangrejo": "パンジャングレジョ",
          "patehan": "パタン",
          "sleman": "スレマン",
          "yogyakarta": "ジョグジャカルタ"
        }
      }
    }
  },
  "limitation": {
    "inc": "含む",
    "exc": "含まれません",
    "Preferred": "優先配信",
    "NonPreferred": "優先配信しない",
    "other": "他の",
    "labels": {
      "trafficAttribute": "トラフィック属性",
      "total": "合計: {{total}}",
      "warningAddDomain": "入力されたカスタム配置は RMax スペース ID ではない可能性があります",
      "customGeofence": "緯度と経度",
      "customKeyword": "キーワード",
      "contentcat": "記事のカテゴリ",
      "keywordDescription": "語彙",
      "languageDescription": "キーワード検索言語を選択してください",
      "tranditionalChinese": "繁体字中国語",
      "vietnamese": "ベトナム語",
      "latitude": "緯度",
      "longitude": "経度",
      "radius": "半径距離",
      "minDecimalPlacesError": "少なくとも{{count}}桁の小数点以下の精度が必要です",
      "maxDecimalPlacesError": "小数点以下は {{count}} 桁までしかサポートされません。",
      "simulcastMismatch": "同時放送不一致",
      "searchResult": "過去 7 日間でこのキーワードが表示された記事は合計 {{articleCount}} 件あります",
      "updateEveryHour": "※1時間ごとに更新されます※",
      "singleSelectTip": "単一選択のみ",
      "peopleNumberTip": "{{value}}人",
      "country": "国家",
      "geography": "国家",
      "adx": "広告取引プラットフォーム",
      "keyword": "キーワード",
      "unicornkeywords": "キーワード",
      "keyword1": "キーワード - グループ1の用語",
      "keyword2": "キーワード - グループ2の用語",
      "searchKeyword": "検索キーワード",
      "unicornkeyword1": "グループ1の単語",
      "unicornkeyword2": "グループ2の単語",
      "unicornlanguage": "キーワード言語",
      "and": "そして",
      "space": "版位",
      "adspace": "版位",
      "ages": "年",
      "age": "年",
      "os": "オペレーティング·システム",
      "articleCategory": "記事のカテゴリ",
      "tenmaxCategory": "ウェブサイトのカテゴリ",
      "adcat": "ウェブサイトのカテゴリ",
      "carrier": "通信事業者",
      "contentlang": "ウェブページの言語",
      "dealId": "取引IDを指定する",
      "testMode": "テストモード",
      "segment": "リターゲティング",
      "gender": "性別",
      "device": "デバイスタイプ",
      "tenmaxAudience": "TenMaxのオーディエンス",
      "domain": "ドメイン",
      "finishEditing": "編集完了",
      "spaceType": "配置タイプ",
      "outDoorDevice": "カスタマイズマシン",
      "publisher": "パブリッシャー",
      "edit": "条件設定の編集",
      "incHaveValue": "配信量の制限 │以下の配信枠（端末）のみに広告を配信する",
      "incNoValue": "配信量の制限（なし）",
      "excHaveValue": "指定した配信枠を除外 │ 以下の条件では広告が表示されません",
      "excNoValue": "指定した配信枠を除外（なし）",
      "preferHaveValue": "優先配信 │広告を配信したい",
      "preferNoValue": "優先配信（なし）",
      "nonpreferHaveValue": "優先配信しない │ 広告が配送されないように願っています",
      "nonpreferNoValue": "優先配信しない（なし）",
      "instl": "許容カバーフロー",
      "adFormat": "広告フォーマット",
      "agencySegment": "{{name}} のオーディエンスパック",
      "consumer_profile": "消費者プロフィール",
      "bill_payment_audience": "請求書の支払い受取人",
      "consumer_profile-age": "消費者プロフィール - 年齢",
      "consumer_profile-gender": "消費者プロフィール - 性別",
      "location_audience": "場所 対象者",
      "offline_store_consumption": "オフラインのコンビニ消費が人気",
      "offline_store_active_users": "オフラインコンビニエンスストアのアクティブユーザー",
      "purchase_power_audience": "消費者層",
      "preorder_products": "予約注文商品",
      "gaming_audience": "ゲーム観客",
      "others": "他の",
      "custom_segment": "カスタマイズされたオーディエンス",
      "gender_male": "性別 (男)",
      "gender_female": "性別（女性）",
      "age_1": "年齢 (0～17)",
      "age_2": "年齢（18～24歳）",
      "age_3": "年齢（25～34歳）",
      "age_4": "年齢 (35～44歳)",
      "age_5": "年齢 (45～54歳)",
      "age_6": "年齢（55～64歳）",
      "age_7": "年齢（65歳以上）",
      "work_area": "職場の聴衆",
      "home_area": "居住地オーディエンス",
      "hospital_area": "病院エリア",
      "school_area": "学校エリア",
      "business_area": "商業エリア",
      "tech_area": "サイエンスパーク",
      "travel_area": "観光名所",
      "low_spend": "購買力が低い",
      "mid_spend": "中所得層の消費者",
      "high_spend": "高い購買力",
      "high_activity": "高い活動",
      "low_activity": "活動が低い",
      "discount": "割引イベント参加",
      "health_food": "健康製品のオーディエンス",
      "forzen_food": "冷凍食品の視聴者",
      "snack": "スナック",
      "makeup": "美しさ",
      "goods": "家庭生活",
      "coffee": "コーヒー愛好家",
      "alcohol": "スピリッツオーディエンス",
      "beer": "ビール愛好家",
      "drinks": "飲料オーディエンス",
      "fried_food": "揚げ物",
      "instant_noodles": "インスタントラーメン",
      "fresh_food": "生鮮食品",
      "oral_care": "オーラル製品",
      "facial_care": "フェイシャルケア",
      "threeC": "3C製品",
      "gaming": "ゲームリチャージ",
      "parking": "駐車料金",
      "bill": "水道、電気、ガスなどの料金",
      "donation": "寄付先",
      "i_threeC": "家電製品3C",
      "i_fancy_food": "高級料理",
      "i_makeup": "美容製品",
      "i_health_food": "健康食品",
      "customOutdoorDevice": "カスタマイズマシン",
      "systemRecommendOutdoorDevice": "システム推奨セット",
      "geofence": "重要なMRT駅",
      "simulcastGroup": "同時放送ポジション",
      "storeNum": "店舗情報",
      "expandAllStores": "すべて展開",
      "collapseAllStores": "すべて折りたたむ",
      "unknownMunicipality": "不明な都市",
      "weatherCode": "天気現象",
      "temperature": "気温制限",
      "probabilityOfPrecipitation": "降水確率",
      "uvIndex": "紫外線指数",
      "relativeHumidity": "相対湿度",
      "options": {
        "uvIndex": {
          "low": "低レベル",
          "moderate": "中レベル",
          "high": "高レベル",
          "veryHigh": "非常に高いレベル",
          "extreme": "極端なレベル"
        },
        "weatherCode": {
          "sunny": "晴れ",
          "cloudy": "曇り",
          "rainy": "雨",
          "snowy": "雪"
        }
      },
      "settingSearchResult": "広告は、{{name}} を含む <2>{{result}}</2> 件の記事内に表示できます。",
      "adxCanNotNull": "少なくとも1つのプラットフォームを選択してください",
      "geograthyCanNotNull": "少なくとも1つの国を選択してください",
      "general": "一般的に",
      "searchKeywordsTitle": "検索キーワード",
      "searchKeywords": "キーワード",
      "searchKeywordsDes": "ロックしたいキーワードを入力してください",
      "placement": "広告の配置",
      "relatedKeywordsTitle": "関連キーワード",
      "audienceDefinition": "オーディエンス定義",
      "cityGroup": "地理区分",
      "administrativeArea": "行政区",
      "outdoorPlaceCategories": "エリア特性",
      "deviceCharacteristic": "端末情報",
      "interests": "興味"
    },
    "titles": { "outdoorDeviceProperty": "機械特性" },
    "addSpace": "カスタムレイアウト",
    "addSpaceTip": "プレースメントIDと名前を区切るには「,」を使用してください。他のプレースメントを入力するにはEnterキーを押してください。",
    "placeholders": {
      "addSpace": "例: スロットID、スロット名\nff73b7afb2804c15、スロット名 1\nfeda87ba37f94366\nfe7c4bea7b39473c、スロット名 2",
      "addDomain": "tenmax.io\ngoogle.com",
      "addOutdoorDevice": "例: スロット名\n台北市_XXXXX1_XX門市_門口第1台\n台北市_XXXXX1_XX門市_門口第2台\n台北市_XXXXX1_XX門市_門口第3台",
      "addOutdoorStore": "例: 店舗名\n台北市_XXXXX1_XX門市\n台北市_XXXXX2_XX門市\n台北市_XXXXX3_XX門市",
      "addPublisher": "例: パブリッシャーID、パブリッシャー名\nff73b7afb2804c15、パブリッシャー名1\nfeda87ba37f94366\nfe7c4bea7b39473c、パブリッシャー名2",
      "categoryTip": "分類を表示するにはプロパティを選択してください",
      "searchSpace": "検索配置…",
      "searchAdx": "検索広告交換プラットフォーム…",
      "searchCountryCity": "国、地域、都市で検索...",
      "searchCountryProvince": "国、地域、都道府県で検索...",
      "searchCarrier": "通信事業者を検索...",
      "searchContentLang": "ウェブページの言語を検索...",
      "searchContentCat": "記事カテゴリを検索…",
      "searchOs": "オペレーティング システムを検索...",
      "searchAges": "検索年齢範囲…",
      "searchGenders": "性別を検索…",
      "searchDevice": "デバイスタイプを検索…",
      "searchTenmaxSegments": "TenMaxオーディエンスを検索…",
      "searchDomains": "ドメインを検索...",
      "searchAdCat": "ウェブサイトのカテゴリを検索…",
      "searchAgencySegment": "ディーラーオーディエンスを検索…",
      "searchSegment": "検索リマーケティング オーディエンス…",
      "searchGojekSegment": "Gojek の視聴者を検索しています…",
      "searchSpaceType": "配置タイプを検索...",
      "searchAdFormat": "検索広告フォーマット",
      "searchOutdoorDevice": "検索マシン...",
      "searchRecommendOutdoorDevice": "検索システム 推奨マシン ...",
      "searchGeofence": "重要な MRT 駅を検索...",
      "searchKeywords": "キーワードグループを区切るには「,」を使用してください。例：3c, スマートフォン",
      "searchPlacement": "広告掲載場所を検索する"
    },
    "addDomain": "新しい指定ドメインを追加する",
    "addDomainTip": "複数のドメイン アドレスを入力するには Enter キーを押してください。",
    "addOutdoorDevice": "カスタマイズされたマシン",
    "addOutdoorDeviceTip": "Enter キーを押して新しい行を開始した後、複数のマシン名を入力してください。",
    "addOutdoorStore": "カスタマイズされたマシン",
    "addOutdoorStoreTip": "Enter キーを押して新しい行を開始した後、複数のマシン名を入力してください。",
    "addPublisher": "カスタマイズされたパブリッシャー",
    "addPublisherTip": "パブリッシャーIDと名前を区切るには「,」を使用してください。他のパブリッシャーを入力するにはEnterキーを押してください。",
    "addDealId": "特定のトランザクション ID を入力した後、Enter キーを使用して別のトランザクション ID を追加できます...",
    "buttons": {
      "addDomain": "参加する",
      "cancelAddDomain": "キャンセル",
      "search": "検索",
      "clear": "クリア",
      "addDevice": "マシンを追加",
      "removeDevice": "マシンへの参加をキャンセル",
      "addStore": "店舗を追加する",
      "removeStore": "店舗を外す"
    },
    "classificationTotal": "{{total}} 個のオプション",
    "hints": {
      "inc": "制限未指定時、すべての有効な枠に配信されます",
      "ageGroups": "対象年齢: {{groups}}",
      "storeCount": "店鋪数：{{count}}",
      "deviceCount": "機械数：{{count}}",
      "overBindingLimit": "配信上限に達しました"
    },
    "title": {
      "you": {
        "need": "配信方向を制限する",
        "dont": { "need": "配送トラフィックの方向を除外" }
      },
      "other": { "need": "その他の条件" },
      "fixOutdoorLimitationSection": "固定マシンのオプション",
      "weatherSection": "天気ターゲティング",
      "mapSection": "マップモード"
    },
    "hint": {
      "weatherSection": "天気ターゲティングは店舗設定と交差し、広告を配信できる適切な店舗を決定します"
    },
    "allow": { "inst": "許容カバーフロー" },
    "move": { "to": "移動先" },
    "include": "交通量を制限する",
    "exclude": "指定した配信枠を除外",
    "preferred": "優先配信",
    "nonPreferred": "優先配信しない",
    "general": "一般的な目標設定",
    "warning": {
      "sameTypeWarning": "{{type}} に同じトラフィック属性が既に存在します。プロジェクトを上書きしてもよいか確認してください。"
    },
    "genders": { "male": "男性", "female": "女性", "unlimited": "全て" },
    "carries": { "chunghwa": "中華電信", "taiwanMobile": "台湾モバイル" },
    "locations": {
      "xiangshanStation": "象山MRT駅",
      "daanStation": "大安MRT駅",
      "nanjingFuxingStation": "MRT 南京復興駅",
      "songshanStation": "松山MRT駅",
      "yonganMarketStation": "永安市場MRT駅",
      "shilinStation": "士林MRT駅",
      "tamsuiStation": "淡水MRT駅",
      "taipeiNangangExhibitionCenterStation": "南港展覧館MRT駅",
      "taipeiMainStation": "台北MRT駅",
      "wanfangHospitalStation": "万芳病院MRT駅",
      "ximenStation": "西門MRT駅",
      "minquanWestRoadStation": "民権西路MRT駅",
      "luzhouStation": "蘆洲MRT駅",
      "fuJenUniversityStation": "輔大MRT駅",
      "shanbStation": "空港MRT山鼻駅"
    },
    "contentCategory": {
      "iab1": "芸術とエンターテイメント",
      "iab1_1": "書籍と文学",
      "iab1_2": "ファン/ゴシップ",
      "iab1_3": "美術",
      "iab1_4": "ユーモア",
      "iab1_5": "映画",
      "iab1_6": "音楽",
      "iab1_7": "テレビ",
      "iab2": "車",
      "iab2_1": "自動車部品",
      "iab2_2": "自動車整備士",
      "iab2_3": "車の売買",
      "iab2_4": "カーカルチャー",
      "iab2_5": "認定中古車",
      "iab2_6": "コンバーチブル",
      "iab2_7": "スポーツカー",
      "iab2_8": "クロスオーバーSUV",
      "iab2_9": "ディーゼル車",
      "iab2_10": "電気自動車",
      "iab2_11": "ハッチバック",
      "iab2_12": "ハイブリッド",
      "iab2_13": "高級車",
      "iab2_14": "バン",
      "iab2_15": "オートバイ",
      "iab2_16": "オフロード車",
      "iab2_17": "高性能車",
      "iab2_18": "乗用車と貨物車",
      "iab2_19": "ロードサイドアシスタンス",
      "iab2_20": "車",
      "iab2_21": "トラックとアクセサリー",
      "iab2_22": "クラシックカー",
      "iab2_23": "ステーションワゴン",
      "iab3": "仕事",
      "iab3_1": "広告する",
      "iab3_2": "農業",
      "iab3_3": "バイオテクノロジー/バイオメディシン",
      "iab3_4": "商用ソフトウェア",
      "iab3_5": "工事",
      "iab3_6": "林業",
      "iab3_7": "政府",
      "iab3_8": "環境に優しい",
      "iab3_9": "人事",
      "iab3_10": "ロジスティクス",
      "iab3_11": "マーケティング",
      "iab3_12": "金属",
      "iab4": "キャリア",
      "iab4_1": "キャリアプランニング",
      "iab4_2": "カレッジ",
      "iab4_3": "奨学金",
      "iab4_4": "就職フェア",
      "iab4_5": "求人検索",
      "iab4_6": "履歴書作成・コンサルティング",
      "iab4_7": "看護",
      "iab4_8": "奨学金",
      "iab4_9": "リモートワーク",
      "iab4_10": "米軍",
      "iab4_11": "キャリアアドバイス",
      "iab5": "教育・学習",
      "iab5_1": "小学校教育",
      "iab5_2": "成人教育",
      "iab5_3": "美術史",
      "iab5_4": "大学運営",
      "iab5_5": "大学生活",
      "iab5_6": "遠隔学習",
      "iab5_7": "第二言語としての英語",
      "iab5_8": "言語学習",
      "iab5_9": "大学院",
      "iab5_10": "独学",
      "iab5_11": "宿題/勉強のヒント",
      "iab5_12": "幼稚園教育者",
      "iab5_13": "私立学校",
      "iab5_14": "特別支援教育",
      "iab5_15": "ビジネスを学ぶ",
      "iab6": "家族と教育",
      "iab6_1": "採択",
      "iab6_2": "乳幼児",
      "iab6_3": "保育園・幼稚園",
      "iab6_4": "自宅インターネット",
      "iab6_5": "幼稚園児教育",
      "iab6_6": "青少年教育",
      "iab6_7": "妊娠中",
      "iab6_8": "特別なニーズを持つ子どもたち",
      "iab6_9": "高齢者ケア",
      "iab7": "健康とフィットネス",
      "iab7_1": "スポーツ",
      "iab7_2": "追加",
      "iab7_3": "エイズ",
      "iab7_4": "アレルギー",
      "iab7_5": "代替医療",
      "iab7_6": "関節炎",
      "iab7_7": "喘息",
      "iab7_8": "自閉症 / PDD",
      "iab7_9": "躁鬱症",
      "iab7_10": "脳腫瘍",
      "iab7_11": "癌",
      "iab7_12": "コレステロール",
      "iab7_13": "慢性疲労症候群",
      "iab7_14": "慢性的な痛み",
      "iab7_15": "風邪とインフルエンザ",
      "iab7_16": "聴覚障害者",
      "iab7_17": "歯科治療",
      "iab7_18": "うつ",
      "iab7_19": "皮膚科",
      "iab7_20": "糖尿病",
      "iab7_21": "てんかん",
      "iab7_22": "胃食道逆流症（GERD）/胃酸逆流",
      "iab7_23": "頭痛/片頭痛",
      "iab7_24": "心臓病",
      "iab7_25": "漢方健康",
      "iab7_26": "ホリスティック治療",
      "iab7_27": "過敏性腸症候群（IBS）/クローン病",
      "iab7_28": "近親相姦/虐待サポート",
      "iab7_29": "尿失禁",
      "iab7_30": "不妊",
      "iab7_31": "メンズヘルス",
      "iab7_32": "栄養",
      "iab7_33": "整形外科",
      "iab7_34": "パニック障害/不安障害",
      "iab7_35": "小児科",
      "iab7_36": "理学療法",
      "iab7_37": "心理学/精神医学",
      "iab7_38": "高齢者の健康",
      "iab7_39": "性行動",
      "iab7_40": "睡眠障害",
      "iab7_41": "禁煙する",
      "iab7_42": "薬物乱用",
      "iab7_43": "甲状腺疾患",
      "iab7_44": "体重を減らす",
      "iab7_45": "女性の健康",
      "iab8": "食品と飲料",
      "iab8_1": "アメリカ料理",
      "iab8_2": "グリルとバーベキュー",
      "iab8_3": "ケイジャン/クレオール",
      "iab8_4": "中華料理",
      "iab8_5": "カクテル/ビール",
      "iab8_6": "コーヒー/紅茶",
      "iab8_7": "料理",
      "iab8_8": "スイーツ・菓子とベーキング",
      "iab8_9": "外食",
      "iab8_10": "食物アレルギー",
      "iab8_11": "フランス料理",
      "iab8_12": "ヘルシー/低脂肪料理",
      "iab8_13": "イタリア料理",
      "iab8_14": "日本料理",
      "iab8_15": "メキシコ料理",
      "iab8_16": "ベジタリアン食",
      "iab8_17": "ベジタリアン",
      "iab8_18": "ワイン",
      "iab9": "趣味",
      "iab9_1": "アート / テクノロジー",
      "iab9_2": "手工芸品",
      "iab9_3": "手作りジュエリー",
      "iab9_4": "バードウォッチング",
      "iab9_5": "ボードゲーム / パズル",
      "iab9_6": "手作りキャンドルソープ",
      "iab9_7": "カードゲーム",
      "iab9_8": "チェス",
      "iab9_9": "葉巻",
      "iab9_10": "集める",
      "iab9_11": "コミック",
      "iab9_12": "描画/スケッチ",
      "iab9_13": "フリーランスライティング",
      "iab9_14": "系譜",
      "iab9_15": "出版",
      "iab9_16": "ギター",
      "iab9_17": "ライフビデオ録画",
      "iab9_18": "投資/特許",
      "iab9_19": "ジュエリー作り",
      "iab9_20": "魔法/イリュージョン",
      "iab9_21": "刺繍",
      "iab9_22": "絵画",
      "iab9_23": "写真",
      "iab9_24": "無線",
      "iab9_25": "ロールプレイ",
      "iab9_26": "SF",
      "iab9_27": "コラージュ",
      "iab9_28": "脚本家",
      "iab9_29": "切手とコイン",
      "iab9_30": "オーディオ/ビデオ/電気",
      "iab9_31": "大工仕事",
      "iab10": "家と庭",
      "iab10_1": "家電",
      "iab10_2": "エンターテインメント",
      "iab10_3": "環境安全",
      "iab10_4": "園芸",
      "iab10_5": "住宅修理",
      "iab10_6": "ホームシアター",
      "iab10_7": "室内装飾",
      "iab10_8": "造園",
      "iab10_9": "改修と建設",
      "iab11": "法律、政府、政治",
      "iab11_1": "移民",
      "iab11_2": "法的問題",
      "iab11_3": "米国政府のリソース",
      "iab11_4": "政治",
      "iab11_5": "コメント",
      "iab12": "ニュース",
      "iab12_1": "国際ニュース",
      "iab12_2": "国内ニュース",
      "iab12_3": "ローカルニュース",
      "iab13": "個人金融",
      "iab13_1": "初心者向け投資",
      "iab13_2": "クレジット/負債とローン",
      "iab13_3": "金融ニュース",
      "iab13_4": "財務計画",
      "iab13_5": "ヘッジファンド",
      "iab13_6": "保険",
      "iab13_7": "投資する",
      "iab13_8": "投資信託",
      "iab13_9": "選択する権利",
      "iab13_10": "退職計画",
      "iab13_11": "ストック",
      "iab13_12": "税務計画",
      "iab14": "社会",
      "iab14_1": "デート",
      "iab14_2": "離婚サポート",
      "iab14_3": "ゲイライフ",
      "iab14_4": "結婚",
      "iab14_5": "老後の生活",
      "iab14_6": "ティーンエイジャー",
      "iab14_7": "ブライダル・結婚",
      "iab14_8": "国籍",
      "iab15": "科学",
      "iab15_1": "占星術",
      "iab15_2": "生物学",
      "iab15_3": "化学薬品",
      "iab15_4": "地質学",
      "iab15_5": "超常現象",
      "iab15_6": "物理",
      "iab15_7": "宇宙/天文学",
      "iab15_8": "地理",
      "iab15_9": "植物学",
      "iab15_10": "天気",
      "iab16": "ペット",
      "iab16_1": "水族館",
      "iab16_2": "鳥",
      "iab16_3": "猫",
      "iab16_4": "犬",
      "iab16_5": "大型動物",
      "iab16_6": "爬虫類",
      "iab16_7": "獣医",
      "iab17": "体育",
      "iab17_1": "レース",
      "iab17_2": "野球",
      "iab17_3": "自転車",
      "iab17_4": "ボディビルディング",
      "iab17_5": "ボクシング",
      "iab17_6": "カヌー/カヤック",
      "iab17_7": "チアリーディング",
      "iab17_8": "山に登る",
      "iab17_9": "クリケット",
      "iab17_10": "フィギュアスケート",
      "iab17_11": "釣り",
      "iab17_12": "フットボール",
      "iab17_13": "淡水釣り",
      "iab17_14": "狩猟と魚",
      "iab17_15": "ゴルフ",
      "iab17_16": "人種",
      "iab17_17": "馬",
      "iab17_18": "狩猟/射撃",
      "iab17_19": "インラインスケート",
      "iab17_20": "武道",
      "iab17_21": "マウンテンバイク",
      "iab17_22": "NASCARレース",
      "iab17_23": "オリンピック",
      "iab17_24": "漆彈",
      "iab17_25": "オートバイ",
      "iab17_26": "プロバスケットボール",
      "iab17_27": "プロアイスホッケー",
      "iab17_28": "ロデオ",
      "iab17_29": "フットボール",
      "iab17_30": "ランニング/ジョギング",
      "iab17_31": "ヨット",
      "iab17_32": "海釣り",
      "iab17_33": "スキューバダイビング",
      "iab17_34": "スケートボード",
      "iab17_35": "スキー",
      "iab17_36": "スノーボード",
      "iab17_37": "サーフィン",
      "iab17_38": "泳ぐ",
      "iab17_39": "卓球",
      "iab17_40": "テニス",
      "iab17_41": "バレーボール",
      "iab17_42": "歩く",
      "iab17_43": "水上スキー/ウェイクボード",
      "iab17_44": "ワールドサッカー",
      "iab18": "ファッショナブルなスタイル",
      "iab18_1": "美容",
      "iab18_2": "ボディアート",
      "iab18_3": "ファッション",
      "iab18_4": "ジュエリー",
      "iab18_5": "衣類",
      "iab18_6": "アクセサリー",
      "iab19": "テクノロジーとコンピューター",
      "iab19_1": "3Dグラフィックス",
      "iab19_2": "アニメーション",
      "iab19_3": "ウイルス対策ソフトウェア",
      "iab19_4": "C / C++",
      "iab19_5": "カメラとビデオカメラ",
      "iab19_6": "携帯電話",
      "iab19_7": "コンピュータ認定",
      "iab19_8": "インターネット",
      "iab19_9": "コンピュータ周辺機器",
      "iab19_10": "コンピューターレビュー",
      "iab19_11": "データセンター",
      "iab19_12": "データベース",
      "iab19_13": "デスクトップパブリッシング",
      "iab19_14": "コンピューターオーディオとビデオ",
      "iab19_15": "電子メール",
      "iab19_16": "グラフィックソフトウェア",
      "iab19_17": "ホームビデオ/DVD",
      "iab19_18": "インターネット技術",
      "iab19_19": "ジャワ",
      "iab19_20": "JavaScript",
      "iab19_21": "Macテクニカルサポート",
      "iab19_22": "MP3/MIDI",
      "iab19_23": "オンライン会議",
      "iab19_24": "ウェブページの使い方",
      "iab19_25": "インターネットセキュリティ",
      "iab19_26": "PDA / ハンドヘルドコンピュータ",
      "iab19_27": "コンピュータ技術サポート",
      "iab19_28": "ポータブル",
      "iab19_29": "エンターテインメント",
      "iab19_30": "シェアウェア / フリーウェア",
      "iab19_31": "Unix",
      "iab19_32": "ビジュアルベーシック",
      "iab19_33": "ウェブクリップアート",
      "iab19_34": "ウェブデザイン/HTML",
      "iab19_35": "インターネット検索",
      "iab19_36": "ウィンドウズ",
      "iab20": "旅行・トラベル",
      "iab20_1": "アドベンチャーツーリズム",
      "iab20_2": "アフリカ",
      "iab20_3": "航空旅行",
      "iab20_4": "オーストラリアとニュージーランド",
      "iab20_5": "ゲストハウス",
      "iab20_6": "手頃な価格の旅行",
      "iab20_7": "出張",
      "iab20_8": "米国ロケール経由",
      "iab20_9": "キャンプ",
      "iab20_10": "カナダ",
      "iab20_11": "カリブ海",
      "iab20_12": "クルーズ船",
      "iab20_13": "東欧",
      "iab20_14": "ヨーロッパ",
      "iab20_15": "フランス",
      "iab20_16": "ギリシャ",
      "iab20_17": "ハネムーン/休暇の目的地",
      "iab20_18": "ホテル",
      "iab20_19": "イタリア",
      "iab20_20": "日本",
      "iab20_21": "メキシコと中央アメリカ",
      "iab20_22": "国立公園",
      "iab20_23": "南アメリカ",
      "iab20_24": "スパ",
      "iab20_25": "テーマパーク",
      "iab20_26": "親子旅行",
      "iab20_27": "英国",
      "iab21": "不動産",
      "iab21_1": "アパート",
      "iab21_2": "建築家",
      "iab21_3": "アパートの売買",
      "iab22": "買い物",
      "iab22_1": "コンテストとプレゼント",
      "iab22_2": "クーポン",
      "iab22_3": "パリティ",
      "iab22_4": "検索エンジン",
      "iab23": "宗教と精神性",
      "iab23_1": "代替宗教",
      "iab23_2": "無神論/不可知論",
      "iab23_3": "仏教",
      "iab23_4": "カトリック",
      "iab23_5": "キリスト教",
      "iab23_6": "ヒンドゥー教",
      "iab23_7": "イスラム教",
      "iab23_8": "ユダヤ教",
      "iab23_9": "末日聖徒",
      "iab23_10": "異教/魔術",
      "iab24": "未分類",
      "iab25": "非標準コンテンツ",
      "iab25_1": "モデレートされていないUGC",
      "iab25_2": "極めて露骨な暴力",
      "iab25_3": "ポルノ",
      "iab25_4": "俗悪な内容",
      "iab25_5": "憎悪的なコンテンツ",
      "iab25_6": "工事中",
      "iab25_7": "原因",
      "iab26": "違法コンテンツ",
      "iab26_1": "違法コンテンツ",
      "iab26_2": "リスト",
      "iab26_3": "スパイウェア/マルウェア",
      "iab26_4": "著作権侵害",
      "countHint": "選択した記事カテゴリには、過去 7 日間で合計 {{count}} 件の記事が表示されます。"
    },
    "errors": {
      "invalidSpaceName": "<1>セクション名の検証に失敗しました。</1>\n名前が元のデータと一致していること、および記号 <2>[</2>, <2>]</2> と <2>_</2> のみが含まれていることを確認してください。その他の異常な文字やスペースが含まれている場合、正常に追加できません。",
      "invalidStoreName": "<1>店鋪名の検証に失敗しました。</1>\n名前が元のデータと一致していること、および記号 <2>[</2>, <2>]</2> と <2>_</2> のみが含まれていることを確認してください。その他の異常な文字やスペースが含まれている場合、正常に追加できません。"
    }
  },
  "adFormat": { "instl": "カバー" },
  "rtbCampaignSetupStep": {
    "labels": {
      "fixOutdoorDeviceSection": "固定マシンのオプション",
      "fixOutdoorStoreSection": "固定ストアオプション"
    },
    "hints": {
      "fixOutdoorDeviceSection": "システムは現在の端末リストを固定し、ダウンロード可能にします。",
      "fixOutdoorStoreSection": "システムは現在の店舗リストを固定し、ダウンロード可能にします。"
    }
  },
  "campaign": {
    "buttons": {
      "downloadFixOutdoorStoreData": "店舗情報をダウンロード",
      "downloadFixOutdoorDeviceData": "端末情報をダウンロード",
      "importOutdoorStore": "店舗情報ファイルをインポートする",
      "importOutdoorDevice": "端末情報ファイルをインポート",
      "cancelCreate": "作成をキャンセル",
      "saveDraft": "下書きを保存",
      "cancelEdit": "編集をキャンセル",
      "adTypeDisplayTitle": "ディスプレイ広告",
      "adTypeVideoTitle": "視聴覚広告",
      "adTypeComboTitle": "ビデオ+画像広告",
      "adTypeSandboxOutdoorTitle": "R&Dテストユーザー屋外広告",
      "adTypeSandboxMovableOutdoorTitle": "R&Dテストユーザー移動式屋外広告",
      "adTypePicShortTitle": "PIC屋外15秒広告",
      "adTypePicLongTitle": "PIC屋外30秒広告",
      "adTypePicExtendedTitle": "PIC屋外60秒広告",
      "adTypePicBroadTitle": "PIC屋外60秒以上の広告",
      "adTypeHwacomShortTitle": "HwaCom15秒広告",
      "adTypeHwacomLongTitle": "HwaCom30秒広告",
      "adTypeHwacomExtendedTitle": "HwaCom60秒広告",
      "adTypeHwacomBroadTitle": "HwaCom60秒以上の広告",
      "adTypeFridgeBroadTitle": "60秒以上の屋外冷凍庫広告",
      "adTypeFridgeLongTitle": "30秒の屋外冷凍庫広告",
      "adTypeFridgeExtendedTitle": "60秒の屋外冷凍庫広告",
      "adTypePmpPicTitle": "PMP PIC 屋外広告",
      "adTypePmpFridgeTitle": "PMP冷凍庫屋外広告",
      "adTypeThirdPartyTitle": "アドネオン",
      "adTypeThirdPartyBottomTitle": "モバイル下部広告",
      "adTypeThirdPartyRectangleTitle": "中サイズの長方形広告",
      "adTypeOutdoorLineMessageTitle": "Outdoor Line Message 広告",
      "adTypeLineMessageTitle": "Line Message 広告",
      "adTypeDisplayDesc": "画像│HTML5│ネイティブ│ダイナミック",
      "adTypeVideoDesc": "インストリーム│アウトストリーム",
      "adTypeComboDesc": "映画 + 写真",
      "adTypeSandboxOutdoorDesc": "屋外オーディオおよびビデオ広告の研究開発とテスト",
      "adTypeSandboxMovableOutdoorDesc": "移動式屋外オーディオおよびビデオ広告の研究開発とテスト",
      "adTypePicShortDesc": "PIC屋外15秒広告",
      "adTypePicLongDesc": "PIC屋外30秒広告",
      "adTypePicExtendedDesc": "PIC屋外60秒広告",
      "adTypePicBroadDesc": "PIC屋外60秒以上の広告",
      "adTypeHwacomShortDesc": "HwaCom15秒広告",
      "adTypeHwacomLongDesc": "HwaCom30秒広告",
      "adTypeHwacomExtendedDesc": "HwaCom60秒広告",
      "adTypeHwacomBroadDesc": "HwaCom60秒以上の広告",
      "adTypeFridgeBroadDesc": "60秒以上の屋外冷凍庫広告",
      "adTypeFridgeLongDesc": "30秒の屋外冷凍庫広告",
      "adTypeFridgeExtendedDesc": "60秒の屋外冷凍庫広告",
      "adTypeOutdoorLineMessageDesc": "Outdoor Line Message 広告",
      "adTypeLineMessageDesc": "Line Message 広告",
      "adTypePmpPicDesc": "PMP PIC 屋外広告",
      "adTypePmpFridgeDesc": "PMP冷凍庫屋外広告",
      "adTypeThirdPartyDesc": "アドネオン",
      "adTypeThirdPartyBottomDesc": "行動置底",
      "adTypeThirdPartyRectangleDesc": "中サイズの長方形",
      "adTypeCTVTitle": "デジタルテレビ広告",
      "adTypeCTVDesc": "コネクテッドTV | コネクテッドデバイス | セットトップボックス",
      "adTypeMessageTitle": "SMS広告",
      "adTypeMessageDesc": "ショートメッセージ",
      "completeAndCheck": "完了してチェック",
      "send": "送信",
      "back": "前のステップに戻る",
      "saveAndBindCreative": "新しい資料を提出して追加する"
    },
    "labels": {
      "adType": "キャンペーンタイプ",
      "noSupportedAdType": "現在利用可能なキャンペーンタイプはありません。対応する機能を有効にするには、システム管理者にお問い合わせください。",
      "pmpSelect": "PMP注文を選択",
      "campaignSetting": "キャンペーン設定",
      "summary": "情報の概要",
      "standard": "通常配信",
      "accelerated": "集中配信",
      "deliverType": "配信タイプ",
      "orderPrice": "- 契約価格",
      "orderPriceChange": "管理者（Admin）が契約価格を調整\n{{from}} から {{to}} に変更",
      "adTypePageTitle": "キャンペーンタイプを選択",
      "createCampaignTitle": "新しいキャンペーンを追加する",
      "editCampaignTitle": "キャンペーンの編集",
      "splitCampaignTitle": "キャンペーンの削減",
      "copyCampaignTitle": "キャンペーンをコピーする",
      "editCampaignDraftTitle": "下書きを編集",
      "summaryCampaignTitle": "キャンペーン概要",
      "videoObjective": "ターゲットを見る",
      "videoObjectiveDefault": "デフォルト",
      "videoObjectiveProgress": "秒",
      "videoObjectiveMetric": "イベント",
      "rs": "ダイナミック入札",
      "dcpm": "ダイナミックCPM",
      "fcpc": "固定クリック単価",
      "fcpm": "固定CPM",
      "fbcpm": "メッセージ単価",
      "fcpv": "固定CPV",
      "fvcpm": "固定vCPM",
      "facpm": "固定aCPM",
      "fwcpm": "固定 wCPM",
      "rb": "障害",
      "cpc": "クリック単価",
      "cpm": "インプレッション単価",
      "cpv": "CPV",
      "vcpm": "仮想CPM",
      "fixed_viewable_impression": "ビューアブルインプレッション数",
      "firstquartile": "動画の25%を視聴する",
      "midpoint": "動画の50%を視聴する",
      "complete": "ビデオを100%視聴する",
      "thirdquartile": "動画の75%を視聴する",
      "sec": "2番",
      "targetClicks": "目標クリック数 {{value}}",
      "targetKImpressions": "目標 {{value}} 千インプレッション",
      "targetKPublisherImpressions": "目標 {{value}} 千回の訪問",
      "targetViews": "目標閲覧数 {{value}}",
      "targetMessages": "目標メッセージ数 {{value}}",
      "tags": "メモ",
      "agencyProfit": "ディーラーの利益",
      "budgetPercentage": "予算比率",
      "creativeDeliverType": {
        "optimize": "配信の最適化",
        "average": "平均配達"
      },
      "outdoorDeliverType": {
        "optimize": "機械の最適化",
        "average": "機械1台あたりの平均配送量"
      },
      "convTrackEventclick": "クリック後のコンバージョン",
      "convTrackEventview": "閲覧後に変換する",
      "convTrackEvent": "コンバージョントラッキングモード",
      "hour": "時間",
      "day": "日",
      "week": "週",
      "group": { "rs": "CPCダイナミック入札", "fcpc": "固定クリック単価" }
    },
    "descriptions": {
      "notWithinOrderDayRange": "注文期限の超過",
      "overDailyBudget": "旅行期間中に予算を前倒しで使い切る",
      "underDailyBudget": "旅行期間中に予算をすべて使い切ることはできません",
      "meetDailyBudget": "期間中に<1>予算配分が完了</1>",
      "lengthError": "255文字未満にしてください",
      "messageLengthError": "テキストメッセージは 134 文字を超えることはできません。",
      "messageClickUrlMacroError": "ニュースレターのコンテンツには、外部URLを1つだけ含める必要があります。",
      "clickUrlFieldEmpty": "※外部URLコンテンツの設定が必要です",
      "smallerThanBudgetZero": "予算は0未満にすることはできません",
      "smallerThanDailyMnBudgetSum": "1 日の最小額は {{dmin}} です。日数 x 1 日の最小額は {{min}} 未満にすることはできません。",
      "smallerThanCampaignBudgetMinimum": "予算はキャンペーンの最小予算 {{min}} より低く設定できません",
      "smallerThanBudgetMinimum": "予算は{{min}}未満であってはなりません",
      "smallerThanBudgetMinimumDetail": "予算は {{min}} より低く設定できません。現在割り当てられている予算は {{budget}} です。",
      "smallerThanRTBBudgetMinimum": "この設定により、RTBによって割り当てられる予算はRTBの最小予算よりも低くなります。{{min}}よりも大きい値を設定することを推奨します。",
      "smallerThanSpents": "使用済み予算 {{min}} 未満であってはなりません",
      "smallerThanExpectSpents": "予想コスト {{min}} 未満であってはなりません",
      "smallerThanExpectSpentsDetail": "予想コストは{{min}}未満にすることはできません。現在割り当てられている予算は{{budget}}です。",
      "smallerThanRTBExpectSpents": "この設定により、RTBに割り当てられる予算が想定されるRTB費用よりも低くなります。{{min}}よりも大きい値を設定することを推奨します。",
      "percentSmallerThanLowerbound": "総予算の {{min}}% 未満であってはなりません",
      "percentBiggerThanUpperbound": "総予算の {{max}}% を超えることはできません",
      "overed": "超過",
      "overBudget": "{{wording}} <1>利用可能な予算合計</1><2> : {{currency}} {{overBudget}}</2>",
      "remainBudget": "予算残高 <1>{{currency}}{{remainBudget}}</1>",
      "percentBudgetHint": "割り当てられた予算 <1>{{currency}}{{budget}}</1>",
      "orderPriceTips": "少なくとも<1> {{price}} </1>元をお支払いください",
      "comboObjectiveDefault": "認識基準は2秒間のビデオコンテンツを視聴することである",
      "videoObjectiveDefault": "認識基準は映画コンテンツを100％視聴すること",
      "videoObjectiveProgress": "ビデオ+画像タイプの素材にのみ適用されます",
      "videoObjective25Event": "25% の視聴率は、インストリーム、ムービー + 画像、アウトストリーム タイプの素材にのみ適用されます。",
      "videoObjective50100Event": "視聴率 50% または 100% は、インストリームおよびムービー + 画像タイプの素材にのみ適用されます。",
      "videoObjectiveAllEvent": "インストリーム、ムービー+画像、インストリームタイプの素材に適用可能",
      "adTypeChangeAlert": "タイプを切り替えると、編集した内容がリセットされます。切り替えてもよろしいですか？",
      "campaignSchedulingDay": "合計 <1>{{days}} 日</1>",
      "campaignSchedulingHour": "合計 <1>{{hours}} 時間</1>",
      "priceMinimum": "金額が少なくとも{{min}}であることを確認してください",
      "bidPriceRange": "金額は <1>{{min}}</1> より高く、契約価格 <3>{{orderPrice}}</3> を超えてはなりません。",
      "moreThanDays": "{{days}}日を超えない期間を選択してください",
      "moreThanHours": "7日間または{{hours}}時間を超えない期間を選択してください",
      "createBeforeNow": "開始時刻として過去の時刻を選択することはできません",
      "startDayBeforeOrder": "開始時間は注文開始時間よりも後にする必要があります",
      "endDayBeforeNow": "終了時刻として過去の時刻を選択することはできません",
      "invalidValue": "このオプションは利用できなくなりました。",
      "budgetPercentageHoverHint": "※配送が半分以上完了している場合は変更できません",
      "cannotEditBudgetPercentHint": "※納品が半分以上完了しているため、予算比率の変更はできません",
      "budgetPercentageRangeHint": "初期値（{{init}}）は50%までしか調整できません。現在の調整範囲は{{min}}%～{{max}}%です。",
      "initBudgetPercentageRangeHint": "調整可能な範囲は {{min}}% ~ {{max}}% です",
      "minL1ObjectBudget": "この広告グループ内のすべてのキャンペーンをカバーするには、広告グループの予算が少なくとも {{budget}} である必要があります。"
    },
    "prefixs": {
      "videoObjectiveProgress": "トリガー時間（秒）",
      "videoObjectiveMetric": "トリガーイベント"
    },
    "strategyAndTracking": {
      "conversionTracking": "コンバージョントラッキング",
      "newThirdPartyTracking": "サードパーティのトラッキングを追加",
      "thirdPartyTracking": "サードパーティの追跡",
      "thirdPartyTrackingType": "コードタイプ",
      "thirdPartyTrackingTypePixel": "ピクセルコードまたはURL",
      "thirdPartyTrackingTypeJs": "JavaScriptコードURL",
      "thirdPartyTrackingCode": "追跡コード",
      "thirdPartyTrackingPreview": "解析結果",
      "videoProgressTracking": "リマーケティングトラッキング",
      "videoProgressTrackingCode": "リマーケティングトラッキングコード",
      "videoProgressTrackingCodeOffset": "トリガー時間（秒）",
      "noURL": "解析できません",
      "asiaMaxOnlyHint": "*注: JSタイプのサードパーティトラッカーを追加すると、asiamaxトラフィックのみが配信されます。",
      "viewableImpressionTrigger": "ビューアブルインプレッション数",
      "impressionTrigger": "インプレッション数",
      "trigger": "トリガータイプ"
    },
    "name": "キャンペーン名",
    "placeholders": {
      "tags": "アクティブなラベル テキストを入力した後、Enter キーを使用して別のラベルを追加できます..."
    },
    "errors": {
      "movableOutdoorAreaDerivationFailed": "次の座標から行政区を導出できませんでした：{{coordinates}}。座標が有効であることを確認して再試行してください。"
    }
  },
  "campaignInfo": {
    "labels": {
      "title": "基本的な広告情報と価格モデル",
      "order": "注文",
      "campaignName": "キャンペーン名",
      "dayRange": "配信期間",
      "deliverDate": "納期",
      "message": "ニュースレターの内容",
      "priceModel": "価格モデル",
      "totalBudget": "総活動予算",
      "dailyBudgetPlan": "予算配分",
      "schedule": "旅行期間全体の平均分布",
      "daily": "1日あたりの指定予算",
      "cannotModifyHint": "※アクティビティは一度作成すると変更できません！",
      "cannotModifyPriceModelHint": "※アクティビティが確立されると、価格設定モードを変更することはできません！",
      "dateCannotModifyHint": "※キャンペーン開​​始後は開始日の変更はできません。",
      "optimizeTitle": "スマート入札モード",
      "optimizeCap": "{{optimize}} 入札制限額",
      "creativeDeliverType": "材料の配送方法",
      "outdoorDeliverType": "機械による配送方法",
      "optimize": "スマート入札モード",
      "minimizeHint": "最低金額{{optimizeMinimum}}元を入力してください",
      "frequencySessionTitle": "広告配信頻度と配信期限",
      "sessionCapping": "指定された日数内の回数",
      "daypart": "配信時間を指定する",
      "rbPriceModelHint": "指定された広告掲載場所が必要",
      "isOutOfOutdoorBk": "屋外BK計算を除外するかどうか",
      "orderPriceEnable": "契約価格を手動で設定",
      "allowOverrun": "スーパーカー可",
      "lifeHint": "広告の放映期間中に視聴者が広告を視聴した最大回数。",
      "bLifeHint": "広告の掲載期間中に視聴者が広告の各要素を視聴した回数。",
      "sessionHint": "指定された期間内に視聴者がこの広告を見た最大回数",
      "bSessionHint": "指定された期間内に視聴者がこの広告の各クリエイティブ要素を閲覧した回数。",
      "messageHint": "残り{{number}}文字",
      "enableMonitor": "異常状態の監視が可能",
      "autoBudgetOptimize": "予算を自動的に最適化",
      "autoBudgetOptimizeHint": "この機能をオンにすると、広告の結果に基づいてシステムが予算配分比率を自動的に調整します。",
      "group": { "priceModel": "RTB価格モデル" },
      "CBOBudgetHint": "CBO キャンペーン グループがキャンペーンの予算を管理するため、ユーザーが予算を設定する必要はありません。",
      "backToEditRtbCampaignGroup": "広告グループの予算の編集に戻るには、ここをクリックしてください。"
    },
    "hints": {
      "acceleratedDeliverType": "ご注意: 有効化すると、配信条件を満たすトラフィックがある限り、システムは継続的に集中配信を行います。その結果、短時間で予算を大幅に早く消化してしまう可能性があります。設定前に十分ご確認のうえ、予算の消化状況をこまめにご監視ください。"
    }
  },
  "stepSideBar": {
    "labels": {
      "basic": "基本情報",
      "targeting": "ターゲットの最適化",
      "strategyAndTracking": "さまざまな追跡モード",
      "adLogo": "広告ロゴ",
      "creativeChooseAdvertiser": "広告主を選択",
      "creativeSetUp": "設定素材",
      "creativeSummary": "情報の概要",
      "creativeBasic": "基本情報",
      "creativeLimitation": "ターゲットの最適化",
      "campaignSettingSummary": "アクティビティ設定",
      "creativeSettingSummary": "素材設定"
    }
  },
  "campaignSummary": {
    "labels": {
      "adTypeDisplay": "ディスプレイ広告",
      "adTypePicShort": "PIC屋外15秒広告",
      "adTypePicLong": "PIC屋外30秒広告",
      "adTypePicExtended": "PIC屋外60秒広告",
      "adTypePicBroad": "PIC屋外60秒以上の広告",
      "adTypeFridgeBroad": "60秒以上の屋外冷凍庫広告",
      "adTypeFridgeLong": "30秒の屋外冷凍庫広告",
      "adTypeFridgeExtended": "60秒の屋外冷凍庫広告",
      "adTypeVideo": "視聴覚広告",
      "adTypeThirdParty": "アドネオン",
      "adTypeThirdPartyBottom": "モバイル下部広告",
      "adTypeThirdPartyRectangle": "中サイズの長方形広告",
      "adTypeMessage": "SMS広告",
      "adTypeSandboxOutdoor": "屋外広告の利用に関する調査",
      "adTypeSandboxMovableOutdoor": "R&Dテストユーザー移動式屋外広告",
      "adTypeOutdoorLineMessage": "Outdoor Line Message 広告",
      "adTypeLineMessage": "Line Message 広告",
      "orderName": "注文",
      "campaignName": "キャンペーン名",
      "schedule": "配信期間",
      "deliverDate": "納期",
      "message": "ニュースレターの内容",
      "pricingModel": "価格モデル",
      "orderPrice": "{{model}} 契約価格",
      "campaignBudget": "総活動予算",
      "budgetDistribution": "予算配分",
      "budgetScheduleDistribution": "旅行期間全体の平均分布",
      "budgetDailyDistribution": "{{currency}}}{{budget}}/日",
      "optimizeModel": "スマート入札モード",
      "optimizePriceCap": "{{model}} 配信制限",
      "creativeDeliveryType": "材料の配送方法",
      "creativeOptimizeDelivery": "配信の最適化",
      "creativeUniformDelivery": "平均配達",
      "budgetPercentage": "予算比率",
      "autoBudgetOptimize": "予算を自動的に最適化",
      "videoAdViewObjective": "ターゲットを見る",
      "videoAdViewObjectiveMetric": "イベント: {{metric}}",
      "videoAdViewObjectiveProgress": "秒数: {{offset}} 秒",
      "videoAdViewObjectiveDefault": "デフォルト",
      "fixOutdoorSpace": "固定ストアオプション",
      "conversionTracking": "コンバージョントラッキング",
      "trackingCodes": "連結",
      "videoProgressTrackingCode": "追跡コード",
      "videoProgressTrackingOffset": "トリガー時間",
      "dayPart": "配信時間を指定する",
      "deliverType": "配信タイプ",
      "standard": "標準",
      "accelerated": "密集",
      "tags": "メモ",
      "uniqueUserTitle": "推定週次リーチ",
      "impressionTitle": "推定インプレッション数",
      "uniqueUserInformation": "現在のターゲティング設定に基づく、週ごとのオーディエンス数の推定値です。実際のリーチ数は予算設定によって異なります。",
      "estimateDesc": "週ごとの推定リーチ数と推定インプレッション数は、実際の広告オーディエンスの規模と異なる場合があります。これらの推定値は、特定のトラフィックを制限または除外する設定に基づいています。",
      "limitationNotEstimateDesc": "現在、特定のトラフィックを除外したり、リマーケティング オーディエンス、TenMax オーディエンス グループ、キーワードなどを含むようにトラフィックを制限したりした場合のリーチとインプレッションの見積もりはありません。",
      "impressionInformation": "今後1週間の広告の予想インプレッション数です。実際のインプレッション数は予算設定によって異なります。",
      "rbNotEstimateDesc": "料金モデルがロードブロッキングの場合、推定リーチと推定インプレッションは利用できません。",
      "estimateLowHint": "ターゲットの最適化が厳しすぎる設定になっています。",
      "convTrackEventClick": "クリック後のコンバージョン",
      "convTrackEventView": "閲覧後に変換する",
      "convTrackEvent": "コンバージョントラッキングモード",
      "autoBid": "自動調整",
      "enableMonitor": "異常状態の監視が可能",
      "group": { "pricingModel": "RTB価格モデル" },
      "adTypeOneForAllDisplay": "ワンフォーオールディスプレイ広告",
      "startDate": "開始時間",
      "endDate": "終了時間",
      "storeDeliverable": "配信可能の店舗",
      "deviceDeliverable": "配信可能の機械",
      "storeWeatherNonDeliverable": "天気条件で絞り込まれた店舗",
      "deviceWeatherNonDeliverable": "天気条件で絞り込まれた機器",
      "storeChangeNonDeliverable": "店舗変更",
      "deviceChangeNonDeliverable": "機器変更",
      "deviceOverBindingLimitNonDeliverable": "ロック上限を超えた機器",
      "storeOverBindingLimitNonDeliverable": "ロック上限を超えた店舗"
    },
    "titles": {
      "generalInformation": "基本的な広告情報と価格モデル",
      "optimizeSetting": "スマート入札モードの設定",
      "advanceSetting": "広告配信頻度と配信期限",
      "inc": "交通量を制限する",
      "exc": "指定した配信枠を除外",
      "preferred": "優先配信",
      "nonPreferred": "優先配信しない",
      "other": "他の",
      "adType": "キャンペーンタイプ",
      "basicSetting": "基本情報",
      "targetSetting": "ターゲットの最適化",
      "trackingSetting": "さまざまな追跡",
      "conversionTracking": "コンバージョントラッキングを使用する",
      "trackingCodes": "トラッキングコードリンク",
      "videoProgressTrackingCode": "リマーケティングトラッキング",
      "checkYourSettings": "設定を確認してください",
      "adLogo": "広告ロゴ",
      "storeDeliverability": "配信可能の店舗数／設定店舗総数",
      "deviceDeliverability": "配信可能の機械数／設定機械総数"
    }
  },
  "summary": { "titles": { "noData": "なし", "generalInfo": "一般情報" } },
  "daypart": {
    "labels": {
      "monday": "月曜日",
      "tuesday": "火曜日",
      "wednesday": "水曜日",
      "thursday": "木曜日",
      "friday": "金曜日",
      "saturday": "土曜日",
      "sunday": "日曜日",
      "optionsPlaceholder": "配送期間を選択してください...",
      "am": "朝",
      "pm": "午後",
      "hourUnit": "時間",
      "allDay": "全時間帯（指定なし）",
      "afternoon": "午後：12時〜17時",
      "evening": "夜間：18時〜23時",
      "morning": "朝：6時〜11時",
      "weekday": "平日：月曜日〜金曜日",
      "weekend": "週末：土・日・祝",
      "conversionOptimize": "転換率が高い最適化の時間帯",
      "midnightDisabled": "深夜時間帯の除外",
      "mobileOptimize": "スマホの使用頻度が高い時間帯",
      "pcOptimize": "PCの使用頻度が高い時間帯"
    },
    "segments": {
      "h00": "00:00 - 05:59",
      "h06": "06:00 - 11:59",
      "h12": "12:00 - 17:59",
      "h18": "18:00 - 23:59"
    }
  },
  "errorPage": {
    "labels": {
      "403": "申し訳ありませんが、必要な権限をお持ちでないようです。<1/>\n<3>別のロールでログイン</3>してみてください。または…",
      "404": "申し訳ありません！結果が見つかりませんでした。<1/>\n<3>他のページを参照</3>するか、…",
      "back": "戻る",
      "contact": "お問い合わせ"
    }
  },
  "orderDetail": {
    "labels": {
      "orderNumber": "注文番号",
      "orderType": "注文タイプ",
      "externalId": "外部注文番号",
      "externalType": "外部注文カテゴリ",
      "dateRange": "配信期間",
      "remainDays": "残り日数",
      "today": "今日",
      "totalBudget": "総予算",
      "alreadySpent": "消化金額",
      "remainBudget": "予算残高",
      "progress": "注文執行",
      "agencyProfit": "ディーラーの利益",
      "impres": "インプレッション数",
      "viewable": "ビューアブルインプレッション数",
      "clicks": "クリック数",
      "ctr": "クリックスルー率",
      "adView": "閲覧数",
      "viewRate": "視聴率",
      "originBudget": "{{budget}} (当初予算)",
      "changeBudget": "{{budget}} (審査中)",
      "originProfit": "{{profit}} % （元の利益）",
      "changeProfit": "{{profit}} % (審査中)",
      "days": "{{days}}日",
      "settleWait": "ご注文は決済中です、お待ちください...",
      "settledNoNeedSettle": "決済済みの注文は再度決済する必要はありません",
      "settleSuccess": "和解は成功した",
      "unsettleSuccess": "決済のキャンセルが成功しました",
      "creator": "創設者",
      "creatorEmail": "メール",
      "monitor": "注文監視",
      "channelMargin": "{{channel}} ディーラー利益",
      "title": "注文と活動リスト",
      "name": "注文名: {{name}}",
      "hasRunningCampaignCannotSettle": "開始されていない、または実行中/一時停止中で決済できない広告活動があります。",
      "finished": "終了しました",
      "notstart": "開始されていません",
      "isEndCannotCreate": "終了した注文ではキャンペーンを作成できません",
      "orderStateCannotCreate": "承認されていない/決済中/決済済みの注文に対してはキャンペーンを作成できません",
      "lessThanBudgetMinimum": "利用可能な残りの予算が最低配送額 {{budget}} より少ないです",
      "report": "広告効果",
      "generalReport": "一般広告",
      "videoReport": "視聴覚広告",
      "downloadRtbReport": "RTBレポートをダウンロード",
      "downloadOutdoorReport": "Outdoorレポートをダウンロード",
      "editOrder": "注文を編集",
      "waitingForReview": "審査中",
      "reject": "断る",
      "settle": "決済進行中",
      "settled": "落ち着いた",
      "approve": "承認する",
      "status": "ステータス",
      "approveSuccess": "承認に成功しました",
      "rejectSuccess": "拒否成功",
      "modifyReason": "異動理由",
      "orderPrice": "CPM契約価格",
      "creativeDuration": "素材の推定再生時間",
      "dayPart": "配信時間を指定する",
      "messageCampaignStartTimeError": "SMS広告の最終設定時間は注文終了日を超えることはできません"
    },
    "errors": {
      "budgetExceedStoredValueError": "残高が不足しています。予算は {{amount}} を超えることはできません。"
    },
    "buttons": { "settle": "決済", "unsettle": "決済をキャンセルする" },
    "tabs": {
      "campaign": "キャンペーン",
      "campaignControl": "予算配分グループ",
      "record": "ログ"
    }
  },
  "orderForm": {
    "errors": {
      "budgetExceedStoredValueError": "残高が不足しています。予算は {{max}} を超えることはできません。",
      "endDateError": "過去の終了日を選択することはできません",
      "finalReport": {
        "receivers": "無効なメールアドレスが含まれています: {{invalidEmails}}"
      },
      "projectNamePatternError": "Onelink キャンペーン名は、記号やスペースを含まない CamelCase の英数字文字列である必要があります。"
    },
    "labels": {
      "advertiser": "広告主",
      "name": "注文名",
      "externalId": "外部注文番号",
      "dateRange": "配信期間",
      "dateCannotModifyHint": "※注文成立後は開始日の変更はできません。",
      "totaldates": "合計{{num}}日",
      "budget": "予算",
      "orderMargin": "ディーラーの利益",
      "remark": "その他の注意事項",
      "createTitle": "ニュー・オーダー",
      "modifyReason": "予算変更理由",
      "modifyMargin": "利益の変化",
      "modifyCancel": "変更をキャンセル",
      "modifyBudget": "予算の変更",
      "editTitle": "注文を編集",
      "externalType": "外部注文タイプ",
      "campaignMinDateError": "注文開始時間は、キャンペーンの開始時間より遅くすることはできません。",
      "campaignMaxDateError": "注文の終了時間は、キャンペーンの終了時間より早くすることはできません。",
      "monitor": "注文監視",
      "creditHint": "現在のクレジット限度額は{{credit}}の上限に達しており、管理者による処理を待機しています。",
      "orderPrice": "CPM契約価格",
      "creativeDuration": "素材秒數",
      "daypart": "配信時間を指定する",
      "basic": "基本情報設定",
      "outdoor": "屋外広告の設定",
      "finalReport": {
        "projectName": "ワンリンクキャンペーン名",
        "projectType": "広告主タイプ",
        "receivers": "受信者",
        "sendOutDate": "送信日",
        "advertiserName": "広告主名",
        "targetType": "ターゲットタイプ",
        "targetValue": "目標回数",
        "targetImpressions": "目標インプレッション数"
      }
    },
    "placeholders": {
      "finalReport": { "receivers": "受信者のメールアドレス" }
    },
    "titles": { "finalReport": "事件終結報告書" },
    "hints": { "finalReport": { "projectName": "※このプロジェクト名は" } }
  },
  "orderList": {
    "headers": {
      "orderNumber": "注文名とID",
      "advertiser": "広告主",
      "targetBudget": "予算",
      "spent": "消化金額",
      "remainingDay": "残り日数",
      "progress": "配送の進捗状況",
      "state": "ステータス",
      "endDate": "終了日",
      "externalId": "PA外部番号",
      "noDataAvailable": "注文なし"
    },
    "labels": {
      "copyYahooOrderNameSuccess": "コピーされた注文番号と名前",
      "editHint": "注文を編集",
      "copyYahooOrderNameHint": "Verizonの注文名をコピーする",
      "reportHint": "レポートを見る",
      "creatorInformation": "注文メーカー情報",
      "creator": "創設者",
      "creatorEmail": "メール",
      "createDateTime": "注文作成時間",
      "stateFilterMenuTitle": "注文ステータスを選択",
      "progressNormal": "通常 {{count}}",
      "progressNotStart": "開始されていません {{count}}",
      "progressBehind": "{{count}}の後ろ",
      "progressSeverelyBehind": "真剣に{{count}}の後ろに",
      "progressOver": "スーパーカー {{count}}",
      "progressAhead": "スーパーカー {{count}}",
      "filterList": "フィルター",
      "stateFilter": "注文状況",
      "tagFilter": "メモ",
      "tagFilterMenuTitle": "タグを選択",
      "stateTag": "注文状況",
      "tagTag": "メモ",
      "remainBudget": "予算黒字"
    },
    "placeholders": { "searchbar": "注文名、ID、または外部番号を検索..." }
  },
  "campaignList": {
    "headers": {
      "nameColumn": "名前",
      "stateColumn": "広告ステータス",
      "typeColumn": "広告の種類",
      "scheduleColumn": "配信期間",
      "progressColumn": "配送の進捗状況",
      "budgetColumn": "予算と配分",
      "budgetDistributionColumn": "予算配分",
      "priceModel": "実施計画",
      "limitationColumn": "ターゲットの最適化",
      "trackingColumn": "さまざまな追跡",
      "campaignControlColumn": "予算配分グループ",
      "tagsColumn": "カスタムラベル",
      "impresColumn": "インプレッション数",
      "viewableColumn": "ビューアブルインプレッション数",
      "clicksColumn": "クリック数",
      "cpcColumn": "クリック単価",
      "ctrColumn": "クリックスルー率",
      "vctrColumn": "視認可能なクリックスルー率",
      "convertColumn": "変換番号",
      "cpaColumn": "コンバージョン単価",
      "cvrColumn": "コンバージョン率",
      "viewColumn": "動画視聴回数",
      "viewRateColumn": "動画視聴率",
      "viewableViewRateColumn": "動画の視聴率",
      "creativeColumn": "クリエイティブ",
      "uuCountColumn": "リピーターなし",
      "priceGroupColumn": "実施計画",
      "deliveryColumn": "配送状況",
      "optimize": "時間帯の設定",
      "resultsColumn": "結果",
      "spents": "消化金額"
    },
    "labels": {
      "createCampaignBtn": "+ キャンペーン",
      "stateFilterMenuTitle": "キャンペーンのステータスを選択",
      "tagFilterMenuTitle": "タグを選択",
      "adTypeThirdParty": "アドネオン",
      "adTypeThirdPartyRectangle": "中サイズの長方形",
      "adTypeThirdPartyBottom": "行動置底",
      "adTypeVideo": "オーディオとビデオの種類",
      "adTypeDisplay": "画面",
      "adTypePicShort": "PIC屋外15秒広告",
      "adTypePicLong": "PIC屋外30秒広告",
      "adTypePicExtended": "PIC屋外60秒広告",
      "adTypePicBroad": "PIC屋外60秒以上の広告",
      "adTypeHwacomShort": "HwaCom15秒広告",
      "adTypeHwacomLong": "HwaCom30秒広告",
      "adTypeHwacomExtended": "HwaCom60秒広告",
      "adTypeHwacomBroad": "HwaCom60秒以上の広告",
      "adTypeFridgeBroad": "60秒以上の屋外冷凍庫広告",
      "adTypeFridgeLong": "30秒の屋外冷凍庫広告",
      "adTypeFridgeExtended": "60秒の屋外冷凍庫広告",
      "adTypePmpPic": "PMP PIC 屋外広告",
      "adTypePmpFridge": "PMP冷凍庫屋外広告",
      "adTypeCombo": "映画 + 写真",
      "adTypeCTV": "デジタルテレビ",
      "adTypeKeyword": "キーワード",
      "adTypeEmpty": "未分類",
      "adTypeMessage": "SMS広告",
      "adTypeSandboxOutdoor": "R&Dテストユーザー屋外オーディオおよびビデオ",
      "adTypeSandboxMovableOutdoor": "R&Dテストユーザー移動式屋外広告",
      "adTypeOutdoorLineMessage": "Outdoor Line Message",
      "adTypeLineMessage": "Line Message",
      "activateState": "放送中",
      "deactivateState": "非アクティブ化",
      "deleteState": "削除済み",
      "pendingReviewState": "審査待ち",
      "withIssues": "改訂予定",
      "stoppingState": "一時停止",
      "pmpInactiveState": "PMPは無効になっています",
      "pmpEndState": "PMPは終了しました",
      "pmpExpiredState": "失敗",
      "pmpExpiredHint": "このキャンペーンは、注文が実行される前に材料の検討が間に合わなかったため無効になりました。",
      "draftStateHint": "草稿はまだ公開されていません",
      "schedule": "{{start}}<1/>から<3/>{{end}}",
      "messageCampaignSchedule": "{{start}}",
      "budget": "予算",
      "distribute": "配布する",
      "budgetSchedule": "旅行期間全体の平均分布",
      "budgetDailyDistribution": "{{currency}} {{budget}} / 日",
      "bidPriceDes": "配送制限 {{currency}} {{price}}",
      "conversionTracking": "コンバージョントラッキング",
      "viewTrackingCodes": "サードパーティの追跡",
      "videoProgressTrackingCode": "リマーケティングトラッキング",
      "campaignCount": "キャンペーン {{count}}",
      "campaignBudget": "合計予算 {{number}}",
      "emptyContent": "なし",
      "creativeAmount": "クリエイティブ {{count}}",
      "pmpChangedState": "PMPの変更",
      "pmpChangedHint": "PMPレビューの変更",
      "limitation": "ターゲットの最適化",
      "addLimitation": "新たなターゲット",
      "removeLimitation": "ターゲットを削除",
      "summaryCampaign": "キャンペーン概要ページ",
      "deliverStandard": "標準",
      "deliverAsap": "密集",
      "deliverType": "配信タイプ",
      "noData": "現在、広告活動はありません。「+ 広告活動」をクリックして追加してください。",
      "noCreativesState": "無素材",
      "budgetRemainState": "予算黒字",
      "partialStoreChange": "一部店舗の変更",
      "allStoreChange": "すべての店舗の変更",
      "allWeatherFiltered": "すべての天気条件が一致しません",
      "partialWeatherFiltered": "一部の天気条件が一致しません",
      "endState": "終了しました",
      "notStartState": "開始されていません",
      "editHint": "キャンペーンの編集",
      "cloneHint": "キャンペーンをコピーする",
      "splitHint": "キャンペーンの削減",
      "reportHint": "レポートを見る",
      "creativeEditHint": "クリエイティブの管理",
      "creativeViewHint": "クリエイティブを表示",
      "priceModel": "価格モデル",
      "campaignControlName": "名前",
      "optimize": "スマート入札モード",
      "priceCap": "配送制限",
      "autoBid": "自動調整",
      "filterList": "フィルター",
      "tagFilter": "メモ",
      "tagTag": "メモ",
      "bidPriceChange": "入札制限\n{{from}} から {{to}} に変更",
      "deliveringStoreRatio": "配信中店舗 / 設定店舗",
      "deliveringDeviceRatio": "配信中端末 / 設定端末",
      "notDelivering": "配信対象外",
      "weatherMismatch": "天気不一致",
      "storeChange": "店舗変更",
      "deviceChange": "端末変更",
      "limitationDetail": "ターゲットの詳細を最適化する",
      "edit": "編集",
      "creative": "素材",
      "batchEdit": "一括編集",
      "bindCreative": "既存ものを使用",
      "deactivateCreative": "素材を無効化",
      "activeCreative": "素材を有効化",
      "activeCampaign": "有効にする",
      "activeSuccess": "有効化に成功しました",
      "activeFailed": "有効化に失敗しました",
      "deactiveSuccess": "無効化に成功しました",
      "deactiveFailed": "無効化に失敗しました",
      "deleteSuccess": "削除されました",
      "deactivateCampaign": "無効化",
      "selected": "選択済み",
      "canSplitMinimum": "キャンペーン予算が最小分割額 {{budget}} 未満です",
      "adTypeNotSupportCopy": "この広告タイプはまだコピーをサポートしていません",
      "adTypeNotSupportSplit": "この広告タイプでは分割機能がまだサポートされていません",
      "batchEditMultiTypeError": "異なる種類のキャンペーンを一括編集できません",
      "unknowTypeBatchEditError": "分類されていない広告は一括管理できません",
      "batchEditDraftError": "下書きは一括管理できません",
      "cannotDelete": "バインドされたクリエイティブを含むキャンペーンは削除できません",
      "cannotEditMessageCampaign": "当日に予定されているキャンペーンやすでに開始されているキャンペーンは編集できません。",
      "cannotDeleteMessageCampaign": "当日に予定されているキャンペーンやすでに開始されているキャンペーンは削除できません。",
      "cannotActiveMessageCampaign": "当日に配信期間されているキャンペーンやすでに開始されているキャンペーンをアクティブ化することはできません。",
      "cannotDeactiveMessageCampaign": "当日に配信期間されているキャンペーンやすでに開始されているキャンペーンを非アクティブ化することはできません。",
      "deleteCampaign": "削除",
      "deleteDraft": "下書きを削除",
      "deleteCampaignModalTitle": "キャンペーンを削除する",
      "deleteCampaignModalContent": "選択したキャンペーンを削除してもよろしいですか？\nこの操作は元に戻せません",
      "deleteDraftModalTitle": "下書きを削除",
      "deleteDraftModalContent": "選択した下書きを削除してもよろしいですか？\nこの操作は元に戻せません",
      "mixDeleteModalTitle": "キャンペーンと下書きの削除",
      "mixDeleteModalContent": "選択したキャンペーンと下書きを削除してもよろしいですか？\nこの操作は元に戻せません。",
      "rtbPriceCap": "RTB配信制限",
      "manageBidWeightModalTitle": "配送重量の管理",
      "updateBidWeightSuccess": "配送重量を更新しました",
      "updateAdminBidPriceSuccess": "入札設定を変更しました",
      "adTypeOneForAllDisplay": "ワンフォーオールディスプレイ広告",
      "canCopyNeedMore": "{{parent}} がこのキャンペーンをコピーするには、追加の予算 {{budget}} が必要です。",
      "minBudgetRequiredHint": "非アクティブ化されたキャンペーンを再度アクティブ化するには、キャンペーン グループに必要な予算を追加する必要があります。",
      "hasRejectedAd": "1 つ以上のクリエイティブが拒否されました。詳細は広告リストをご覧ください。",
      "duplicate": "クローン",
      "allStoreOverBindingLimit": "すべてロック上限超過",
      "epaperNotActivatableHint": "選択したキャンペーンの中に、10 件のキャンペーンで既にロックされている機器を指定しているものがあります。上限を超えた枠を編集で外してから有効化してください。",
      "partialStoreOverBindingLimit": "一部ロック上限超過"
    },
    "hints": { "manageAdminBidPrice": "入札設定を編集する" },
    "tabs": {
      "basic": "基本",
      "performance": "一般的なパフォーマンス情報",
      "message_performance": "一般的なパフォーマンス情報",
      "auditLog": "操作履歴記録",
      "videoPerformance": "オーディオとビデオのパフォーマンス情報",
      "rtb_video_performance": "オーディオとビデオのパフォーマンス情報"
    },
    "placeholders": { "searchbar": "キャンペーン名と番号を検索..." }
  },
  "messageCampaignList": {
    "labels": {
      "scheduledState": "キュー内",
      "pendingState": "結果を待つ",
      "abnormalState": "異常な"
    }
  },
  "l2ObjectList": {
    "labels": {
      "objectTypeFilterMenuTitle": "オブジェクトカテゴリを選択",
      "objectTypeFilter": "オブジェクトタイプ",
      "objectTypeTag": "カテゴリ",
      "ordinaryCampaign_rtb": "キャンペーン",
      "draft": "下書き",
      "editDraft": "下書きを編集",
      "statusFilter": "広告ステータス",
      "statusFilterMenuTitle": "広告ステータスを選択",
      "statusTag": "広告ステータス",
      "deliveryFilter": "配送状況",
      "deliveryFilterMenuTitle": "配送状況を選択",
      "deliveryTag": "配送状況"
    }
  },
  "order": {
    "status": {
      "notapprove": "承認待ち",
      "reject": "断る",
      "approvenotstart": "承認する",
      "approvestart": "承認する",
      "approve": "承認する",
      "stop": "終了しました",
      "delete": "削除",
      "invalid": "空所",
      "changepending": "注文の変更、審査待ち",
      "settle": "注文決済中",
      "settled": "注文が確定しました",
      "active": "有効にする",
      "deactive": "無効化"
    },
    "finalReport": {
      "targetType": {
        "impression": "インプレッション数",
        "click": "クリック数",
        "conversion": "変換番号",
        "view": "動画視聴回数"
      }
    }
  },
  "creativeOverviewStateContent": {
    "buttons": {
      "bind": "既存ものを使用",
      "new": "新規作成",
      "actionTips": "ステータスが「処理中」のクリエイティブへの変更は許可されません",
      "pmpDeactiveTips": "PMPキャンペーンではすべてのクリエイティブを非アクティブ化することはできません",
      "active": "有効にする",
      "deactive": "無効化",
      "singleActiveBindTips": "有効なクリエイティブが既にあります。無効化してから紐付けてください",
      "singleActiveActivateTips": "同時に有効にできるクリエイティブは1つまでです。先に既存のものを無効化してください",
      "singleActiveCreateTips": "有効なクリエイティブが既にあります。無効化してから新規作成してください",
      "epaperSpaceQuotaFullTips": "このキャンペーンが指定している機器は、すでに 10 件のキャンペーンでロックされています。まず上限を超えた枠をキャンペーンから外してください。",
      "epaperSpaceQuotaFullTipsWithCampaigns": "キャンペーン {{names}} が指定している機器は、すでに 10 件のキャンペーンでロックされています。上限を超えた枠を外すか、選択を変更してください。"
    },
    "tags": { "selectedTip": "{{count}} 個選択済み" },
    "tooltip": { "notAllowUnkown": "サポートされていない広告タイプ" }
  },
  "campaignCreativeList": {
    "headers": {
      "creativeName": "素材名",
      "creativePreview": "画像プレビュー",
      "creativeStatus": "ステータス",
      "ctr": "クリックスルー率",
      "vctr": "視認可能なクリックスルー率",
      "vtr": "視聴率",
      "imps": "インプレッション数",
      "clicks": "クリック",
      "vimps": "ビューアブルインプレッション数",
      "view": "時計",
      "typeAndSize": "タイプとサイズ",
      "approvalStatus": "レビューステータス",
      "effectiveStatus": "配達",
      "creativeLayout": "バージョン",
      "noDataAvailable": "無素材",
      "results": "結果",
      "uu": "リピーターなし"
    },
    "labels": {
      "copyImaxShortcutSuccess": "短縮URLをコピーしました",
      "emptyShortcutUrl": "この資料には有効な短縮URLがありません",
      "editHint": "編集素材",
      "copyShortcutHint": "短縮URLをコピー",
      "reportHint": "レポートを見る",
      "cannotEditCustomCreativeHint": "広告プラットフォーム上で広告を編集した後は、それ以上編集することはできません。",
      "noData": "現在、バインドされたクリエイティブはありません",
      "noDataWithoutAddPermission": "現在データはありません"
    }
  },
  "creativeList": {
    "labels": {
      "demoPageHint": "表示ページへ移動",
      "beforeStartTime": "開始されていません",
      "afterEndTime": "終了しました",
      "none": "なし",
      "notBindYet": "解放された",
      "reviewSuccess": "レビューのために正常に送信されました",
      "reviewFailed": "レビューの送信に失敗しました",
      "noData": "現在、広告素材はありません。「+ 素材」をクリックして新しい素材を追加できます。",
      "newCreative": "+ 素材",
      "bindEnable": "{{count}} を有効にする",
      "bindDisable": "{{count}}を無効化",
      "selected": "選択済み",
      "unlimited": "無制限",
      "bindingCampaign": "バインディングの使用状況",
      "enableBindState": "有効にする",
      "disableBindState": "無効化",
      "copyCreative": "クローン",
      "nameIdSummary": "素材 {{count}}",
      "updateYahooIdsSuccess": "Verizon 広告 ID を更新しました",
      "yahooIdEditTitle": "Verizon 広告 ID を編集",
      "enableStartTime": "開始時間",
      "enableEndTime": "終了時間",
      "yahooIdBind": "バインドされた Verizon 広告 ID",
      "updateBindStateSuccess": "バインディングの使用状況を更新しました",
      "cloneCreativeSuccess": "コピー素材が作成されました",
      "deleteCreativeSuccess": "削除された資料",
      "cannotDeleteHint": "バインドされたマテリアルを削除できません",
      "cannotCloneHint": "進行中の資料をコピーできません",
      "editHint": "編集素材",
      "cloneHint": "コピー素材",
      "editYahooIdHint": "Verizon 広告 ID を編集",
      "deleteHint": "素材を削除",
      "previewHint": "出版用プレビュー資料",
      "cannotUnBindSomeCreative": "以下のクリエイティブは PMP キャンペーンにバインドされており、キャンペーンには他に配信可能なクリエイティブがないため、非アクティブ化できません: {{ creatives }}",
      "deleteModalTitle": "素材を削除",
      "deleteModalContent": "選択したマテリアルを削除してもよろしいですか?",
      "skippable": "省略",
      "nonSkippable": "無視できない",
      "skipOffset": "{{offset}}秒",
      "inStream": "インストリーム（プレロール）",
      "outStream": "アウトストリーム",
      "approvalDefault1": "画像",
      "approvalDefault2": "HTML5",
      "approvalDefault3": "ネイティブ",
      "approvalDefault4": "ビデオ",
      "approvalDefault8": "アドネオン",
      "approvalDefault10": "ビデオ + 写真",
      "approvalDefault11": "エディマックスアウトドア",
      "approvalDefault26": "PIC 屋外 15秒",
      "approvalDefault27": "PIC 屋外 30秒",
      "approvalDefault12": "RTBネイティブ",
      "approvalDefault13": "ワン・フォー・オール・ディスプレイ",
      "approvalDefault14": "ワン・フォー・オール・ディスプレイ",
      "approvalDefault15": "ワン・フォー・オール・ディスプレイ",
      "approvalDefault23": "デジタルテレビ",
      "approvalDefault28": "ネイティブ",
      "approvalCtv": "CTV",
      "approvalDesktop": "デスクトップ",
      "approvalMobile": "携帯",
      "creativeCount": "素材 {{count}}",
      "approvalDefault16": "ワン・フォー・オール - 動画広告",
      "archivedActionHint": "この素材はアーカイブ済みのため、この操作はできません。",
      "archivedNotice": "この素材は保存期間を過ぎており使用されていないため、編集・紐付けできません。",
      "noMatchData": "条件に一致する素材がありません"
    },
    "placeholders": { "searchbar": "資産名と ID を検索..." },
    "headers": {
      "bannerId": "資産名とID",
      "bindingCampaign": "使用状況",
      "approvalStatus": "資料の形式とレビュー状況",
      "preview": "マテリアルプレビュー",
      "adTitle": "広告タイトル",
      "adDesc": "広告の説明",
      "bannerUrl": "リンクURL",
      "sponsor": "スポンサー",
      "limitations": "ターゲットの最適化",
      "streamingSetting": "広告の配置",
      "oneForAllClickUrl": "URLをクリック",
      "rtbClickUrl": "RTBリンクURL",
      "ppsLayoutId": "パターンID",
      "message": "メッセージ",
      "shortMessage": "ショートメッセージ",
      "skipSetting": "広告をスキップする設定",
      "outdoorType": "屋外広告の種類",
      "duration": "素材の再生時間",
      "status": "状態",
      "delivery": "配送状況",
      "adneonLayout": "バージョン"
    },
    "filter": {
      "statusFilter": "ステータス",
      "statusFilterMenuTitle": "素材ステータスを選択",
      "statusTag": "ステータス"
    },
    "status": {
      "active": "有効",
      "all": "すべて",
      "archived": "アーカイブ済み"
    }
  },
  "bindCreativeStateContent": {
    "placeholders": { "searchbar": "資産名または ID を検索..." },
    "buttons": {
      "newToOld": "新しいものから古いものへ",
      "oldToNew": "古いものから新しいものへ",
      "native": "ネイティブ広告",
      "selected": "選択済み",
      "allSelected": "すべて選択"
    },
    "labels": {
      "title": "既存ものを使用",
      "image": "RTBイメージ広告",
      "html5": "HTML広告",
      "native": "ネイティブ広告",
      "video": "動画広告",
      "dynamic": "ダイナミック広告",
      "flash": "フラッシュ広告",
      "third_party": "アドネオン広告",
      "combo": "ビデオ+画像広告",
      "edimax": "エディマックス屋外広告",
      "pic_short": "PIC屋外15秒広告",
      "pic_long": "PIC屋外30秒広告",
      "pic_extended": "PIC屋外60秒広告",
      "pic_broad": "PIC屋外60秒以上の広告",
      "hwacom_short": "HwaCom15秒広告",
      "hwacom_long": "HwaCom30秒広告",
      "hwacom_extended": "HwaCom60秒広告",
      "hwacom_broad": "HwaCom60秒以上の広告",
      "fridge_braod": "60秒以上の屋外冷凍庫広告",
      "fridge_long": "30秒の屋外冷凍庫広告",
      "fridge_extended": "60秒の屋外冷凍庫広告",
      "one_for_all": "ワン・フォー・オール - ディスプレイ",
      "one_for_all_display": "ワン・フォー・オール - ディスプレイ",
      "one_for_all_display_ios": "ワン・フォー・オール - ディスプレイ",
      "one_for_all_display_android": "ワン・フォー・オール - ディスプレイ",
      "ctv": "デジタルテレビ広告",
      "custom_bottom": "手彫りの下部広告",
      "custom_rectangle": "手彫りの中型長方形広告",
      "sandbox_outdoor": "R&Dテストユーザー屋外広告",
      "outdoor_line_message": "Outdoor Line Message 広告",
      "line_message": "Line Message 広告",
      "one_for_all_video": "ワン・フォー・オール - 動画広告",
      "one_for_all_video_ios": "ワン・フォー・オール - 動画広告",
      "one_for_all_video_android": "ワン・フォー・オール - 動画広告",
      "singleCreativeTips": "電子ペーパーチャネルでは一度に1つのクリエイティブのみ紐付けできます。他の選択を解除してください。"
    }
  },
  "creativeCard": { "labels": { "createTime": "{{time}} 設立" } },
  "batchEditCampaignTitle": {
    "title": "{{num}} 件のプロジェクトを同期的に調整します",
    "labels": { "subTitle": "キャンペーン名" }
  },
  "batchEditCampaignSummary": {
    "labels": { "checkYourSettings": "設定を確認してください" },
    "titles": { "trackingSummary": "さまざまな追跡" }
  },
  "creativeSummmaryStateContent": { "title": "既存ものを使用" },
  "creative": {
    "approval": { "no": { "record": "レビュー記録はまだありません" } },
    "list": { "filter": { "all": "すべて選択" } },
    "change": { "confirmation": "アセットバインディングの変更の概要" },
    "binding": { "status": "材料の結合状態" },
    "compositeSetting": {
      "invalidHint": "素材の再生サイズ設定に誤りがあります。システム管理者に販売チャネル設定の確認を依頼してください。"
    },
    "status": {
      "enable": "有効にする",
      "disable": "無効化",
      "waitingActivate": "アクティブ",
      "waitingDeactivate": "無効化",
      "default": "アクティブ",
      "processing": "処理",
      "processingFailed": "処理に失敗しました",
      "archived": "アーカイブ済み"
    }
  },
  "creativeOverviewState": {
    "labels": {
      "activeSuccess": "マテリアルが有効",
      "activeFailed": "素材の活性化エラー",
      "deactiveSuccess": "材料は非活性化されました",
      "deactiveFailed": "材料の不活性化エラー"
    }
  },
  "creativeSummaryState": {
    "labels": {
      "modifySuccess": "マテリアルバインディングの変更が完了しました"
    }
  },
  "orderHome": {
    "labels": { "title": "注文と広告", "advertiserListTitle": "広告主" }
  },
  "recentGroupDropdown": {
    "labels": {
      "useRecently": "最近使用した",
      "otherAdvertiserId": "その他の広告主",
      "otherMerchantId": "その他の商家",
      "otherAgencyId": "その他のディーラー",
      "otherRestaurantId": "その他のレストラン",
      "otherBeaconConnectionId": "その他の公式アカウント"
    }
  },
  "groupOptionsSelection": {
    "labels": {
      "selectAllAdvertiserId": "すべての広告主",
      "selectAllMerchantId": "すべての商家",
      "selectAllAgencyId": "すべてのディーラー",
      "selectAllRestaurantId": "すべてのレストラン",
      "selectAllBeaconConnectionId": "すべての公式アカウント",
      "pleaseChooseAdvertiserId": "広告主を選択してください...",
      "pleaseChooseMerchantd": "商家を選択してください...",
      "pleaseChooseAgencyId": "ディーラーを選択してください...",
      "pleaseChooseRestaurantId": "レストランを選択してください...",
      "pleaseChooseBeaconConnectionId": "公式アカウントを選択してください...",
      "searchAdvertiserId": "広告主名を検索...",
      "searchMerchantId": "商家名を検索...",
      "searchAgencyId": "ディーラー名を検索…",
      "searchRestaurantId": "レストラン名を検索…",
      "searchBeaconConnectionId": "公式アカウント名を検索…"
    }
  },
  "orders": { "labels": { "newOrder": "+ 注文" } },
  "modifyCreativeActivationStateContent": {
    "labels": {
      "chooseActivate": "活性化する材料を選択する",
      "chooseDeactivate": "無効化したい素材を選択してください"
    }
  },
  "downloadReportPanel": {
    "labels": {
      "cpmClosingReport": "CPM決算報告",
      "cpcClosingReport": "CPC事件終結報告書",
      "normal": "カスタマイズされたレポート",
      "closing": "事件終結報告書",
      "downloadReport": "ダウンロード",
      "downloadOutdoorReport": "Outdoor レポートのダウンロード",
      "dateRange": "注文配信期間",
      "reportType": "レポートの種類",
      "advance": "カスタムフィールドレポート",
      "dataContent": "文書の内容",
      "quickSelect": "クイックピック",
      "videoAdViewObjective": "ビデオを見る",
      "cpmOption": "CPM価格設定",
      "cpcOption": "CPC価格設定",
      "cpaOption": "CPA価格設定",
      "videoOption": "視聴覚広告",
      "outdoorOption": "屋外広告",
      "outdoorDeviceOption": "屋外機広告情報",
      "outdoorDeviceBeaconOption": "屋外機広告情報(Line Simple Beacon)",
      "lineMessageOption": "Line Message 報告",
      "rawDataOption": "元データ",
      "reset": "初期状態に戻す",
      "firstQuartile": "25%を見る",
      "midPoint": "50%を見る",
      "thirdQuartile": "75%を見る",
      "complete": "100%視聴",
      "audienceData": "視聴者情報",
      "gender": "性別",
      "age": "年",
      "interest": "興味",
      "impress": "インプレッション数",
      "viewable": "ビューアブルインプレッション数",
      "uu": "リピーターなし",
      "click": "クリック数",
      "ctr": "クリックスルー率",
      "viewableCtr": "視認可能なクリックスルー率",
      "adView": "閲覧数",
      "viewRate": "視聴率",
      "viewableViewRate": "視聴可能視聴率",
      "convs": "変換番号",
      "spent": "消化金額",
      "cpm": "インプレッション単価",
      "cpc": "クリック単価",
      "cpv": "CPV",
      "cpa": "公認会計士",
      "groupBy": "グループ化",
      "groupByCreative": "素材",
      "groupByCampaign": "キャンペーン",
      "groupByL1Object": "広告グループ",
      "audienceDataHint": "オーディエンス データは注文期間全体の累積データであり、カスタム日付範囲の影響を受けません。",
      "beaconEvents": "ビーコンデータ",
      "ePublisherImpres": "人数",
      "acpm": "aCPM",
      "acpmOption": "aCPM価格設定",
      "country": "市",
      "domain": "ドメイン",
      "deliveryBrief": "配信データ簡易レポート",
      "reportDateRange": "レポート期間",
      "format": "形式",
      "uniqueUserCount": "ユニークユーザー数",
      "averageViewRate": "平均視聴率",
      "averageCtr": "平均クリック率"
    },
    "buttons": { "download": "ダウンロード" },
    "placeholders": { "reportType": "レポートの種類を選択" },
    "errors": {
      "fieldRequired": "{{field}}: {{checkedDependentFields}} にはこのフィールドに関する情報が必要です",
      "dateRangeOutOfOrderPeriod": "期間は注文の配信期間内で指定してください（{{start}} ~ {{end}}）"
    }
  },
  "limitationOptions": {
    "labels": {
      "gender": { "1": "男性", "2": "女性" },
      "spaceType": { "1": "ウェブページ", "2": "モバイルアプリ" },
      "carrier": {
        "chunghwa": "中華電信",
        "taiwan_mobile": "台湾モバイル",
        "far_eastone": "ファー・イーストーン・テレコミュニケーションズ",
        "taiwan_star": "台湾スター",
        "asia_pacific": "アジアパシフィックテレコム",
        "viettel": "ベトテル",
        "mobifone": "モビフォン",
        "vinaphone": "ヴィナフォン",
        "vietnamobile": "ベトナムモバイル"
      },
      "contentlang": {
        "zh": "中国語",
        "en": "英語",
        "vi": "ベトナム語",
        "th": "泰文",
        "es": "スペイン語",
        "ja": "日本語",
        "mg": "マレー語",
        "ko": "韓国語",
        "id": "インドネシア語"
      },
      "device": {
        "2": "コンピューター",
        "3": "コネクテッドテレビ",
        "4": "携帯電話",
        "5": "フラット",
        "6": "インターネット接続デバイス",
        "7": "デジタルビデオコンバータボックス",
        "smartphone": "携帯電話",
        "tablet": "フラット"
      }
    }
  },
  "tenmaxCategory": {
    "labels": {
      "others": "その他",
      "3c": "デジタル・ガジェット",
      "telecom": "通信・キャリア",
      "home_appliance": "家電製品",
      "mobile_app": "モバイルアプリ",
      "computer_software": "ソフトウェア",
      "pharmacy": "ヘルスケア・健康",
      "diet": "ダイエット・ボディケア",
      "medical_care": "医療",
      "career": "求人・キャリア",
      "e_commerce": "オンラインショッピング",
      "shopping": "実店舗・リテール",
      "aviation": "航空",
      "travel": "旅行",
      "baby": "ベビー・キッズ・ママ",
      "automobile": "自動車とオートバイ",
      "automobile1": "自動車・クルマ",
      "insurance": "保険",
      "real_estate": "不動産",
      "loan": "ローン・キャッシング",
      "investment": "投資する",
      "investment_activities": "投資・資産運用",
      "credit_card": "クレジットカード",
      "media": "インターネットコミュニティ",
      "social_media": "ソーシャルメディア・SNS",
      "dessert": "スイーツ・菓子",
      "restaurant": "グルメ・レストラン",
      "wine": "お酒・アルコール",
      "home_decoration": "インテリア・住まい",
      "cook": "料理・クッキング",
      "cleaning": "掃除用品",
      "beverage": "ドリンク",
      "snack": "スナック・お菓子",
      "fast_food": "ファストフード",
      "science": "新しい科学的知識",
      "science_activity": "科学・サイエンス",
      "books": "グラフィックアート",
      "graphic_art": "グラフィックアート",
      "cosmetics": "コスメ・スキンケア",
      "women_clothing": "レディースファッション",
      "men_clothing": "メンズファッション",
      "luxary": "ラグジュアリー・高級ブランド",
      "beauty": "ビューティー",
      "accessory": "ファッション小物",
      "surgery": "美容整形・美容医療",
      "news": "ニュース",
      "government": "政党政権",
      "government_communications": "政府広報",
      "politics": "社会問題",
      "regime": "政治",
      "pet": "ペット",
      "toy": "フィギュア",
      "music": "音楽",
      "movie": "映画",
      "outdoor_activities": "アウトドア",
      "drama": "ドラマ・番組",
      "game": "ゲーム",
      "sport": "スポーツ",
      "society": "ソーシャル・交流",
      "sexuality": "アダルトグッズ",
      "exhibition": "展示会・イベント",
      "immigration": "移住・移民サービス",
      "motobike": "バイク・オートバイ",
      "saas": "SaaS",
      "social_issue": "社会問題",
      "social_welfare": "社会貢献・非営利",
      "technology_art": "メディアアート",
      "iab1": "芸術とエンターテイメント",
      "iab19": "コンピューター＆エレクトロニクス",
      "iab13": "ファイナンス",
      "iab9_30": "ゲーム",
      "iab10": "ホーム＆ガーデン",
      "iab3": "ビジネスと産業",
      "iab19_18": "インターネットと通信",
      "iab14_1": "人々と社会",
      "iab12": "ニュース",
      "iab22": "買い物",
      "iab11": "法律と政府",
      "iab17": "スポーツ",
      "iab1_1": "書籍と文学",
      "iab21": "不動産",
      "iab14": "オンラインコミュニティ",
      "iab18": "美容とフィットネス",
      "iab7": "健康",
      "iab2": "自動車と車両",
      "iab4": "仕事と教育",
      "iab9": "趣味とレジャー",
      "iab16": "ペットと動物",
      "iab20": "旅行・トラベル",
      "iab8": "食べ物と飲み物",
      "iab19-12": "参照",
      "iab15": "科学",
      "logistics": "運輸・デリバリー",
      "education": "教育・学習",
      "wedding": "ブライダル・結婚",
      "daily_necessities": "日用品・生活雑貨",
      "shoes": "靴・シューズ",
      "women_talk": "女性向けトピック\"",
      "energy": "エネルギー"
    }
  },
  "creativeSetupFlow": {
    "labels": {
      "advertiser": "広告主",
      "nextStep": "次のステップ",
      "name": "素材名",
      "title": "広告タイトル",
      "desc": "広告の説明",
      "message": "広告メッセージ",
      "shortMessage": "広告メッセージ（短）",
      "landingPageUrl": "対象ページのURL",
      "sponsor": "スポンサー",
      "sponsorLink": "スポンサーリンク",
      "videoPlacement": "広告の配置",
      "creativeType": "素材タイプ",
      "tenmaxCategory": "素材カテゴリ",
      "remainingCharacters": "{{num}}文字を入力できます",
      "openLinkHint": "リンクを開く",
      "creativeBasicInfo": "材料に関する基本情報",
      "agencyId": "ディーラー番号",
      "enableNativeBanner": "画像ベースの資料を生成する",
      "image": "画像アーカイブ",
      "enableStartTime": "開始時間",
      "enableEndTime": "終了時間",
      "outdoorHtml": "HTML圧縮ファイル",
      "customLayout": "手彫りバージョン",
      "bannerUrl": "リンクURL",
      "rtbBannerUrl": "RTBリンクURL",
      "analyzingHint": "分析中...",
      "sponsoredBy": "スポンサー",
      "imageCreativeTypeHint": "JPG、PNG、GIF形式を使用できます",
      "typeHint": "JPGまたはPNG形式で利用可能",
      "comboImagetypeHint": "JPGまたはPNG形式を使用できます",
      "videoTypeHint": "MP4ビデオ形式のみ利用可能です",
      "videoDurationHint": "最長120秒の動画が使用可能",
      "sizeHint": "画像の比率は {{proportion}}、サイズは少なくとも {{size}} である必要があります",
      "storageHint": "ファイルサイズは{{storage}}より小さくなければなりません",
      "successHint": "アップロード成功",
      "audioSuccessHint": "サウンドが正常にアップロードされました",
      "fileUploadSuccessHint": "ファイルのアップロードに成功しました",
      "videoSuccessHint": "ビデオが正常にアップロードされました",
      "sizeErrorHint": "画像サイズは {{size1}} です。{{size2}} より大きい（等しい）必要があります。",
      "proportionErrorHint": "この画像の比率は {{proportion1}} ですが、{{proportion2}} である必要があります",
      "typeErrorHint": "画像形式は{{type}}形式で、jpgまたはpngである必要があります",
      "imageCreativeTypeErrorHint": "画像形式は {{type}} 形式で、jpg、png、または gif である必要があります。",
      "storageErrorHint": "ファイルサイズは {{storage1}} です。これは {{storage2}} より小さくなければなりません。",
      "zipContentError": "圧縮ファイルにはindex.htmlが含まれている必要があります",
      "rectImg": "ワイド画像アーカイブ",
      "squareImg": "スクエアチャートアーカイブ",
      "dragdropHint": "ファイルをドラッグアンドドロップするか、選択してください",
      "videoDurationError": "ビデオの最大長さは120秒を超えてはなりません",
      "creatives": "素材庫",
      "creativeBinding": "マテリアルプレビュー",
      "createSuccess": "成功を築く",
      "updateSuccess": "更新成功",
      "createCreative": "新規作成",
      "editCreative": "編集素材",
      "creativeId": "素材 ID",
      "cancelUpdate": "変更をキャンセル",
      "updateManually": "手動変更",
      "bannerSize": "素材サイズ",
      "maxCardsCount": "表示される商品カードの最大数",
      "autoAnimationSeconds": "自動回転秒針",
      "autoAnimationSeconds_postText": "自動カルーセル後",
      "showAdvanceSetting": "展開",
      "closeAdvanceSetting": "崩壊",
      "displaySize": "広告サイズ",
      "layoutId": "パターンID",
      "subLayout": "サブバージョン",
      "adServingUrl": "第三方動画",
      "videoDuration": "動画の長さ",
      "skippableSetting": "広告をスキップする設定",
      "imageSizeErrorHint": "画像サイズ {{size}} はサポートされていません。サポートされているサイズを確認するには、サイズの説明ボタンをクリックしてください。",
      "imagePreview": "画像プレビュー",
      "htmlSnippet": "AdNeonコード",
      "outdoorType": "屋外広告の種類",
      "imageSizeHint": "画像サイズは{{size}}である必要があります",
      "outdoorDuration": "素材の再生時間",
      "creativeSize": "素材サイズ",
      "lineBeaconServiceType": "Line ステータス",
      "lineBeaconHardwareId": "ハードウェアID",
      "lineBotChannelSecret": "チャンネルシークレット",
      "lineBotChannelAccessToken": "チャネルアクセストークン",
      "orderName": "注文名",
      "orderBudget": "注文予算",
      "orderSchedule": "注文の予想配達日",
      "sizeErrorHint2": "画像サイズは {{size1}} で、{{size2}} と同じである必要があります",
      "audioTypeHint": "MP3形式で利用可能",
      "audio": "サウンドアーカイブ",
      "outdoorAudioSwitch": "サウンドファイルの使用",
      "videoSizeHint": "動画のサイズは{{size}}である必要があります",
      "videoSizeErrorHint2": "このビデオのサイズは {{size1}} です。これは {{size2}} と同じである必要があります。",
      "callToAction": "行動喚起",
      "deepLink": "ディープリンク（オプション）",
      "layout": "配置タイプ",
      "imageMultipleSizeErrorHint": "一部の画像ファイルサイズはサポートされていません。サイズの説明ボタンをクリックして、サポートされているサイズをご確認ください。",
      "storageMultipleErrorHint": "一部のファイルは {{storage}} より大きいです",
      "imageMultipleTypeErrorHint": "一部の画像はjpg、png、gif形式ではありません",
      "images": "画像アーカイブ",
      "oneForAllRectImg": "ワイド画像ファイル（オプション）",
      "outdoorVideoSizeErrorHint": "動画サイズ {{size}} はサポートされていません。サポートされているサイズを確認するには、素材情報リマインダーボタンをクリックしてください。",
      "outdoorImageSizeErrorHint": "画像サイズ {{size}} はサポートされていません。サポートされているサイズを確認するには、素材情報リマインダーボタンをクリックしてください。",
      "videoCodecHint": "このチャネルが対応するビデオエンコード：{{codecs}}"
    },
    "placeholders": {
      "chooseAdvertiser": "広告主を選択",
      "landingPageUrlHint": "リンクURLを入力すると自動的に読み込まれます"
    },
    "titles": { "advancedSetting": "詳細設定" }
  },
  "formValidate": {
    "labels": {
      "remainingCharacters": "{{num}}文字を入力できます",
      "needUrl": "http://を含むURLを入力してください",
      "maximumError": "値は{{max}}以下である必要があります",
      "minimumError": "値は{{min}}以上である必要があります",
      "emptyError": "まだ空白です!",
      "integerError": "整数である必要があります",
      "maximumLengthError": "長さは{{max}}以下である必要があります",
      "invalidValueError": "このオプションは利用できなくなりました。",
      "validWordsError": "文字および句読点のみ入力できます",
      "invalidEmail": "@ と を含むメール形式を入力してください。",
      "emailRequired": "メールアドレスを入力してください"
    }
  },
  "creativeType": {
    "image": "RTBイメージ広告",
    "html": "HTML広告",
    "html5": "HTML広告",
    "native": "ネイティブ広告",
    "video": "動画広告",
    "dynamic": "ダイナミック広告",
    "flash": "フラッシュ広告",
    "thirdParty": "サードパーティの広告",
    "combo": "ビデオ+画像広告",
    "edimax": "エディマックス屋外広告",
    "picShort": "PIC屋外15秒広告",
    "picLong": "PIC屋外30秒広告",
    "picExtended": "PIC屋外60秒広告",
    "picBroad": "PIC屋外60秒以上の広告",
    "hwacomShort": "HwaCom15秒広告",
    "hwacomLong": "HwaCom30秒広告",
    "hwacomExtended": "HwaCom60秒広告",
    "hwacomBroad": "HwaCom60秒以上の広告",
    "fridgeBroad": "60秒以上の屋外冷凍庫広告",
    "fridgeLong": "30秒の屋外冷凍庫広告",
    "fridgeExtended": "60秒の屋外冷凍庫広告",
    "imageAds": "RTBイメージ広告",
    "htmlAds": "HTML広告",
    "nativeAds": "ネイティブ広告",
    "videoAds": "動画広告",
    "dynamicAds": "ダイナミック広告",
    "flashAds": "フラッシュ広告",
    "thirdPartyAds": "アドネオン広告",
    "comboAds": "ビデオ+画像広告",
    "picShortAds": "PIC屋外15秒広告",
    "picLongAds": "PIC屋外30秒広告",
    "picExtendedAds": "PIC屋外60秒広告",
    "picBroadAds": "PIC屋外60秒以上の広告",
    "fridgeBroadAds": "60秒以上の屋外冷凍庫広告",
    "fridgeLongAds": "30秒の屋外冷凍庫広告",
    "fridgeExtendedAds": "60秒の屋外冷凍庫広告",
    "oneForAllDisplay": "ワン・フォー・オール - ディスプレイ広告",
    "oneForAllDisplayIos": "One For All - ディスプレイ広告（iOS）",
    "oneForAllDisplayAndroid": "One For All - ディスプレイ広告（Android）",
    "custom": "カスタマイズされた広告",
    "ctv": "デジタルテレビ広告",
    "customBottom": "手彫りの下部広告",
    "customRectangle": "手彫りの中型長方形広告",
    "sandboxOutdoor": "R&Dテストユーザー屋外広告",
    "outdoorLineMessage": "Outdoor Line Message 広告",
    "lineMessage": "Line Message 広告",
    "oneForAllVideo": "ワン・フォー・オール - 動画広告",
    "oneForAllVideoIos": "One For All - 動画広告（iOS）",
    "oneForAllVideoAndroid": "One For All - 動画広告（Android）"
  },
  "yahooIDInput": {
    "labels": { "title": "Verizon広告IDを入力してください" },
    "placeholders": {
      "tags": "Verizon 広告 ID を入力した後、Enter キーを使用して別の広告 ID を追加します..."
    }
  },
  "creativeBindStatusPage": {
    "headers": {
      "id": "キャンペーンID",
      "name": "キャンペーン名",
      "effectiveStatus": "キャンペーン配送状況",
      "bindState": "材料の結合状態"
    },
    "labels": {
      "noData": "まだキャンペーンがリンクされていません",
      "active": "有効にする",
      "inactive": "無効化"
    }
  },
  "creativeBindingStatusPage": { "title": "広告素材情報" },
  "creativesHome": {
    "labels": {
      "title": "素材",
      "agencyListTitle": "ディーラー",
      "advertiserListTitle": "広告主"
    },
    "titles": { "createCreativeErrorModal": "一部の資料を作成できませんでした" }
  },
  "creativeReview": {
    "labels": {
      "pending": "審査待ち",
      "approved": "承認する",
      "denied": "拒否する",
      "fixed": "修正済み",
      "new": "審査待ち",
      "reviewHint": "レビューのための資料提出",
      "incompleted": "未完成",
      "deleted": "削除済み",
      "stateTitle": "ステータス：",
      "stateUpdateTime": "最後更新時間：",
      "tenmaxCategoryChange": "TenmaxCategoryはSSPによって変更されました",
      "tenmaxCategoryFrom": "開始日:",
      "tenmaxCategoryTo": "変更後:",
      "categoryChangeHint": "この材料は、修正された素材カテゴリで配送されるようになります。",
      "banAttribute800": "女性向けファッションサイトには適していません",
      "banAttribute810": "広告画像は女性向けファッションウェブサイトには適していません",
      "banAttribute811": "広告画像にテキストが含まれています",
      "banAttribute812": "広告主のロゴが広告画像に含まれている",
      "banAttribute813": "広告画像には広告対象商品がはっきりと表示されている",
      "banAttribute820": "広告タイトルは女性向けファッションウェブサイトには適していません",
      "banAttribute821": "広告タイトルは明らかに商業的だ",
      "banAttribute822": "ポルノ、暴力、テロなどの否定的な言葉を含む広告タイトル",
      "banAttribute700": "広告にはアダルトコンテンツが含まれています",
      "partialBanTitle": "トラフィックが拒否される理由には次のようなものがあります:",
      "partialBanHint": "このクリエイティブは、準拠している広告スペースに引き続き配信されます。",
      "missingReviewDataHint": "この資料には審査に必要な情報が不足しています。この資料を再編集し、不足している情報を記入してください。"
    },
    "lables": {
      "titkokWaitingForCreate": "オーディエンスをパッケージ化するのに最大 24 時間かかる場合がありますので、後でもう一度ステータスを確認してください。"
    }
  },
  "report": {
    "labels": {
      "reportType": "レポートの種類",
      "reportGran": "配信期間",
      "performanceType": "一般広告",
      "videoType": "視聴覚広告",
      "messageType": "SMS広告",
      "outdoorType": "屋外広告",
      "lineMessageType": "Line Message",
      "month": "月",
      "day": "日",
      "hour": "時間",
      "+0800": "UTC+8",
      "+0700": "UTC+7",
      "+0900": "UTC+9",
      "reconciliationTitle": "ディーラー調整レポート",
      "performanceTitle": "広告効果",
      "beaconMessageTitle": "Beacon 広告効果",
      "filterCondition": "フィルター",
      "agencyId": "ディーラー",
      "advertiserId": "広告主",
      "adsOrderId": "注文",
      "campaignId": "キャンペーン",
      "creativeId": "素材",
      "creativeType": "素材カテゴリ",
      "creativeSize": "素材サイズ",
      "isSelfBuy": "独自のトラフィック",
      "deviceType": "デバイスタイプ",
      "salesChannel": "配信チャネル",
      "dimentSelectArea": "レポートフィルター条件",
      "reportChartArea": "チャート",
      "download": "ダウンロード",
      "adType": "キャンペーンタイプ",
      "useAppsflyerConversion": "Appsflyerのコンバージョンデータを表示する",
      "withoutPerformance": "現在のオプションには結果データがありません",
      "mrt": "重要なMRT駅",
      "l3ChannelId": "広告する",
      "l2ChannelId": "キャンペーン",
      "l2ObjectId": "キャンペーン",
      "l1ObjectId": "広告グループ"
    },
    "buttons": { "search": "検索" },
    "titles": { "salesChannelReconciliation": "配信チャネル調整レポート" },
    "hints": {
      "salesChannelReconciliation": "毎日のデータは元の配送情報に応じて変更されます。前月の最終データは毎月2日以降にご確認いただけます。"
    }
  },
  "reportTable": {
    "labels": {
      "dayDimension": "日付",
      "agencyIdDimension": "ディーラー",
      "advertiserIdDimension": "広告主",
      "adsOrderIdDimension": "注文",
      "campaignIdDimension": "キャンペーン",
      "adTypeDimension": "キャンペーンタイプ",
      "creativeIdDimension": "素材",
      "creativeTypeDimension": "素材カテゴリ",
      "creativeSizeDimension": "素材サイズ",
      "isSelfBuyDimension": "独自のトラフィック",
      "deviceTypeDimension": "デバイスタイプ",
      "salesChannelDimension": "配信チャネル",
      "mrtDimension": "重要なMRT駅",
      "adsOrderIdLinkHint": "注文の詳細を見る",
      "campaignIdLinkHint": "キャンペーンの詳細を見る",
      "l2ObjectIdLinkHint": "キャンペーンの詳細を見る",
      "creativeIdLinkHint": "素材の詳細を見る",
      "alertModalContent": "セルフサービングで作成/編集されたクリエイティブは、プラットフォームのクリエイティブ カテゴリに分類し直すこ​​とができないため、クリエイティブ カテゴリ ディメンションに切り替えると、データの合計が不一致になる可能性があります。",
      "alertModalTitle": "レポートビューのディメンションを切り替える",
      "l3ChannelIdDimension": "広告する",
      "l2ChannelIdDimension": "キャンペーン",
      "l2ObjectIdDimension": "キャンペーン",
      "l1ObjectIdDimension": "広告グループ",
      "l1ObjectIdLinkHint": "広告グループの詳細を表示",
      "l2ChannelIdLinkHint": "キャンペーンの詳細を見る",
      "l3ChannelIdLinkHint": "広告の詳細を見る"
    },
    "placeholders": {
      "searchDate": "検索日...",
      "searchName": "名前を検索..."
    },
    "headers": {
      "name": "名前",
      "date": "日付",
      "impres": "インプレッション数",
      "clicks": "クリック数",
      "ctr": "クリックスルー率",
      "messageCTR": "視認可能なクリックスルー率",
      "viewable": "ビューアブルインプレッション数",
      "vctr": "視認可能なクリックスルー率",
      "cpm": "インプレッション単価",
      "acpm": "1CPM",
      "cpc": "クリック単価",
      "cpa": "コンバージョン単価",
      "convs": "変換番号",
      "conv_1": "1日以内のコンバージョン数",
      "conv_7": "7日以内のコンバージョン",
      "cvr": "コンバージョン率",
      "mediaCost": "メディア費用（{{currency}}）",
      "mediaSpent": "メディア料金（{{currency}}）",
      "agcProfit": "ディーラーの利益（{{currency}}）",
      "sysProfit": "システム利益（{{currency}}）",
      "dataCost": "データ料金（{{currency}}）",
      "spent": "消化金額（{{currency}}）",
      "adView": "閲覧数",
      "viewRate": "視聴率",
      "viewableViewRate": "視聴可能視聴率",
      "cpv": "CPV",
      "skipCount": "スキップ回数",
      "firstQuartile": "視聴率（25％）",
      "midpoint": "視聴率（50％）",
      "thirdQuartile": "視聴率（75％）",
      "complete": "視聴率（100％）",
      "tags": "カスタムラベル",
      "messageSend": "一般的な露出数",
      "messageArrived": "ビューアブルインプレッション数",
      "ePublisherImpres": "来店者数",
      "beaconEvents": "ビーコンデータ",
      "beacon": "ビーコン発信回数",
      "messageCount": "ビーコンメッセージ配信数",
      "uu": "リピーターなし"
    },
    "footers": { "total": "合計" }
  },
  "deviceType": {
    "computer": "コンピューター",
    "tablet": "フラット",
    "phone": "携帯電話",
    "unknown": "不明なデバイス"
  },
  "advertiserHome": {
    "labels": { "title": "広告主", "agencyOptionsTitle": "ディーラー" }
  },
  "advertiserList": {
    "headers": {
      "id": "広告主名とID",
      "category": "プリセット素材カテゴリ",
      "website": "公式ウェブサイト"
    },
    "labels": {
      "nodata": "現在、広告主がいません。新しい広告主を追加するには、「+ 広告主」をクリックしてください。",
      "newAdvertiser": "+ 広告主",
      "editHint": "広告主を編集"
    },
    "placeholders": { "searchbar": "広告主名とIDを検索..." }
  },
  "advertiserForm": {
    "labels": {
      "createTitle": "新しい広告主を追加する",
      "editTitle": "広告主を編集",
      "name": "広告主名",
      "website": "公式ウェブサイト",
      "category": "プリセット素材カテゴリ",
      "note": "その他の注意事項",
      "id": "広告主ID",
      "publisher": "パブリッシャー"
    }
  },
  "advertiserDetail": {
    "labels": {
      "title": "広告主と会員一覧",
      "name": "広告主名: {{name}}",
      "id": "広告主ID",
      "website": "公式ウェブサイト",
      "publisher": "パブリッシャー",
      "category": "プリセット素材カテゴリ",
      "note": "その他の注意事項",
      "advertiserSegmentSource": "その他の広告主オーディエンス",
      "editAdvertiser": "広告主を編集",
      "segmentSource": "その他の広告主オーディエンスソース"
    },
    "tabs": {
      "member": "メンバー",
      "advertiserMemberList": "メンバー",
      "beaconConnectionList": "ビーコン接続方法"
    }
  },
  "advertiserMemberList": {
    "labels": {
      "nodata": "現在メンバーがいません。「+ メンバー」をクリックして新しいメンバーを追加してください。",
      "newAdvertiserMember": "+ メンバー",
      "deleteModalTitle": "ロール権限の削除",
      "deleteModalContent": "選択したロール権限を削除してもよろしいですか?",
      "deleteAccountMemberSuccess": "役割権限が正常に削除されました",
      "createAccountMemberSuccess": "新しいロール権限が正常に追加されました",
      "editAccountMemberSuccess": "ロール権限の更新に成功しました",
      "editHint": "編集委員",
      "deleteHint": "削除権限",
      "newAccount": "+ アカウント"
    },
    "placeholders": { "searchbar": "メンバー名またはメールアドレスで検索..." },
    "permissions": {
      "ROLE_ADV_ADMIN": "広告主 - 広告マネージャー",
      "ROLE_ADV_REPORT": "広告主 - 広告クライアント",
      "ROLE_ADV_SALES": "広告主 - 広告事業"
    },
    "headers": {
      "emailColumn": "電子メール",
      "nameIdColumn": "名前",
      "statusColumn": "ステータス",
      "permissionColumn": "権限"
    }
  },
  "advertiserMemberForm": {
    "labels": {
      "email": "電子メール",
      "role": "権限",
      "role_adv_admin": "広告主│広告運用担当者ー-担当する広告主の案件を管理する",
      "role_adv_report": "広告主│クライアント-自社の広告配信成果の閲覧",
      "role_adv_sales": "広告主│営業担当者-担当する広告主の案件情報と成果の閲覧",
      "createMember": "新しい広告主メンバーを追加する",
      "editMember": "広告主メンバーを編集"
    }
  },
  "adLogoForm": {
    "labels": {
      "title": "広告ロゴ",
      "logoType": "Logo 種類",
      "logoLink": "連結",
      "logoUpload": "アップロード",
      "typeErrorHint": "画像形式は{{type}}形式で、jpgまたはpngである必要があります",
      "sizeErrorHint": "画像サイズは {{size1}} で、{{size2}} と同じである必要があります",
      "default": "デフォルト",
      "custom": "カスタム",
      "null": "なし",
      "sizeHint": "画像サイズが50×50であることを確認してください",
      "logoPreview": "広告ロゴプレビュー",
      "logoHint": "広告ロゴはイメージ広告とネイティブ広告にのみ表示されます"
    }
  },
  "adDeclarationForm": { "labels": { "title": "広告文をアップロードする" } },
  "segmentHome": {
    "labels": {
      "title": "リターゲティング",
      "agencyListTitle": "ディーラー",
      "advertiserListTitle": "広告主"
    }
  },
  "segmentList": {
    "placeholders": {
      "searchbar": "リマーケティング オーディエンス名または ID を検索..."
    },
    "labels": {
      "newSegment": "+ リマーケティングオーディエンス",
      "nodata": "現在、リマーケティング ユーザーリストがありません。「+ リマーケティング ユーザーリスト」をクリックして追加してください。",
      "chooseAgency": "まずディーラーを選択してください",
      "duration": "{{days}}日",
      "deleteModalTitle": "リマーケティングオーディエンスを削除する",
      "deleteModalContent": "選択したリマーケティング ユーザーリストとそのすべてのサブリマーケティング ユーザーリストを削除してもよろしいですか?",
      "editHint": "リマーケティングオーディエンスを編集する",
      "deleteHint": "リマーケティングオーディエンスを削除する",
      "deleteSuccess": "リマーケティングオーディエンスを削除しました"
    },
    "headers": {
      "nameIdColumn": "リマーケティングオーディエンス名",
      "durationColumn": "ライフサイクル",
      "segmentCountColumn": "観客",
      "subSegmentAmountColumn": "リマーケティングオーディエンスの数"
    }
  },
  "segmentForm": {
    "labels": {
      "createTitle": "新しいリマーケティングオーディエンスを追加する",
      "editTitle": "リマーケティングオーディエンスを編集する",
      "advertiser": "広告主",
      "name": "リマーケティングオーディエンス名",
      "duration": "ライフサイクル",
      "durationUnit": "日",
      "durationLimit": "期間は30日から365日まで設定できます"
    }
  },
  "segmentDetail": {
    "labels": {
      "dmpId": "リマーケティングオーディエンスコード",
      "duration": "ライフサイクル",
      "segmentCount": "観客",
      "name": "リマーケティング ユーザーリスト名: {{name}}",
      "title": "リマーケティングオーディエンス情報",
      "editSegment": "リマーケティングオーディエンスを編集する",
      "code": "コード",
      "import": "インポートオーディエンス",
      "reset": "オーディエンスをリセット",
      "export": "エクスポートオーディエンス",
      "importSuccess": "オーディエンスのインポートに成功しました",
      "resetSuccess": "視聴者を正常にリセットしました",
      "exportSuccess": "オーディエンスのエクスポートに成功しました",
      "fileSizeErrorModalTitle": "ファイルサイズが大きすぎます",
      "fileSizeErrorModalContent": "オーディエンスをインポートします。ファイルサイズは {{bytes}} バイト未満である必要があります。",
      "importCookies": "クッキー",
      "importDeviceIds": "モバイルデバイスID"
    }
  },
  "segmentCode": {
    "labels": {
      "id": "リマーケティングオーディエンスコード",
      "code": "リマーケティングオーディエンス収集コード",
      "codeHint": "このトラッキングコードは、ウェブサイト管理者がオーディエンス情報を取得する目的などでウェブサイトのフッターに設置することで初めて有効になります。",
      "codeType": "コードタイプ",
      "jsCode": "JSトラッキングコード",
      "imageCode": "画像トラッキングコード"
    }
  },
  "codePage": {
    "labels": {
      "privacy": "プライバシーに関する声明",
      "privacyStatement": "このトラッキングコードは主に、ユーザーの行動を追跡し、サードパーティの広告プラットフォームや分析プラットフォーム（Facebook、AdWords、Google Analyticsなど）へのイベント転送を容易にし、コンバージョン効果を追跡するために使用されます。TenMaxの<1>プライバシーポリシー</1>をご確認ください。このコードをウェブサイトに配置することで、規約に同意したものとみなされます。",
      "copyCodeSuccess": "コードをコピーしました"
    }
  },
  "subSegmentList": {
    "labels": {
      "newSegment": "+ サブリマーケティングオーディエンス",
      "nodata": "現在、サブリマーケティング ユーザーリストがありません。「+ サブリマーケティング ユーザーリスト」をクリックして、追加を開始してください。",
      "deleteModalTitle": "子供のリマーケティングオーディエンスを削除する",
      "deleteModalContent": "選択したサブリマーケティング ユーザーリストを削除してもよろしいですか?",
      "editHint": "リマーケティングオーディエンスを編集する",
      "exportHint": "リマーケティングオーディエンスをエクスポートする",
      "deleteHint": "子供のリマーケティングオーディエンスを削除する",
      "deleteSuccess": "リマーケティングオーディエンスを削除しました"
    },
    "headers": {
      "nameIdColumn": "サブリマーケティングオーディエンス名",
      "dmpSegmentIdColumn": "サブリマーケティングオーディエンスコード",
      "segmentCountColumn": "観客",
      "ruleContentColumn": "ウェブサイトの利用規約"
    },
    "placeholders": {
      "searchbar": "子供のリマーケティング ユーザーリストの名前または ID を検索します..."
    }
  },
  "segmentRuleComparator": {
    "labels": {
      "contains": "含む",
      "equals": "等しい",
      "starts_with": "開始",
      "ends_with": "終了",
      "does_not_equal": "等しくない",
      "does_not_contain": "含まれません",
      "does_not_start_with": "開始しない",
      "does_not_end_with": "終わらない",
      "regex": "通常の表現"
    }
  },
  "subSegmentForm": {
    "labels": {
      "createTitle": "新しいリマーケティングオーディエンスを追加する",
      "editTitle": "リマーケティングオーディエンスを編集する",
      "name": "サブリマーケティングオーディエンス名",
      "ruleContent": "高度なフィルター - URL条件",
      "filterRules": "フィルター",
      "ruleContentEmptyError": "有効なウェブサイト条件を少なくとも 1 つ追加してください"
    }
  },
  "conversionHome": {
    "labels": {
      "title": "コンバージョントラッキング",
      "agencyListTitle": "ディーラー",
      "advertiserListTitle": "広告主"
    }
  },
  "conversionForm": {
    "labels": {
      "createTitle": "コンバージョントラッキングを追加しました",
      "editTitle": "コンバージョントラッキングを編集する",
      "advertiser": "広告主",
      "name": "コンバージョントラッキング名",
      "type": "種類"
    }
  },
  "conversionList": {
    "labels": {
      "newConversion": "+ コンバージョントラッキング",
      "nodata": "現在、コンバージョン トラッキングが設定されていません。「+ コンバージョン トラッキング」をクリックして追加してください。",
      "chooseAgency": "まずディーラーを選択してください",
      "editHint": "コンバージョントラッキングを編集する",
      "codeHint": "コンバージョントラッキングコード"
    },
    "placeholders": {
      "searchbar": "コンバージョン トラッキング名または ID を検索..."
    },
    "headers": {
      "nameIdColumn": "コンバージョントラッキング名",
      "typeColumn": "種類"
    }
  },
  "conversionType": {
    "labels": {
      "purchase": "購入済み",
      "cart": "ショッピングカート",
      "signUp": "登録する",
      "lead": "ガイド",
      "viewOfAKeyPage": "時計",
      "others": "他の"
    }
  },
  "conversionCode": {
    "labels": {
      "id": "コンバージョントラッキングコード",
      "code": "コンバージョントラッキングコード",
      "codeHint": "イベント収集情報がサーバーに正確に送信されるように、トラッキング コードをコピーして、Web サイトの <body> タグの後に貼り付けてください。"
    }
  },
  "accountActorList": {
    "labels": {
      "deletePermissionContent": "このアカウントから権限を削除してもよろしいですか?",
      "actionHint": {
        "edit": "アカウント権限の編集",
        "delete": "アカウント権限の削除"
      }
    }
  },
  "accountDetail": {
    "labels": {
      "name": "アカウント名: {{name}}",
      "resendActivationEmail": "認定書の再送"
    }
  },
  "loginPage": {
    "labels": {
      "loginError": "アカウントまたはパスワードが間違っています",
      "emailTitle": "メール",
      "passwordTitle": "パスワード",
      "forgotPassword": "パスワードを忘れましたか？",
      "privacyPolicy": "プライバシーポリシー",
      "confirmPasswordTitle": "パスワードを認証する"
    }
  },
  "prompt": {
    "labels": {
      "title": "編集ページを離れようとしています",
      "message": "編集した内容はまだ保存されていません。本当に終了しますか?"
    }
  },
  "daypick": {
    "labels": {
      "add1Day": "1日",
      "add7Days": "7日間",
      "add1Month": "1ヶ月",
      "thisWeek": "今週",
      "thisMonth": "今月",
      "endOfNextMonth": "来月末",
      "endOfNext3Months": "今後3ヶ月の終わり",
      "today": "今日",
      "yesterday": "昨日",
      "last7Days": "過去7日間",
      "last30Days": "過去30日間",
      "lastWeek": "先週",
      "lastMonth": "先月"
    }
  },
  "advertiserDetailModal": {
    "titles": {
      "addOtherAdvertiserSegments": "他の広告主オーディエンスデータソースを追加する"
    }
  },
  "videoForm": {
    "labels": {
      "inStream": "インストリーム（プレロール）",
      "outStream": "アウトストリーム",
      "unlimitStream": "無制限",
      "nonSkippable": "無視できない",
      "skippable": "省略",
      "videoSource": "ビデオソースを選択",
      "tenMaxVideo": "TenMax",
      "3rdVideo": "サードパーティ",
      "tenMaxVideoInput": "ビデオアーカイブ",
      "3rdVideoInput": "広告配信URL",
      "3rdVideoDuration": "ビデオの長さ"
    }
  },
  "advertiserSegmentSource": {
    "labels": {
      "addSourceBtn": "ソースを追加",
      "advertiserSegmentSource": "視聴者ソース",
      "title": "その他の広告主オーディエンス情報"
    },
    "placeholders": {
      "agencies": "ディーラーを選択してください",
      "advertisers": "広告主を選択してください"
    }
  },
  "thirdPartyVideoPreview": { "labels": { "thirdParty": "第三者" } },
  "videoCreativePreivew": {
    "labels": { "generating": "プレビュー画像を生成しています" }
  },
  "videoCreativeDetail": { "labels": { "generating": "ビデオ制作中" } },
  "creativeChooseAdvertiser": {
    "title": { "warning": "警告する" },
    "labels": {
      "advertiserChangeAlert": "広告主を変更すると、編集した内容がリセットされます。切り替えてもよろしいですか？"
    }
  },
  "nativeForm": {
    "labels": {
      "nativeBannerTitle": "広告スタイル",
      "enableNativeBanner": "画像広告トラフィックに配信",
      "cannotModifyHint": "※一度作成した素材は修正できません！"
    }
  },
  "nativeBanner": {
    "labels": {
      "sponsoredBy": "{{sponsor}} スポンサー",
      "learnMore": "もっと詳しく知る",
      "recommendation": "注目のおすすめ"
    }
  },
  "nativeCreativeDetail": {
    "labels": { "toggleBanner": "画像素材", "toggleNative": "原生素材" }
  },
  "ppsCreativeDetail": {
    "labels": {
      "toggleMobile": "モバイル版",
      "toggleDesktop": "デスクトップ版"
    }
  },
  "nativeMediaSummary": {
    "titles": { "native": "原生素材", "nativeBanner": "画像素材" }
  },
  "imageCreativeSizeHint": {
    "labels": {
      "sizeInstruction": "サイズ説明",
      "recommendTitle": "推奨画像サイズ",
      "otherSizeTitle": "サポートされているその他の画像サイズ"
    }
  },
  "ppsForm": {
    "labels": {
      "macroInstruction": "必要なトレースマクロをコードに含める必要があります",
      "htmlSnippet": "広告コード",
      "normalBannerUrlHint": "広告タグに設定されたアウトバウンドリンクが使用されます。調整が必要な場合は、広告タグサービスプロバイダにお問い合わせください。",
      "layoutId": "パターンID",
      "subLayout": "サブバージョン",
      "noCorrespondingLayoutId": "サポートされていないレイアウト ID: {{layoutId}}",
      "layoutIdNotFound": "バージョンIDが見つかりません",
      "autoGenImage": "自動生成",
      "cannotFindPreveiwImage": "対応するプレビュー画像が見つかりません",
      "needPPSCreativeID": "まず有効なAdNeonコードを入力してください"
    }
  },
  "macro": {
    "titles": {
      "clickMacroDesc": "システムは必要なトラッキングマクロが含まれているかどうかを自動的に確認します。広告コードには、以下のマクロのうち少なくとも1つが含まれている必要があります。",
      "viewableMacroDesc": "AdNeon アセットの広告コードには、次のマクロが含まれている必要があります。"
    },
    "headers": {
      "clickMacro": "クリックトラッキングマクロ",
      "desc": "説明する",
      "viewableMacro": "視覚印象追跡マクロ"
    },
    "unescapedClickURL": "翻訳されていないクリックトラッキングURL",
    "escapedClickURL": "翻訳されたクリックURL",
    "doubledEscapedClickURL": "2回翻訳されたクリックURL",
    "vastUrl": "ビデオ視聴イベントの場合、VAST 形式の URL が必要です。",
    "dspViewableURL": "DSP 視覚露出トラッキングマクロ",
    "sspViewableURL": "SSP 視覚印象追跡マクロ",
    "adxViewableURL": "ADX 視覚露出追跡マクロ",
    "bannerUrl": {
      "clickId": "このクリックのトラッキングIDマクロ",
      "idfa": "iOSデバイスの追跡IDマクロをクリックします",
      "androidId": "AOSデバイスの追跡IDマクロをクリックします",
      "campaignId": "クリックされた広告の広告IDマクロ",
      "bannerId": "クリック広告のクリエイティブIDマクロ"
    },
    "hint": {
      "appsflyer": "※注：このルールはAppsflyerのウェブサイトにのみ適用されます。同様のニーズがある場合は、窓口までお問い合わせください。"
    }
  },
  "ppsFormValidate": {
    "labels": {
      "macroError": "AdNeonコードに必要なマクロが欠落しています",
      "codeSizeToLarge": "AdNeonコードが大きすぎるため、コンテンツを減らしてください"
    }
  },
  "html5Form": {
    "labels": {
      "recommended": "推薦する",
      "bannerSize": "素材サイズ",
      "htmlZip": "HTML圧縮ファイル",
      "typeHint": "zip形式のみ使用可能",
      "fileHint": "※素材ページにある該当ファイルをzipファイルに圧縮してアップロードしてください。<1>サンプルファイルのダウンロードはこちら</1>",
      "typeErrorHint": "ファイル形式は{{type}}形式で、zipである必要があります"
    }
  },
  "outdoorForm": {
    "labels": {
      "outdoorType1": "ビデオ",
      "outdoorType2": "画像 + 音声",
      "outdoorType3": "ビデオ + 写真",
      "outdoorType4": "HTML",
      "outdoorType2Epaper": "画像",
      "duration15": "15秒",
      "duration30": "30秒",
      "duration0": "制限なし",
      "videoProportionHint": "ビデオの比率は{{proportion}}である必要があります",
      "videoProportionErrorHint": "ビデオの比率は{{proportion}}である必要があります",
      "videoSizeHint": "動画のサイズは{{size}}である必要があります",
      "videoSizeBoxingHint": "動画のサイズ制限については素材情報の注意事項をご確認ください。",
      "imageSizeBoxingHint": "画像のサイズ制限については素材情報の注意事項をご確認ください。",
      "orderName": "注文名",
      "orderBudget": "注文予算",
      "orderSchedule": "注文の予想配達日",
      "selfCheckDocument": "セルフチェックリスト",
      "outdoorType6": "画像"
    },
    "hints": {
      "orderName": "{{channelName}} 提供された情報に基づいて、審査担当者が申請を承認するかどうかを決定します。フォームに詳細をご記入ください。",
      "orderBudget": "{{channelName}} 提供された情報に基づいて、審査担当者が申請を承認するかどうかを決定します。フォームに詳細をご記入ください。",
      "orderSchedule": "配信期間設定は、資料レビューの段階でレビュー担当者の参考として表示されますが、正式な配信期間設定には影響しません。",
      "selfCheckFileType": "doc / docx / pdf 形式のみ受け付けます",
      "selfCheckFileExample": "サンプルファイルをダウンロードするには<1>ここをクリック</1>してください",
      "nonExpressPassCategory": "このカテゴリーはエクスプレスパス対象外です。自己チェックリストのアップロードが必須となります。"
    },
    "errors": {
      "selfCheckDocumentRequired": "クリエイティブ審査のため、自己チェックリストをアップロードしてください。"
    }
  },
  "streamingStatus": {
    "title": "直撥素材調整",
    "labels": {
      "create": "直撥素材調整",
      "edit": "編輯直撥素材調整",
      "noData": "直撥素材調整"
    }
  },
  "streamingStatusList": {
    "headers": { "crid": "Creative id", "isLive": "是否直播中" },
    "hints": { "edit": "編輯直撥素材狀態" }
  },
  "streamingStatusForm": {
    "labels": {
      "createTitle": "新增直撥素材狀態",
      "editTitle": "編輯直撥素材狀態",
      "crid": "Creative id",
      "isLive": "是否直播中"
    }
  },
  "beaconFields": {
    "labels": {
      "beaconConnection": "公式アカウント",
      "webhookType": "Webhookタイプ",
      "hardwareId": "ハードウェアID",
      "channelSecret": "チャンネルシークレット",
      "channelAccessToken": "チャネルアクセストークン",
      "beaconConfigSwitch": "ビーコンプッシュ通知",
      "generateWebhook": "出力Webhook URL",
      "generateBeaconAPIUrl": "出力ビーコンAPI URL",
      "tenmaxSupport": "TenMaxサポート",
      "tenmax": "TenMaxサポート",
      "advertiserSelfServe": "広告主所有のウェブフック",
      "beaconType": "ビーコンタイプ",
      "frequencyCap": {
        "every": "毎",
        "send": "送信",
        "cappingCount": "二流",
        "cappingCounts": "二流"
      },
      "frequencyCapSwitch": "送信回数制限",
      "language": "ユーザー使用言語",
      "lineUserLanguage": {
        "all": "すべて指定なし",
        "zh_hant": "繁体字中国語",
        "zh_hans": "簡体字中国語",
        "en": "英語",
        "ja": "日本語",
        "th": "タイ語"
      }
    },
    "buttons": {
      "generateWebhook": "クリックしてWebhook URLをコピーします",
      "generateBeaconAPIUrl": "クリックしてビーコンAPI URLをコピーします"
    },
    "hints": {
      "generateWebhookSuccess": "Webhook URL がクリップボードにコピーされました",
      "generateBeaconUrlSuccess": "ビーコン API URL がクリップボードにコピーされました"
    }
  },
  "comboForm": {
    "labels": {
      "videoHint": "動画の長さは {{sec}} 秒、高さは {{height}} を超えることはできません",
      "videoDurationErrorHint": "このビデオの長さは {{sec1}} 秒で、{{sec2}} 秒を超えることはできません。",
      "videoHeightErrorHint": "このビデオの高さは {{height1}} で、{{height2}} を超えることはできません。"
    }
  },
  "doctor": {
    "labels": { "campaignId": "キャンペーンID", "creativeId": "素材ID" }
  },
  "doctors": {
    "labels": {
      "campaignIdPlaceholder": "キャンペーンIDを入力してください",
      "creativeIdPlaceholder": "材料IDを入力してください",
      "noCreative": "このキャンペーンには関連するクリエイティブがありません",
      "title": "キャンペーン配信制限のトラブルシューティング"
    }
  },
  "doctorChart": {
    "labels": {
      "remain": "残りのスペース",
      "filtered": "フィルタリングされた配置"
    }
  },
  "doctorTable": {
    "labels": {
      "filterConditionTitle": "フィルター条件",
      "tenmaxCategory": "素材カテゴリ",
      "interstitial": "カバー設定",
      "creativeTitle": "素材"
    },
    "headers": { "domain": "ドメイン", "spaceCount": "スロット数" },
    "placeholders": {
      "filterCondition": "フィルター条件を選択してください",
      "searchbar": "ドメインまたは配置を検索..."
    },
    "tabs": {
      "filtered": "フィルタリングされた交通情報",
      "remained": "残りのデータフロー情報"
    }
  },
  "doctorTableRowExtender": {
    "labels": {
      "banCategoryReasonTitle": "禁止されているカテゴリ:",
      "intersitialCampaign": "この広告枠はカバー広告枠です。このキャンペーンはカバー広告枠に配信できません。",
      "intersitialCreative": "レイアウトは表紙レイアウトです。この資料は表紙レイアウトには納品できません。",
      "reasonTitle": "配達不能の理由"
    },
    "placeholders": {
      "spaceList": "詳細情報を表示するには、配置を検索してください",
      "banReason": "理由を確認するには配置を選択してください"
    }
  },
  "campaignControlList": {
    "headers": { "name": "グループ名", "campaignInfos": "キャンペーン数" },
    "placeholders": { "searchbar": "予算配分グループを検索..." },
    "labels": {
      "newCampaignControl": "+ 予算配分グループ",
      "noData": "現在、予算配分グループがありません。「+ 予算配分グループ」をクリックして作成してください。",
      "editHint": "予算配分グループの編集",
      "deleteHint": "予算配分グループの削除",
      "deleteModalTitle": "予算配分グループの削除",
      "deleteModalContent": "選択した予算配分グループを削除してもよろしいですか?",
      "managementModalTitle": "キャンペーンの管理",
      "campaignEditHint": "キャンペーンの管理"
    }
  },
  "campaignControlForm": {
    "labels": {
      "createTitle": "予算配分グループを作成する",
      "editTitle": "予算配分グループの編集",
      "name": "名前",
      "campaigns": "キャンペーン"
    },
    "placeholders": { "campaigns": "管理したいキャンペーンを選択してください" }
  },
  "changePasswords": {
    "title": { "change": "パスワードを変更する" },
    "message": {
      "reload": "パスワードの更新が完了しました。再度ログインする必要があります。"
    }
  },
  "campaignControlCampaignList": {
    "headers": { "name": "キャンペーン名" },
    "labels": { "deleteHint": "このグループからキャンペーンを削除する" },
    "placeholders": { "searchbar": "検索キャンペーン" }
  },
  "sudo": {
    "placeholders": { "searchbar": "メールアドレスまたは名前を検索" },
    "label": {
      "platformAccounts": "プラットフォームアカウント",
      "oemAccounts": "ホワイトカードアカウント"
    },
    "message": { "success": "変革は成功しました" }
  },
  "errorBoundary": { "labels": { "title": "不明なエラーが発生しました" } },
  "bidPriceSetting": {
    "labels": {
      "display": "ディスプレイ広告の入札設定",
      "video": "動画広告の入札設定",
      "combo": "動画+画像広告の入札設定",
      "thirdParty": "サードパーティ（未分類）広告入札設定",
      "thirdPartyBottom": "サードパーティ（下部配置）広告入札設定",
      "thirdPartyRectangle": "サードパーティ（中央の四角形）の広告入札設定",
      "oneForAllDisplay": "ワンフォーオールディスプレイ広告入札設定",
      "ctv": "デジタルテレビ広告入札設定",
      "keyword": "キーワード広告の入札設定",
      "message": "SMS広告の入札単価設定",
      "picShort": "PIC屋外広告15秒広告入札設定",
      "picLong": "PIC屋外広告30秒広告入札設定",
      "picExtended": "PIC屋外広告60秒広告入札設定",
      "picBroad": "PIC屋外広告60秒以上の広告入札設定",
      "hwacomShort": "HwaCom15秒広告入札設定",
      "hwacomLong": "HwaCom30秒広告入札設定",
      "hwacomExtended": "HwaCom60秒広告入札設定",
      "hwacomBroad": "HwaCom60秒以上の広告入札設定",
      "fridgeBroad": "冷蔵庫の60秒以上の屋外広告の入札設定",
      "fridgeLong": "冷凍庫の30秒屋外広告の入札設定",
      "fridgeExtended": "冷凍庫での60秒屋外広告の入札設定",
      "sandboxOutdoor": "R&Dテストユーザーの屋外広告入札設定",
      "sandboxMovableOutdoor": "R&Dテストユーザーの移動式屋外広告入札設定",
      "outdoorLineMessage": "Outdoor Line Message 広告入札設定",
      "lineMessage": "Line Message 広告入札設定",
      "autoBidCapSetting": "自動配送制限設定",
      "bidFloorSetting": "最低配送金額設定"
    },
    "optimize": {
      "cpc": "クリック",
      "cpm": "インプレッション数",
      "cpv": "ビデオ閲覧",
      "vcpm": "ビューアブルインプレッション",
      "acpm": "人数",
      "wcpm": "画面比率露出",
      "bcpm": "メッセージ単価",
      "dcpm": "動態 CPM"
    }
  },
  "agencyForm": {
    "placeholders": {
      "tags": "ID を入力した後、Enter キーを使用して別の Web サイト所有者を追加できます。"
    },
    "labels": {
      "sysMarginMaximumError": "システム利益とメディアボーナス比率の合計は{{value}}未満である必要があります",
      "smallerThanAgcMarginError": "残りの利益はディーラーが設定した利益{{value}}より少なくなることはありません",
      "smallerThanOrderProfitError": "残りの利益はディーラー利益限度額 {{value}} 未満にはなりません",
      "orderDefaultProfitBiggerThanMaxProfit": "ディーラーの事前設定された利益はディーラーの利益上限を超えることはできない",
      "clickToAddEffectDate": "クリックして有効日を追加",
      "rebateRateMaximumError": "メディアボーナスはシステム利益を超えることはできません: {{margin}}"
    }
  },
  "agencyList": { "labels": { "editHint": "ディーラーを編集" } },
  "productGroupList": {
    "labels": {
      "title": "製品グループ管理",
      "space": "版位",
      "domain": "ドメイン",
      "deleteHint": "商品グループを削除する",
      "noData": "現在、製品グループがありません。「+ 製品グループ」をクリックして追加してください。",
      "campaignModalTitle": "キャンペーン情報",
      "showCampaignHint": "この商品グループを使用したキャンペーン情報を表示する",
      "create": "製品グループを作成する",
      "editHint": "製品グループを編集",
      "deleteModalTitle": "商品グループを削除する",
      "deleteModalContent": "この製品グループを削除してもよろしいですか?"
    },
    "headers": { "id": "名前", "description": "物語", "agencys": "ディーラー" },
    "placeholders": { "searchbar": "製品グループを検索" }
  },
  "campaignUseProductGroup": {
    "headers": { "id": "キャンペーンID", "name": "キャンペーン名" }
  },
  "productGroupForm": {
    "labels": {
      "groupName": "グループ名",
      "groupType": "タイプ",
      "adspace": "版位",
      "domain": "ドメイン",
      "agencyIds": "このグループを利用できる販売業者",
      "description": "物語",
      "customDomain": "カスタムドメイン",
      "customSpace": "カスタムレイアウト",
      "customSpaceName": "名前",
      "customSpaceId": "ID",
      "createTitle": "製品グループを作成する",
      "editTitle": "製品グループを編集",
      "single": "シングル",
      "multiple": "複数",
      "adFormat": "広告スタイル",
      "channel": "配信チャネル",
      "attributes": "財産",
      "selectAllSpace": "すべて選択",
      "conditionSpace": "条件に基づいて配置を自動的に更新する",
      "selectAllDevice": "すべて選択",
      "conditionDevice": "条件に基づいて配置を自動的に更新する",
      "selectAllStore": "すべて選択",
      "conditionStore": "条件に基づいて配置を自動的に更新する"
    },
    "buttons": {
      "customSpace": "+ カスタムレイアウト",
      "customDomain": "+ カスタムドメイン",
      "filterSpace": "フィルターの配置",
      "filterDevice": "端末の配置",
      "filterStore": "店舗の配置",
      "editFilters": "編集条件",
      "editAdspace": "位置を編集",
      "editDomain": "ドメインを編集",
      "finishEdit": "編集完了"
    },
    "placeholders": {
      "customDomain": "ドメインを入力した後、Enter キーを使用して新しいドメインを追加します...",
      "addDomain": "例: www.example.com"
    },
    "addDomain": "カスタムドメイン",
    "title": {
      "generalSection": "一般的に",
      "filterSection": "状態",
      "selectAdspaceSection": "版位",
      "selectDomainSection": "ドメイン",
      "selectStoreSection": "店舗",
      "selectDeviceSection": "端末"
    },
    "titles": { "other": "他の" },
    "hints": {
      "conditionSpace": "「条件に基づいて広告枠を自動更新する」を選択すると、設定した条件に基づいて広告枠のプロパティが自動的に更新されます。広告枠のプロパティが変更されると、システムが自動的に調整・更新し、広告枠が実際の広告枠のプロパティと一致するようにします。",
      "conditionDevice": "「条件に基づいて広告枠を自動更新する」を選択すると、設定した条件に基づいて広告枠のプロパティが自動的に更新されます。広告枠のプロパティが変更されると、システムが自動的に調整・更新し、広告枠が実際の広告枠のプロパティと一致するようにします。",
      "conditionStore": "「条件に基づいて広告枠を自動更新する」を選択すると、設定した条件に基づいて広告枠のプロパティが自動的に更新されます。広告枠のプロパティが変更されると、システムが自動的に調整・更新し、広告枠が実際の広告枠のプロパティと一致するようにします。",
      "autoUpdate": "条件に基づく自動更新"
    }
  },
  "productGroup": {
    "placeholders": { "search": "検索" },
    "labels": { "autoUpdate": "（状況に応じて順位は更新されます）" },
    "space": {
      "attributes": {
        "store": { "postfix": "{{value}}支店" },
        "titles": {
          "storeNum": "店舗情報",
          "cityGroup": "地理区分",
          "administrativeArea": "行政区",
          "outdoorPlaceCategories": "エリア特性",
          "weather": "天気情報",
          "deviceCharacteristic": "端末情報"
        }
      }
    }
  },
  "outdoorMonitor": {
    "labels": {
      "dayRange": "配信期間",
      "agency": "ディーラー",
      "total": "推定総トラフィック秒数",
      "remain": "推定残りトラフィック秒数",
      "proposal": "提案注文で使用されるトラフィックの秒数",
      "formal": "正式注文のトラフィック使用秒数",
      "day": "日",
      "hour": "時間",
      "title": "屋外広告トラフィック監視"
    },
    "placeholders": {
      "agencies": "ディーラーを選択してください",
      "searchbar": "注文を検索…"
    }
  },
  "creditList": {
    "labels": {
      "title": "信用限度額",
      "noData": "現時点では信用限度額の情報はありません",
      "pay": "デポジット",
      "payConfirm": "{{date}} に {{name}} の料金が請求されることを確信していますか?"
    },
    "headers": {
      "agency_id": "ディーラー",
      "used_credit": "使用済みクォータ",
      "creditLimit": "総信用限度額"
    },
    "placeholders": { "searchbar": "信用情報を検索..." }
  },
  "creditDetail": {
    "labels": {
      "totalCredit": "総信用限度額",
      "remainCredit": "残りのクレジット限度額",
      "billUnpaid": "買掛金勘定",
      "billSpent": "消化金額",
      "paymentAt": "最終支払い: {{amount}}、{{at}}",
      "noLastPaid": "支払い情報がありません",
      "title": "信用限度額",
      "pay": "デポジット"
    }
  },
  "creditLog": {
    "labels": {
      "approveAddOrderBudget": "注文 {{orderNumber}} の予算を増額する",
      "approveReduceOrderBudget": "注文 {{orderNumber}} の予算を削減します",
      "addCreditLimit": "クレジット限度額を増やす",
      "reduceCreditLimit": "クレジット限度額を引き下げる",
      "orderSettleAddOrderBudget": "{{orderNumber}} の注文をチェックアウト",
      "orderSettleReduceOrderBudget": "{{orderNumber}} の注文をチェックアウト",
      "approveNewOrder": "注文を追加 {{orderNumber}}",
      "paidBill": "管理者が {{dateId}} にログインしました",
      "noData": "信用限度額情報なし"
    },
    "headers": {
      "ctime": "日付",
      "note": "説明する",
      "paid": "デポジット",
      "unpaid": "支払金額",
      "updatedCredit": "クレジット残高"
    }
  },
  "creditPayModal": {
    "labels": {
      "agency": "ディーラー",
      "currency": "通貨",
      "period": "請求サイクル",
      "payment": "金額",
      "credit": "信用の回復",
      "noData": "未払いの請求書はありません"
    }
  },
  "currencyRateList": {
    "labels": {
      "title": "為替レート設定",
      "NTD": "台湾ドル（NTD）",
      "MYR": "マレーシア・リンギット MYR",
      "JPY": "日本円 JPY",
      "VND": "ベトナムドン（VND）",
      "EUR": "ユーロ（EUR）",
      "IDR": "インドネシアルピア（IDR）",
      "noData": "現在、この通貨の為替レートデータがありません。「新しい為替レートを追加」をクリックすると、新しい為替レートを追加できます。",
      "create": "新しい為替レート",
      "oneDollarEqual": "1米ドル両替"
    },
    "headers": { "ctime": "日付", "rate": "為替レート", "createdBy": "創設者" }
  },
  "l1Object": {
    "labels": {
      "noData": "現在、広告グループがありません。「+ 広告グループ」をクリックして追加してください。",
      "create": "+ 広告グループ",
      "createTitle": "広告グループを作成する",
      "editTitle": "広告グループを編集",
      "deleteTitle": "広告グループを削除",
      "name": "グループ名",
      "l1ObjectId": "グループ名",
      "channel": "グループチャンネル",
      "budget": "予算",
      "autoOptimise": "キャンペーン予算の自動最適化",
      "channel_all": "全て",
      "channel_rtb": "RTB",
      "channel_pic": "PIC Outdoor",
      "channel_fridge": "WI Fridge",
      "channel_message": "Message",
      "channel_matsukiyo": "Retail Beacon Network",
      "channel_hwacom": "HwaCom",
      "detailTitle": "広告グループとキャンペーン",
      "deleteModalContent": "選択した広告グループを削除してもよろしいですか?",
      "state": "グループステータス",
      "budgetBalance": "利用可能な予算",
      "outdoorDeviceReport": "屋外機の納品実績",
      "objectiveLabel": "マーケティング目標",
      "objective": {
        "awareness": "ブランド認知度",
        "traffic": "流れ",
        "sales": "販売",
        "unspecified": "指定されていない"
      },
      "cannotDeleteTitle": "キャンペーンが確立されている広告グループは削除できません",
      "message_cannotDeleteTitle": "今日にキャンペーンが配信期間されている広告グループ、またはすでに開始されている広告グループは削除できません。",
      "bidStrategyLabel": "入札戦略",
      "bidStrategy": {
        "lowest_cost_without_cap": "自動配送",
        "lowest_cost_with_bid_cap": "入札制限",
        "cost_cap": "コスト上限"
      },
      "viewableImpressReport": "ビューアブルインプレッションを採用",
      "downloadReport": "RTBレポートをダウンロード",
      "delivery": "配送状況",
      "impres": "インプレッション数",
      "viewable": "ビューアブルインプレッション数",
      "clicks": "クリック数",
      "cpc": "クリック単価",
      "ctr": "クリックスルー率",
      "vctr": "視認可能なクリックスルー率",
      "convs": "変換番号",
      "cpa": "コンバージョン単価",
      "cvr": "コンバージョン率",
      "cboTimeLimit": "再度切り替えるには {{time}} 分待つ必要があります",
      "campaignBudgetDisableHint": "予算最適化がオンになっている場合にのみ使用できます。",
      "results": "結果",
      "uu": "リピーターなし",
      "spent": "消化金額",
      "view": "動画視聴回数",
      "viewRate": "動画視聴率",
      "viewableViewRate": "動画の視聴率",
      "videoPlayActions": "動画視聴回数",
      "videoWatched2s": "2秒間の動画視聴",
      "videoWatched6s": "6秒間の動画視聴",
      "videoViewsP25": "動画視聴の25%",
      "videoViewsP50": "動画視聴率は50%",
      "videoViewsP75": "動画視聴率は75%",
      "videoViewsP100": "動画視聴率100%",
      "profileVisits": "有料ホームページ訪問",
      "likes": "有料いいね",
      "comments": "有料レビューの数",
      "shares": "支払済み株式数",
      "follows": "有料フォロワー",
      "clicksOnMusicDisc": "ミュージッククリック",
      "rtbCboLimitation": "この機能を有効にするには、広告グループ内のすべてのキャンペーンで同じターゲットの最適化と入札戦略が設定されている必要があります。",
      "rtbCboDailyBudgetHint": "広告グループには 1 日の予算が設定されたキャンペーンが含まれているため、CBO を有効にできません。",
      "cboRtbCampaignLengthLimit": "CBO を無効にするには、広告グループに少なくとも 1 つのキャンペーンが必要です。",
      "cboRtbCampaignBudgetLimit": "広告グループには、x 日間の最小 1 日の予算を下回る予算が設定されたキャンペーンが含まれています: {{campaignIds}}"
    },
    "placeholders": {
      "searchbar": "広告グループのキャンペーン名と ID を検索します..."
    },
    "hints": { "editRtbCampaignBudgets": "RTBキャンペーン予算の編集" }
  },
  "adSetSetupFlow": {
    "mainStep": {
      "fieldset": { "optimizationTitle": "時間帯の設定" },
      "field": {
        "optimizationGoal": "広告配信の最適化",
        "bidStrategy": "入札戦略",
        "bidControl": "入札制限",
        "orderPrice": "契約価格",
        "billingEvent": "請求基準",
        "frequencyControl": "露出頻度制限",
        "useFrequencyControl": "周波数制御"
      },
      "labels": {
        "impression": "インプレッション数",
        "frequencyControl": "{{interval_days}} {{unit}} {{event}} {{max_frequenency}} 回ごと",
        "frequencyCap": { "event": "{{event}}回/回", "unit": "{{unit}}" }
      },
      "errors": {
        "emptyMaxFrequency": "露出頻度の上限は空欄にできません",
        "emptyIntervalDays": "間隔日数は空欄にできません",
        "maxFrequencyOutofRange": "露出頻度の値は {{min}} ~ {{max}} の間でなければなりません",
        "intervalDaysOutofRange": "間隔日数は {{min}} から {{max}} の間でなければなりません"
      }
    }
  },
  "optimizationGoal": {
    "impressions": "インプレッション数",
    "clicks": "クリック数",
    "video_views": "動画視聴回数",
    "reach": "到達した人数",
    "sales": "販売コンバージョン行動",
    "landing_page_views": "ターゲットページビュー",
    "fixed_viewable_impression": "ビューアブルインプレッション数",
    "video_views_reach": "動画視聴リーチ",
    "acpm": "来店者数",
    "wcpm": "スクリーン比露出時間",
    "unspecified": "指定されていない"
  },
  "l1ObjectList": {
    "labels": {
      "l1ObjectCount": "広告グループ {{count}}",
      "drafts": "{{count}} 回のドラフト",
      "cbo": "CBO",
      "non-cbo": "非CBO",
      "activeState": "放送中",
      "deactivateState": "非アクティブ化",
      "deleteState": "削除済み",
      "notStartState": "開始されていません",
      "endState": "終了しました",
      "statusFilter": "グループステータス",
      "statusFilterMenuTitle": "グループのステータスを選択",
      "statusTag": "グループステータス",
      "deliveryFilter": "配送状況",
      "deliveryFilterMenuTitle": "配送状況を選択",
      "deliveryTag": "配送状況",
      "delivery": {
        "notStart": "開始されていません",
        "noCreatives": "無素材",
        "normal": "普通",
        "behind": "後ろに",
        "severelyBehind": "かなり遅れている",
        "ahead": "スーパーカー",
        "inactive": "非アクティブ化",
        "end": "終了しました",
        "active": "放送中",
        "scheduled": "キュー内",
        "abandon": "削除済み",
        "abnormal": "異常な",
        "pmpChanged": "PMPの変更"
      },
      "remainBudget": "予算黒字",
      "undistributedBudget": "予算が割り当てられていない",
      "orderStateCannotCreate": "承認されていない/決済中/決済済みの注文に対して広告グループを作成することはできません",
      "isEndCannotCreate": "終了した注文ではキャンペーン グループを作成できません",
      "noChannelAllowed": "承認する配信チャネルがないとキャンペーン グループを作成できません"
    }
  },
  "goSegmentForm": {
    "errors": {
      "uploadTypeErrorHint": "ファイル形式は{{type}}形式で、csvである必要があります"
    },
    "titles": { "create": "視聴者を増やす" },
    "hints": { "fileType": "csv形式のみ利用可能です" }
  },
  "l2ObjectOptimize": {
    "labels": {
      "lowest_cost_without_cap": "RTBは、予算をすべて使い切り、最も低コストの入札戦略を使用して最大限の最適化を図ります。上限コストを設定する場合は、希望する値を入力してください。",
      "lowest_cost_with_bid_cap": "オークションで入札上限入札戦略を使用する場合、RTB は入札額を {{bidControl}} 未満に保ちながら {{optimization}} を最大化しようとします。"
    }
  },
  "editLimitation": {
    "errors": {
      "repeat": "他のトラフィックでいくつかのオプションが選択されました",
      "someSelectedOptionInvalid": "選択した{{name}}の一部が無効です。削除して再度選択してください。",
      "tooManyKeywords": "キーワードは30個以内",
      "audienceLowestThreshold": "推定視聴者数が少なすぎます。視聴者の選択基準を緩和してください。",
      "requireIncludeLimitation": "配信量の制限ためのターゲットの最適化を少なくとも 1 つ選択する必要があります",
      "spaceOverBindingLimit": "配信期間中に 10 件のキャンペーン（停止中の広告グループのものを含む）でロックされている店舗／機器が {{count}} 件あります。削除してから送信してください"
    },
    "buttons": { "importTargeting": "目標設定のインポート" }
  },
  "l1ObjectBudgetManagement": {
    "title": "{{num}} キャンペーン予算",
    "headers": {
      "id": "名前",
      "status": "状態",
      "spent": "消化金額",
      "budget": "予算"
    },
    "hints": { "campaignBudget": "利用可能な予算: {{total}}" }
  },
  "creativeBasicForm": {
    "labels": {
      "urlMacroInstruction": "マテリアルリンクでサポートされているコード"
    },
    "titles": {
      "clickMacroDesc": "システムは以下のマクロをサポートしており、関連するデータに自動的に置換されます。異なるマクロを接続するには「&」を使用してください。"
    }
  },
  "authenticationManager": {
    "errors": {
      "noActor": "アカウントにロールが割り当てられていません。管理者に問い合わせてください。"
    }
  },
  "messageCampaignInfo": {
    "labels": {
      "insertShortUrl": "外部URLを挿入",
      "clickUrl": "外国語ウェブサイト"
    },
    "descriptions": {
      "invalidContent": "入力された[{{texts}}]にはデリケートな言葉が含まれています。そのような言葉の使用を減らすか、使用しないことをおすすめします。そうしないと、メッセージは審査に通過しません。送信前にメッセージのテキストを調整してください。ありがとうございます！"
    }
  },
  "orderDetails": {
    "buttons": {
      "downloadFinalReport": "決算報告書を生成する",
      "downloadOutdoorFinalReport": "Outdoor 決算報告書を生成する"
    }
  },
  "accountManager": {
    "errors": {
      "localeMeFailed": "アカウント情報の取得に失敗しました。この状況が続く場合は、システム管理者にお問い合わせください。"
    }
  },
  "registerPage": {
    "titles": {
      "notice": "知らせ",
      "invalidLink": "認証リンクが無効です",
      "complete": "セットアップ完了"
    },
    "messages": {
      "activated": "この認証リンクは既に使用されており、アカウントは有効化されています。設定されたアカウントとパスワードを使用してログインしてください。",
      "resendEmail": "確認メールを再送信するには、アカウント管理者に連絡してください。"
    },
    "labels": {
      "setPassword": "こんにちは、{{name}}さん、<3/>パスワードを設定してください",
      "completeTitle": "セットアップが完了しました！",
      "completeMessage": "パスワードの設定が完了しました。PMax3 のご利用を開始するにはログインしてください。"
    }
  },
  "finalReportPage": {
    "titles": {
      "confirmation": "権限認証設定",
      "fail": "失敗",
      "common": {
        "adsPerformance": "広告パフォーマンス",
        "overallAdsPerformance": "全体的な広告配信効果",
        "overallReport": {
          "platform": "プラットフォームによるレポート",
          "l1Object": "広告商品の納品実績"
        },
        "chart": {
          "platform": {
            "CTR": "毎日のプラットフォーム露出と総クリックスルー率（％）"
          },
          "l1Object": {
            "CTR": "1日あたりの広告商品の表示回数と総クリック率（％）",
            "VTR": "1日あたりの広告商品の表示回数と総視聴率（％）"
          }
        },
        "deepDiveBy": {
          "platform": "プラットフォーム別オーディエンス分析 -",
          "l1Object": "広告商品別のオーディエンス分析 -",
          "order": "注文別オーディエンス分析 - {{name}}"
        },
        "table": {
          "platform": "プラットフォーム別",
          "age_group": "年齢別",
          "gender": "性別別",
          "audience_segment": "オーディエンスセグメント別",
          "domain": "ドメイン別",
          "region": "地域別",
          "creative": "素材 (Top 5)",
          "service_area": "地域別（上位5位）",
          "tenmax_segment": "TenMaxオーディエンス（トップ6）",
          "traffic_category": "トラフィック分類（上位5つ）"
        }
      },
      "outdoor": {
        "summaryInfo": "広告注文概要",
        "dailyInfo": "広告日別インプレッション",
        "deliveryInfo": "配信概要",
        "dailyInfoChart": "日別インプレッション数＆来店者数"
      }
    },
    "messages": {
      "login": "PMax3を使用する前にログインしてください",
      "permission": "レポートデータを表示する権限がありません",
      "exceeded": "データ取得がタイムアウトしました。「確認」をクリックして再試行してください。",
      "invalid": "無効なURLまたはレポートが存在しません"
    },
    "labels": {
      "outdoor": {
        "advertiser": "広告主",
        "industry": "業種",
        "period": "配信期間",
        "budget": "予算",
        "creativeDuration": "素材秒數",
        "cpm": "CPM単価",
        "targetImpression": "目標インプレッション数",
        "actualImpression": "実績インプレッション数",
        "achievementRate": "達成率",
        "totalPlayHours": "総再生時間",
        "impres": "インプレッション数",
        "ePublisherImpres": "来店者数",
        "storeCount": "店舗数",
        "totalImpres": "総インプレッション数",
        "totalEPublisherImpres": "総来店者数",
        "thousandsUnit": "千",
        "district": "行政区",
        "impressionShareByCity": "都市別インプレッション割合",
        "cityCounty": "都市",
        "impressionShareByDistrict": "行政区別インプレッション割合",
        "store": "店舗",
        "spent": "消化金額",
        "totalPlayHoursValue": "約{{hours}}時間",
        "noData": "広告情報はありません"
      },
      "common": {
        "header": { "confidential": "機密" },
        "settings": {
          "campaign_name": "キャンペーン",
          "period": "配信期間",
          "budget": "予算",
          "order_name": "注文"
        },
        "overall": {
          "actual": {
            "impression": "インプレッション数",
            "click": "クリック数",
            "conversion": "変換番号",
            "view": "閲覧数"
          },
          "target": {
            "impression": "目標インプレッション数",
            "click": "ターゲットクリック",
            "conversion": "ゴールコンバージョン",
            "view": "目標視聴回数"
          }
        },
        "adsImpact": {
          "sales": "売上高（IDR）",
          "transactions": "取引（注文）",
          "items_sold": "販売商品",
          "basket_size": "バスケットサイズ",
          "lapse_users": "失効ユーザー",
          "new_users": "新規ユーザー",
          "existing_users": "既存ユーザー",
          "totalSummary": "全体概要",
          "averageDaily": "平均日次"
        },
        "table": { "impressions": "インプレッション数", "convs": "変換番号" },
        "impressions": "インプレッション数",
        "clicks": "クリック数",
        "reach": "到達した人数",
        "convs": "変換番号",
        "views": "閲覧数",
        "CTR": "クリック率",
        "VTR": "ビデオ",
        "CPM": "インプレッション単価",
        "CPC": "クリック単価",
        "CPA": "公認会計士",
        "CPV": "CPV",
        "spend": "過ごす",
        "sales": "販売",
        "transactions": "取引",
        "items_sold": "販売商品",
        "users": "ユーザー",
        "new_users": "新規ユーザー",
        "lapse_users": "失効ユーザー",
        "existing_users": "既存ユーザー",
        "basket_size": "バスケットサイズ",
        "unknown": "未知",
        "open_rtb": "オープンRTB",
        "edimax": "エディマックスアウトドア",
        "pic": "PICアウトドア",
        "platform": "プラットフォーム",
        "age_group": "年",
        "gender": "性別",
        "audience_segment": "オーディエンスセグメント",
        "domain": "ドメイン",
        "region": "地域",
        "creative": "素材",
        "service_area": "エリア",
        "l1Object": "広告製品",
        "tenmax_segment": "TenMaxのオーディエンス",
        "traffic_category": "トラフィック分類",
        "benchmark": {
          "awareness": "Facebookの認知度",
          "traffic": "Facebookトラフィック",
          "mixed": "GojekによるオープンRTB"
        },
        "createdTime": "作成時間: {{createTime}}",
        "notes": {
          "title": "注記:",
          "key": {
            "actual_impressions": "インプレッション数",
            "target_impressions": "目標インプレッション数",
            "impressions": "インプレッション数",
            "reach": "到達した人数",
            "clicks": "クリック数",
            "views": "閲覧数",
            "CTR": "クリックスルー率",
            "VTR": "ビデオ",
            "CPM": "インプレッション単価",
            "CPC": "クリック単価",
            "CPV": "CPV",
            "others": "他の",
            "sales": "販売",
            "transactions": "取引",
            "items_sold": "販売商品",
            "new_users": "新規ユーザー",
            "lapse_users": "失効ユーザー",
            "existing_users": "既存ユーザー",
            "basket_size": "バスケットサイズ",
            "service_area": "サービスエリア",
            "benchmarks": "ベンチマーク"
          },
          "value": {
            "actual_impressions": "広告の表示時間",
            "target_impressions": "注文露出目標",
            "impressions": "広告の表示時間",
            "reach": "ユニーク広告視聴者数",
            "clicks": "広告クリック",
            "views": "広告表示回数",
            "CTR": "CTR（％）。広告のクリック数を広告の表示回数で割った値。",
            "VTR": "VTR（％）。広告の視聴回数を広告の表示回数で割った値。",
            "CPM": "1000インプレッションあたりの平均コスト",
            "CPC": "平均クリック単価",
            "CPV": "平均視聴価格",
            "others": "個々のレポートの詳細と合計は、データ タイプの範囲によって若干異なる場合があります。",
            "sales": "キャンペーン期間中の取引（注文）から生成された収益（IDR）。",
            "transactions": "キャンペーン期間中の合計ユニーク注文数。",
            "items_sold": "キャンペーン期間中の取引（注文）から販売された商品の合計数。",
            "new_users": "マーチャント/ブランドで一度も購入したことのないユーザー。",
            "lapse_users": "過去 60 日間に購入を行っていなかったが、キャンペーン期間中に購入したユーザー。",
            "existing_users": "過去 60 日以内に購入したユーザー。",
            "basket_size": "注文あたりの平均売上高。",
            "service_area": "Gojek の営業エリア。エリアの分類は Gojek のグループ分けに基づいています。"
          }
        }
      },
      "tenmax": {
        "header": {
          "title": "こんにちは、{{advertiser}} さん。広告の結果はこちらです。"
        }
      }
    }
  },
  "forgotPasswordPage": {
    "labels": {
      "hints": "パスワードをリセットするには、メールアドレスを入力してください。パスワードリセットの手順はこのメールアドレスに送信されます。",
      "sentMailTitle": "パスワードリセットメールが送信されました。",
      "sentMailMessage": "受信トレイを確認し、リンクをクリックしてパスワードをリセットしてください。",
      "backToLogin": "ログインページに戻る"
    }
  },
  "callToAction": {
    "learn_more": "もっと詳しく知る",
    "shop_now": "ぜひ散策してみてください",
    "watch_more": "もっと見る",
    "buy_now": "即購入"
  },
  "audienceInfo": {
    "labels": {
      "audienceSelection": "観客の選択",
      "audienceEstimatedSize": "推定視聴者数",
      "audienceSizeTooSmall": "ターゲットオーディエンスが限定的すぎるため、広告が配信されない可能性があります。より幅広いオーディエンスを対象にしてください。",
      "audienceEstimatedHint": "視聴者数の推定値は参考値であり、実際の視聴者数は配信当日の最新情報に基づき算出されます。"
    },
    "buttons": { "estimate": "見積もり" }
  },
  "taInfoCard": {
    "labels": {
      "saveTargeting": "次回のインポート時に簡単に目標設定を保存できます",
      "title": "保存先設定",
      "hint": "ターゲット設定を保存するには、 を選択します。",
      "new": "新しい目標設定として保存",
      "replace": "元の目標設定を置き換える",
      "taName": "目標設定名",
      "toReplacedTAName": "目標設定: <1>{{name}}</1>"
    },
    "buttons": { "saveTargeting": "保存先設定" },
    "placeholders": { "taName": "目標設定の名前を入力してください" },
    "errors": { "taNameHasBeenUsed": "この名前はすでに使用されています。" },
    "messages": {
      "createSuccess": "成功を築く",
      "updateSuccess": "更新成功",
      "createFailed": "ビルド失敗",
      "updateFailed": "更新に失敗しました"
    }
  },
  "savedTAManagement": {
    "labels": {
      "title": "保存した目標設定をインポートする",
      "taOptions": "保存された目標設定"
    },
    "buttons": { "import": "輸入", "delete": "この目標設定を削除する" },
    "placeholders": { "taOptions": "選択してください" },
    "titles": {
      "import": "保存した目標設定をインポートする",
      "delete": "保存した目標設定を削除する"
    },
    "messages": {
      "import": "現在の目標設定を、選択した目標設定に置き換えてもよろしいですか?",
      "delete": "この保存済みの目標設定を削除してもよろしいですか？\nこの操作は元に戻せません。",
      "outdate": "プラットフォームバージョンの更新により、この保存されたターゲット設定は利用できなくなりました",
      "deleteSuccess": "削除されました",
      "deleteFailed": "削除に失敗しました"
    }
  },
  "filterMenuTab": { "labels": { "filterList": "フィルター" } },
  "draftCreateModal": {
    "buttons": {
      "goSummary": "概要",
      "createDraft": "下書きを作成する",
      "addTarget": "追加の広告グループを追加する"
    },
    "titles": {
      "duplicate": "{{number}} {{l2Object}} をコピー",
      "target": "{{channel}} キャンペーン",
      "chooseTargetState": "ターゲット広告グループを選択"
    },
    "labels": {
      "order": "注文",
      "l1Object": "広告グループ",
      "numberOfCopies": "コピー数",
      "includeBinding": "既存ものを使用"
    },
    "hints": {
      "cannotBindHint": "バインドされたマテリアルが PMAX から作成されていない場合、または他の広告プラットフォームで編集されていない場合は、コピーされません。",
      "l1ObjectNeedSameChannel": "同じチャネル上の広告グループのみ選択できます"
    }
  },
  "draftSummaryStateContent": {
    "labels": {
      "confirmationTitle": "広告コピー情報の概要",
      "description": "ソース広告は下書きとして次の広告グループにコピーされます",
      "hints": "基本的な広告情報、価格設定モデルの設定、目標トラッキング設定など、すべての関連情報がコピーされます。\nコピーされたキャンペーンは下書きとして保存され、確認後に正式に配信されます。\n入札制限が選択したキャンペーンと異なる場合、入札制限は選択したキャンペーンに基づいて調整されます。"
    },
    "confirmations": {
      "labels": {
        "order": "注文",
        "l1Object": "広告グループ",
        "channel": "グループチャンネル",
        "creative": "素材",
        "copies": "コピー数",
        "status": "検証ステータス"
      }
    },
    "status": {
      "passed": "検証に合格しました",
      "error": {
        "endDate": "配送期間が終了した注文にはコピーできません",
        "delivery": "配信先広告グループの配信状況表示の問題",
        "account": "広告アカウントが異なるためコピーできません"
      },
      "warning": {
        "bindings": "ソース広告が不承認になったか、セルフサービス プラットフォームで編集されたか、プラットフォームに問題がある可能性があるため、{{num}} 個のクリエイティブ バンドルはコピーされません。"
      }
    }
  },
  "draftSourceDetails": {
    "labels": {
      "sourceDetails": "ソース情報",
      "orderName": "注文名",
      "groupName": "広告グループ名",
      "channel": "グループチャンネル",
      "selectedOfCampaigns": "広告オプションの数"
    }
  },
  "draftCamapignGroupOption": { "hints": { "selected": "選択済み" } },
  "draftSummaryState": {
    "labels": { "createSuccess": "下書きが正常に作成されました" }
  },
  "campaignSetupFlow": {
    "messages": {
      "updateDraftSuccess": "下書きを保存しました",
      "updateDraftFailed": "下書きを保存できませんでした",
      "publishBindingFailed": "RTBキャンペーンは正常に作成されましたが、広告のバインディングに失敗しました。後で新しいクリエイティブを追加することを忘れないでください。",
      "publishL2L3Success": "RTB キャンペーンと広告バンドルが正常に確立されました。",
      "publishL2Success": "RTB キャンペーンが正常に確立されました。",
      "publishL2L3Failed": "RTB キャンペーンと広告バインディングの作成に失敗しました。"
    },
    "summaryStep": {
      "draftBindingTitle": "マテリアルバインディング",
      "labels": { "draftBinding": "素材" },
      "message": {
        "willDeliverImmediately": "キャンペーンプランはすでに有効化されているため、ドラフトが公開されるとすぐに広告の掲載が開始されます。"
      }
    }
  },
  "messageCampaignSetupFlow": {
    "descriptions": {
      "validatingContent": "メッセージの内容を確認しています..."
    }
  },
  "orderType": { "enums": { "tenmax": "TenMax" } },
  "rtbCampaign": {
    "billingEvent": {
      "rs": {
        "reach": "インプレッション数",
        "impressions": "インプレッション数",
        "clicks": "クリック数",
        "video_views": "動画視聴回数",
        "video_views_reach": "動画視聴回数",
        "sales": "クリック数",
        "acpm": "インプレッション数",
        "wcpm": "インプレッション数"
      },
      "rb": {
        "reach": "インプレッション数",
        "impressions": "インプレッション数",
        "clicks": "クリック数",
        "video_views": "動画視聴回数",
        "sales": "コンバージョン行動の数"
      },
      "dcpm": "インプレッション数",
      "fcpm": "インプレッション数",
      "fcpv": "動画視聴回数",
      "fcpc": "クリック数",
      "fvcpm": "インプレッション数",
      "facpm": "インプレッション数",
      "fwcpm": "インプレッション数",
      "fbcpm": "メッセージ単価",
      "unspecified": "指定されていない"
    },
    "limitation": {
      "operationSet": { "preferred": "優先配信", "include": "配送制限" }
    }
  },
  "messageCampaign": {
    "billingEvent": {
      "unspecified": "指定されていない",
      "fixed_viewable_impression": "ビューアブルインプレッション数"
    }
  },
  "orderDownloadReportPanel": {
    "labels": {
      "audienceData": "視聴者情報",
      "country": "市",
      "domain": "ドメイン"
    }
  },
  "campaignDashboard": {
    "labels": {
      "future": "内部",
      "ago": "フォワード",
      "endsin": "終了",
      "days": "日",
      "impres": "インプレッション数",
      "clicks": "クリック数",
      "ctr": "クリックスルー率",
      "campaignCount": "キャンペーン実行回数",
      "spent": "消化金額",
      "orderTotalBudget": "総注文予算",
      "orderCount": "注文執行数",
      "orderTotalSpent": "合計注文金額",
      "optimization": "入札モード",
      "bidStrategy": "入札戦略",
      "bidCap": "入札制限",
      "adType": "アクティビティの種類",
      "campaignStatus": "アクティビティステータス",
      "pleaseSearch": "一致するキャンペーンを検索するには、検索ボタンをクリックしてください。",
      "noData": "一致するキャンペーンが見つかりません",
      "adjustmentNeeded": "要調整のアクティビティタイプ",
      "allCampaigns": "すべてのアクティビティ"
    },
    "titles": {
      "main": "キャンペーンダッシュボード",
      "today": "今日の結果",
      "yesterday": "昨日の結果"
    },
    "buttons": { "search": "検索", "download": "フォームのダウンロード" },
    "placeholders": { "searchbar": "検索キャンペーン..." },
    "headers": {
      "campaignId": "名前",
      "adjustmentTags": "要調整のアクティビティタイプ",
      "agencyName": "ディーラー",
      "advertiserName": "広告主",
      "orderName": "注文",
      "executeRate": "配送の進捗状況",
      "ctr": "クリックスルー率",
      "bidPrice": "入札制限",
      "startDate": "開始日",
      "endDate": "終了日",
      "optimize": "入札モードと上限",
      "magnificationRatio": "重さ",
      "orderId": "注文番号",
      "campaignId_excel": "キャンペーンID",
      "campaignName": "アクティビティ名",
      "adType": "アクティビティの種類",
      "budget": "予算",
      "spent": "消化金額",
      "optimize_excel": "入札モード"
    },
    "fileNames": {
      "filterInfo": {
        "1": "{{days}}日後に終了します",
        "-1": "{{days}}日前に終了しました"
      },
      "allAdTypeInfo": "すべてのアクティビティタイプ",
      "statusInfo": {
        "1": "放送中活動",
        "2": "無効なアクティビティ",
        "-1": "すべてのイベント"
      }
    }
  },
  "adType": {
    "one_for_all_display": "ワンフォーオールディスプレイ広告",
    "display": "ディスプレイ広告",
    "third_party_bottom": "モバイル下部広告",
    "third_party_rectangle": "中サイズの長方形広告",
    "video": "視聴覚広告",
    "combo": "ビデオ+画像広告",
    "pic_short": "PIC屋外15秒広告",
    "pic_long": "PIC屋外30秒広告",
    "pic_extended": "PIC屋外60秒広告",
    "pic_broad": "PIC屋外60秒以上の広告",
    "hwacom_short": "HwaCom15秒広告",
    "hwacom_long": "HwaCom30秒広告",
    "hwacom_extended": "HwaCom60秒広告",
    "hwacom_broad": "HwaCom60秒以上の広告",
    "fridge_broad": "60秒以上の屋外冷凍庫広告",
    "fridge_long": "30秒の屋外冷凍庫広告",
    "fridge_extended": "60秒の屋外冷凍庫広告",
    "pmp_fridge": "PMP冷凍庫屋外広告",
    "outdoor_line_message": "Outdoor Line Message 広告",
    "line_message": "Line Message 広告",
    "unknown": "不明な広告の種類",
    "third_party": "サードパーティの広告",
    "ctv": "デジタルテレビ広告",
    "message": "SMS広告",
    "pmp_pic": "PMP PIC 屋外広告",
    "sandbox_outdoor": "R&Dテストユーザー屋外広告",
    "sandbox_movable_outdoor": "R&Dテストユーザー移動式屋外広告"
  },
  "storedValueList": {
    "headers": {
      "adAgencyId": "ディーラーID",
      "used": "使用済みクォータ",
      "stored": "合計保存価値",
      "remain": "残りの保存価値"
    },
    "labels": { "title": "保存価値の制限", "noData": "保存価値情報なし" },
    "placeholders": { "searchbar": "ディーラーを探す..." }
  },
  "storedValueDetail": {
    "labels": {
      "title": "ストアードバリュー - {{agencyName}}",
      "remainValue": "残りの保存価値",
      "totalValue": "合計保存価値",
      "usedValue": "使用済みクォータ"
    },
    "buttons": { "addValue": "トップアップ", "editValue": "クォータを編集" }
  },
  "storedValueLog": {
    "headers": {
      "createTime": "日付",
      "description": "説明する",
      "comment": "述べる",
      "amount": "保存価値",
      "remain": "残りの保存価値"
    },
    "labels": { "noData": "尚無資料" }
  },
  "storedValueEditModal": {
    "labels": {
      "agency": "ディーラー",
      "amount": "金額",
      "comment": "述べる",
      "editConfirm": "{{agencyName}} のトップアップ金額を変更してもよろしいですか?"
    },
    "buttons": { "stored": "店" },
    "titles": {
      "addValueTitle": "トップアップ",
      "editValueTitle": "クォータを編集"
    }
  },
  "sourceList": {
    "title": "ソースリスト",
    "buttons": { "create": "+ ソース" },
    "headers": {
      "name": "名前",
      "duration": "ライフサイクル",
      "tags": "オーディエンスタグ",
      "countries": "対象国"
    },
    "placeholders": {
      "searchbar": "ソース名と番号を検索...",
      "noData": "現在ソースがありません。+ ソースをクリックして追加できます。"
    }
  },
  "source": {
    "labels": {
      "name": "名前",
      "duration": "ライフサイクル",
      "tags": "オーディエンスタグ",
      "countries": "対象国"
    }
  },
  "sourceForm": {
    "titles": { "create": "ソースを作成", "edit": "ソースを編集" },
    "hints": { "durationLimit": "期間は30日から365日まで設定できます" }
  },
  "sourceDetail": {
    "title": "視聴者情報",
    "titles": { "info": "オーディエンス名: {{name}}" },
    "buttons": { "edit": "ソースを編集" }
  },
  "categoryList": {
    "buttons": { "create": "+ カテゴリー" },
    "placeholders": {
      "noData": "現在、カテゴリがありません。「+ カテゴリ」をクリックして追加してください。",
      "searchbar": "検索カテゴリ名と番号、対象者分類..."
    },
    "headers": {
      "name": "名前",
      "tenmaxCategory": "オーディエンスセグメンテーション",
      "audienceCount": "観客"
    },
    "hints": {
      "importCookie": "Cookieオーディエンスをインポートする",
      "importDeviceId": "デバイスオーディエンスをインポートする",
      "export": "エクスポートオーディエンス",
      "importSuccess": "インポート成功",
      "exportSuccess": "エクスポート成功"
    }
  },
  "categoryForm": {
    "titles": { "edit": "カテゴリを編集", "create": "カテゴリを作成" }
  },
  "category": {
    "labels": {
      "name": "名前",
      "tenmaxCategory": "オーディエンスセグメンテーション"
    }
  },
  "customLayoutList": {
    "title": "手彫りバージョン",
    "tooltips": {
      "delete": "手彫りの模様を削除",
      "deleteDisabled": "この手彫りの模様を削除できません"
    },
    "alerts": {
      "delete": {
        "title": "手彫りの模様を削除",
        "message": "手彫りのテンプレート {{name}} を削除してもよろしいですか?"
      }
    },
    "placeholders": {
      "noData": "現在、情報がありません。「+ 手彫りパターン」をクリックすると、新しい情報を追加できます。",
      "searchbar": "手彫りのパターン名または ID を検索します..."
    },
    "buttons": {
      "create": "+ 手彫りの模様",
      "preview": "手彫りの模様をプレビュー"
    },
    "headers": {
      "name": "パターン名",
      "previewUrl": "テンプレートのプレビュー",
      "layoutId": "パターンID",
      "device": "デバイスタイプ",
      "type": "バージョンタイプ"
    }
  },
  "customLayoutSetupFlowPage": {
    "labels": {
      "upload": "手彫りの模様をアップロード",
      "setup": "設定 Macro",
      "preview": "プレビュー",
      "name": "パターン名",
      "layoutId": "パターンID",
      "previewUrl": "プレビューリンク",
      "type": "バージョンタイプ",
      "device": "デバイスタイプ",
      "template": "パターンファイル",
      "desktop": "デスクトップ",
      "mobile": "携帯電話",
      "rectangleLayout": "手彫りの長方形の素材",
      "bottomLayout": "手刻置底素材"
    },
    "titles": { "create": "手彫りの模様を作る" },
    "breadcrumbs": { "home": "手彫りバージョン", "create": "新しい" },
    "hints": {
      "templateContent": "zipアーカイブにはad_tag.htmlが含まれている必要があります"
    },
    "errors": {
      "zipContentError": "zipアーカイブにはad_tag.htmlが含まれている必要があります"
    },
    "buttons": { "configMacro": "設定 Macro" }
  },
  "fieldConfigPage": {
    "labels": {
      "fieldName": "フィールド名",
      "fieldDescription": "フィールドの説明",
      "fieldType": "フィールドタイプ",
      "fileSize": "ファイルの長さと幅",
      "fileStorage": "ファイルサイズ",
      "fileRatio": "ファイル比率",
      "fileType": "ファイルタイプ",
      "videoDuration": "ビデオの長さ",
      "textMinLength": "最小単語数",
      "textMaxLength": "最大単語数"
    }
  },
  "formikConfigInputField": {
    "errors": {
      "fileSize": "ファイルの高さと幅は {{size1}} で、{{size2}} と同じである必要があります。",
      "fileRatio": "ファイル比率は{{ratio}}である必要があります",
      "fileType": "このファイル形式は {{type}} 形式です。{{types}} である必要があります。",
      "fileStorage": "ファイルサイズは {{storage1}} です。これは {{storage2}} より小さくなければなりません。",
      "minLength": "単語数は{{min}}より大きくなければなりません",
      "maxLength": "文字数は{{max}}未満である必要があります",
      "videoDuration": "この動画の長さは {{duration1}} 秒で、{{duration2}} 秒未満である必要があります。"
    },
    "hints": {
      "fileSizeLimit": "ファイルの長さと幅は{{limit}}に等しくなければなりません",
      "fileRatioLimit": "ファイルサイズは{{limit}}である必要があります",
      "fileStorageLimit": "ファイルサイズは {{limit}} MB 未満である必要があります",
      "fileTypeLimit": "このファイルは {{limit}} の形式である必要があります",
      "videoDurationLimit": "動画は{{limit}}秒を超えることはできません",
      "textMinLengthLimit": "文字数は{{limit}}より大きくなければなりません",
      "textMaxLengthLimit": "文字数は{{limit}}未満である必要があります"
    }
  },
  "macroFieldPlaceholder": {
    "hints": {
      "pleaseConfigMacro": "マクロ名、説明、タイプ、その他の追加制限を設定してください"
    }
  },
  "videoFormInput": {
    "errors": {
      "loadingVideo": "ビデオを読み取ることができません。av1、H.265、またはH.264形式でエンコードされたビデオを提供してください。"
    }
  },
  "customLayoutForm": { "labels": { "customLayout": "手彫りバージョン" } },
  "fieldTypes": {
    "image": "写真",
    "video": "ビデオ",
    "url": "連結",
    "text": "純文字"
  },
  "messageSegments": { "title": "ニュースレターの読者" },
  "messageSegmentForm": {
    "titles": {
      "create": "ニュースレターの読者を増やす",
      "edit": "編集者ニュースレターの対象読者"
    },
    "fields": {
      "select": "対象者を選択する",
      "description": "説明する",
      "name": "対象者名",
      "advertiser": "広告主"
    },
    "hints": {
      "selectHint": "生成された視聴者プロフィール",
      "emailCount": "メールボックスの数: {{count}}",
      "phoneCount": "電話の回数: {{count}}",
      "gIdCount": "視聴者数: {{count}}"
    },
    "inventory": {
      "titile": "分類",
      "contentPlaceholder": "カテゴリーを選択してオーディエンスを選択してください",
      "segmentCount": "{{total}}人の視聴者"
    },
    "buttons": {
      "segmentCountBtn": "オーディエンスサマリーに含まれるオーディエンスの数を表示します"
    }
  },
  "messageSegmentList": {
    "buttons": { "create": "+ ニュースレターの読者" },
    "placeholders": { "searchbar": "SMS 受信者の名前と番号を検索します..." },
    "labels": {
      "deleteModalContent": "このオーディエンスを削除してもよろしいですか?"
    },
    "hints": {
      "noData": "現在、SMSオーディエンスがありません。新しいオーディエンスを追加するには、「+オーディエンス」をクリックしてください。",
      "edit": "オーディエンスを編集"
    },
    "headers": {
      "id": "名前",
      "description": "説明する",
      "maxAliveDate": "有効期限"
    }
  },
  "picFormModel": {
    "hints": {
      "videoDuration": "動画の長さは {{min}} 秒から {{max}} 秒の間でなければなりません",
      "audioDuration": "ファイルの長さは {{min}} 秒から {{max}} 秒の間でなければなりません",
      "videoDurationMin": "動画の長さは{{min}}秒以上である必要があります",
      "audioDurationMin": "音声ファイルは少なくとも{{min}}秒の長さである必要があります"
    }
  },
  "customOutdoorDevice": {
    "buttons": {
      "switchToList": "通常モードに切り替える",
      "switchToMap": "地図モードを開く",
      "previewRadius": "範囲を表示",
      "confirmRadius": "追加を確定",
      "removeRadius": "範囲から削除",
      "viewDevices": "デバイスを表示",
      "hideDevices": "デバイスを隠す"
    },
    "placeholder": { "searchGoogleMap": "Google マップを検索" },
    "popout": { "title": "デバイス名" },
    "cluster": {
      "added": "追加済み",
      "filtered": "絞り込み",
      "normal": "通常",
      "full": "上限に達しました"
    }
  },
  "pmp": {
    "pmpTypes": { "buyout": "プライベートテーブル", "sponsorship": "障害" },
    "labels": {
      "pmpType": "PMPモード",
      "budget": "予算",
      "name": "PMP注文名",
      "duration": "配信期間",
      "dayparts": "配信時間を指定する",
      "spaces": "機械",
      "agency": "ディーラーID",
      "channelGroupId": "配信チャネル",
      "noAgency": "ディーラー情報なし"
    },
    "adminStatus": {
      "notBinding": "解放された",
      "binding": "バウンド",
      "stop": "非アクティブ化",
      "finish": "終了しました",
      "expired": "失敗"
    }
  },
  "pmpList": {
    "title": "PMP注文",
    "buttons": {
      "create": "+ PMP注文",
      "activate": "有効にする",
      "deactivate": "無効化",
      "showDevices": "展示機"
    },
    "placeholders": {
      "searchbar": "PMP 注文名を検索...",
      "noData": "現在アクティビティはありませんが、「+ PMP 注文」をクリックしてアクティビティを追加できます。"
    },
    "headers": {
      "name": "PMP注文名",
      "status": "状態",
      "adAgencyId": "ディーラーID",
      "budget": "予算とPMPモデル",
      "schedule": "配信期間",
      "space": "機械",
      "channelGroupId": "配信チャネル"
    },
    "hints": {
      "cannotEdit": "無効化された注文、期限切れの注文、または最終設定時間を超過した注文は編集できません。",
      "pmpStatus": "ディーラーによって正常にバインドされると、PMP 注文は変更できなくなります。"
    },
    "labels": {
      "devicesInfo": "屋外機械情報",
      "deactivateSuccess": "PMP注文が正常に無効化されました"
    }
  },
  "pmpActivateModal": {
    "titles": { "sponsorshipConflict": "既存のPMP注文との競合" },
    "hints": {
      "conflictWith": "既存のPMP注文",
      "durationConflict": "重複配信期間",
      "spaceConflict": "重複配置",
      "boundPmpSuggest": "これは拘束されたPMP注文です。新しい要件を満たすには、新しい注文を開くことをお勧めします。",
      "unboundPmpSuggest": "これはバインドされていない PMP 注文であり、時間と配置を変更した後に開くことができます。"
    }
  },
  "pmpSetupFlowPage": {
    "titles": {
      "create": "PMP注文を作成する",
      "edit": "PMP注文の編集",
      "summary": "PMP注文の概要",
      "formSection": "PMP注文設定",
      "summarySection": "PMP注文の概要"
    },
    "labels": {
      "createSuccess": "PMP注文が正常に確立されました",
      "updateSuccess": "PMP 注文が正常に更新されました"
    }
  },
  "pmpForm": {
    "errors": {
      "sponsorshipConflict": "選択した配置時間が重複しています",
      "createBeforeMinDate": "開始時間は明後日以降にしてください"
    },
    "hints": {
      "budget": "現在の設定に基づくと、推奨予算は {{min}} です",
      "dayparts": "※期間を閉じるとすべて選択されます"
    }
  },
  "channelGroups": {
    "title": "配信チャネル管理",
    "titles": {
      "epaperDefaultImageTab": "電子ペーパー既定画像",
      "epaperDefaultImageContent": "電子ペーパー既定画像",
      "basicTab": "配信チャネル",
      "specialSettingsTab": "イベントの特別設定",
      "reportTab": "レポート設定",
      "bidPriceTab": "配送量制限",
      "adTypesTab": "キャンペーンタイプの設定",
      "outdoorCreativeSizesTab": "屋外広告用素材のサイズ設定",
      "basicContent": "配信チャネル情報",
      "specialSettingsContent": "イベントの特別設定",
      "reportContent": "レポート設定",
      "bidPriceContent": "配送量制限",
      "edit": "配信チャネルを編集",
      "derecognitionAgencyContent": "ディーラー販売は認められない",
      "adTypesContent": "キャンペーンタイプの設定",
      "outdoorCreativeSizesContent": "屋外広告用素材のサイズ設定",
      "defaultMargin": "販売店対帳レポートのデフォルト利益",
      "currencyContent": "報告通貨",
      "create": "配信チャネルを確立する",
      "nonExpressPassCategoriesTab": "エクスプレスパス対象外カテゴリー",
      "nonExpressPassCategoriesContent": "エクスプレスパス対象外カテゴリー",
      "auditLogTab": "操作履歴",
      "brandContent": "チャネルブランド情報"
    }
  },
  "channelGroup": {
    "labels": {
      "name": "配信チャネル",
      "publisherIds": "発行者ID",
      "creativeSizes": "サイズ設定",
      "supportPMP": "PMPのサポート",
      "supportWeatherTargeting": "天気ターゲティング",
      "isScreenSpliced": "マルチスクリーン",
      "isMultiScreenSameVideo": "同時同期再生",
      "screenSplicedVerticalScreenCount": "縦スクリーン数",
      "screenSplicedHorizontalScreenCount": "横方向スクリーン数",
      "multiSplicedScreenCreativeSize": "マルチ分割スクリーンサイズ",
      "singleScreenCreativeSize": "単一スクリーンサイズ",
      "deliveryUnit": "配送単位",
      "alertEmails": "アラート通知メール",
      "siteId": "Site ID",
      "archivedSuffix": "(停止中)",
      "isCompositeCreative": "素材を合成するか",
      "compositePixelSize": "実際の再生サイズ",
      "allowedVideoCodecs": "対応ビデオエンコード",
      "allowedVideoCodecsAll": "すべて",
      "supportCBO": "CBOのサポート"
    },
    "compositeSettingError": {
      "notSynced": "RMax の合成設定を未受信",
      "sizeMissing": "実際の再生サイズがありません",
      "sizeNotMultiple": "実際の再生サイズが枠サイズの整数倍ではありません",
      "sizeTooSmall": "実際の再生サイズが連結画面の合計サイズより小さいです"
    },
    "filter": {
      "statusFilter": "チャネルステータス",
      "statusFilterMenuTitle": "チャネルステータスを選択",
      "statusTag": "ステータス"
    },
    "status": { "active": "有効", "all": "すべて", "archived": "停止済み" }
  },
  "channelGroupForm": {
    "labels": {
      "epaperDefaultImage": "既定画像",
      "epaperDefaultImageNoScreenSizeError": "このチャネルは画面解像度が未同期のため、画像サイズを検証できません。",
      "name": "チャンネル名",
      "nameI18n": {
        "ja": "チャンネル名 (日本語)",
        "en": "チャンネル名 (英語)",
        "zh-tw": "チャンネル名 (繁体字中国語)"
      },
      "publisherIds": "発行者ID",
      "salesChannelReportShowOverspend": "超過分を控除",
      "derecognitionAgencyIds": "ディーラー販売は認められない",
      "defaultMargin": "販売店対帳レポートのデフォルト利益",
      "limitPublisherId": "出版社を制限する",
      "publisherNotLimited": "制限なし",
      "supportPMP": "PMPのサポート",
      "supportWeatherTargeting": "天気ターゲティング",
      "noPublisherIdWarning": "RMaxシステム管理者に、配信チャネルにパブリッシャーIDがまだ割り当てられていないことを通知する必要があります。これはPMaxのアクティビティに影響します。配信の異常を回避するため、できるだけ早く調整してください。",
      "alertEmails": "アラート通知メール",
      "currency": "報告通貨",
      "nonExpressPassCategories": "素材カテゴリー",
      "supportCBO": "CBOのサポート",
      "supportCBOStaticChannelHint": "このチャネルの CBO はシステムで既定により有効化されており、このスイッチでは制御されません。",
      "supportCBOUnsupportedChannelHint": "このチャネルでは CBO を利用できません。このスイッチは機能しません。",
      "brandNameI18n": {
        "ja": "ブランド名 (日本語)",
        "en": "ブランド名 (英語)",
        "zh-tw": "ブランド名 (繁体字中国語)"
      },
      "brandUrl": "ブランドリンク",
      "brandFilteredIcon": "地図マーカー画像 (条件に一致)",
      "brandNormalIcon": "地図マーカー画像 (条件外 / 満枠)",
      "brandIconTypeHint": "SVGまたはPNG形式で利用可能",
      "brandIconPinHint": "ピンの先端は画像の下端中央に配置してください",
      "brandIconTypeError": "画像形式はsvgまたはpngである必要があります",
      "brandNameInvalidCharError": "改行、制御文字、不可視文字、< または > は使用できません",
      "brandNameUrlError": "URLやメールアドレスは使用できません",
      "brandUrlError": "http:// または https:// で始まる有効なURLを入力してください"
    },
    "placeholders": { "alertEmails": "メールを入力して Enter で追加" },
    "errors": {
      "publisherIdIsUsed": "パブリッシャー ID は別の配信チャネルで既に使用されています: {{overlapIds}}"
    }
  },
  "channelGroupList": {
    "placeholders": { "searchbar": "配信チャネル名または ID を検索..." },
    "labels": {
      "noData": "現時点では配信チャネルはありません",
      "archiveReasonPmax": "PMax：{{reason}}",
      "archiveReasonRmax": "RMax：{{reason}}"
    },
    "hints": { "edit": "配信チャネルを編集" },
    "buttons": { "create": "+ 配信チャネル" },
    "headers": { "archiveReason": "停止理由", "status": "ステータス" }
  },
  "channelGroupDetail": {
    "labels": {
      "name": "配信チャネル名: {{name}}",
      "archiveConfirmTitle": "この販売チャネルを停止しますか？",
      "archiveConfirmContent": "このチャネル配下の配信中キャンペーンは一時停止されます。\n配下の PMP 注文は停止され、RMax 側の対応するディールは削除されます。\nチャネルを再開しても、以上のいずれも復元されません。削除されたディールは作り直す必要があります。",
      "unarchiveConfirmTitle": "この販売チャネルを再開しますか？",
      "unarchiveConfirmContent": "チャネルは再び選択できるようになります。\n以前停止したキャンペーンと PMP 注文は停止のままで、手動で再開する必要があります。\nRMax 側で削除されたディールは復元されず、作り直す必要があります。",
      "archiveStatus": "チャネルステータス",
      "archiveStatusArchived": "停止中",
      "archiveStatusActive": "有効",
      "archiveReason": "停止理由"
    },
    "buttons": { "archive": "停止", "unarchive": "再開" },
    "placeholders": {
      "archiveReason": "このチャネルを停止する理由を入力してください"
    }
  },
  "channelGroupMembers": {
    "buttons": { "addMember": "+ メンバー" },
    "headers": {
      "id": "シリアルナンバー",
      "email": "電子メール",
      "name": "メンバー名",
      "status": "州",
      "permission": "権限"
    },
    "active": "有効にする",
    "inactive": "無効化",
    "permissions": {
      "RECONCILIATION_OFFICER": "財務スタッフ | 口座調整スタッフ",
      "BEACON_ADMIN": "Beacon マネージャー | システム管理者",
      "BEACON_EXECUTIVE": "Beacon オペレーター | 広告配信と beacon のメンテナンスに重点を置き、プッシュコンテンツの設定を担当します"
    },
    "labels": {
      "noDataAvailable": "現在メンバーがいません。「+ メンバー」をクリックして新しいメンバーを追加してください。"
    },
    "hints": { "delete": "アカウント権限の削除" }
  },
  "beaconConnectionList": {
    "labels": {
      "newBeaconConnection": "+ ビーコン接続方法",
      "beaconType": "ビーコンタイプ",
      "lineOAName": "Line OA 名",
      "tenMaxBeaconName": "TenMaxビーコン名"
    },
    "hints": { "edit": "ビーコン接続方法を編集" },
    "placeholders": {
      "noData": "現在データがありません。「+ ビーコン接続方法」をクリックして追加を開始できます。",
      "searchbar": "ビーコン接続方法名を検索..."
    },
    "headers": {
      "beaconType": "ビーコンタイプ",
      "name": "名前",
      "webhookType": "Webhookタイプ",
      "hardwareId": "ハードウェアID",
      "otherInfo": "その他のビーコン情報"
    }
  },
  "beaconConnectionForm": {
    "titles": {
      "create": "ビーコン接続を確立する方法",
      "edit": "ビーコン接続方法を編集"
    }
  },
  "beaconType": {
    "lineSimpleBeacon": "Line Simple Beacon",
    "tenmaxBeacon": "TenMaxビーコン"
  },
  "beaconField": { "labels": { "messageType": "メッセージタイプ" } },
  "outdoorLineMessageField": {
    "labels": {
      "imageMessage": "プッシュ写真",
      "videoMessage": "プッシュビデオ",
      "videoMessagePreview": "プッシュビデオプレビュー",
      "textMessage": "プッシュメッセージ",
      "messageTypes": {
        "text": "テキスト",
        "image": "静止画",
        "video": "動画",
        "join": "LINE友達に追加",
        "coupon": "クーポン"
      },
      "officialAccount": "LINE公式アカウント",
      "coupon": "クーポン"
    },
    "hints": {
      "imageType": "PNGまたはJPG形式が利用可能",
      "storage": "ファイルサイズは {{storage}} MB 未満である必要があります",
      "imageRatio": "画像サイズは{{ratio}}である必要があります",
      "videoType": "MP4ビデオ形式のみ利用可能です",
      "videoDuration": "最長{{second}}秒の動画を使用できます",
      "videoRatio": "ビデオの比率は{{ratio}}である必要があります",
      "officialAccount": "@から始まる公式アカウントを入力してください"
    }
  },
  "outdoorLineMessageFields": {
    "labels": { "addLineMessage": "プッシュタイプ" }
  },
  "creativeSummaryStep": {
    "labels": {
      "lineMessage": "情報",
      "beaconInfo": "ビーコン情報",
      "beaconSetting": "Beacon 設定",
      "join": "公式LINEアカウントに参加 <1>{{value}}</1>",
      "coupon": "クーポン <1>{{value}}</1>"
    }
  },
  "outdoorTenMaxBeaconMessageField": {
    "labels": {
      "messageTypes": { "text": "テキスト" },
      "messageType": "メッセージタイプ",
      "bundleIds": "バンドルID",
      "deepLinkIOS": "iOS アプリページパラメータ",
      "deepLinkAndroid": "Android アプリのページパラメータ",
      "dataIOS": "iOS アプリページパラメータ",
      "dataAndroid": "Android アプリのページパラメータ",
      "title": "タイトルをプッシュ",
      "message": "コンテンツをプッシュする"
    },
    "errors": {
      "data": "iOSまたはAndroidアプリページのパラメータを入力する必要があります",
      "bundleIdsUnique": "重複したバンドルIDを入力しないでください"
    },
    "hints": { "inputLength": "{{length}}文字を入力できます" },
    "placeholders": {
      "bundleIds": "ID を入力した後、Enter キーを使用して別のバンドル ID を追加できます..."
    }
  },
  "selectPmpStep": {
    "buttons": {
      "createNewCreative": "新規作成",
      "bindCreative": "既存ものを使用"
    }
  },
  "pmpComparingModal": {
    "title": "PMPレビューの変更",
    "labels": { "currentPmp": "修正前", "newPmp": "修正後" }
  },
  "adminBidPriceModal": {
    "titles": { "manageAdminBidPrice": "{{id}} 入札設定を変更する" }
  },
  "adminBidPrice": { "labels": { "modifyAdminBidPrice": "金額を変更する" } },
  "modifyTrackingState": { "title": "さまざまなトラッキングタイプを編集する" },
  "modifyScheduleState": {
    "title": "配信期間編集",
    "enableStartDate": "開始時間",
    "enableEndDate": "終了時間",
    "startDateCannotModifyHint": "キャンペーンが開始したら、開始時間を変更することはできません。",
    "titles": { "conflictCampaigns": "無視されるキャンペーン" },
    "hints": {
      "conflictCampaigns": "調整された時間が元の広告配信期間と競合する場合は、元の設定が保持されます。"
    },
    "messages": { "scheduleUpdated": "一括編集が成功しました" }
  },
  "modifyLimitationState": {
    "titles": {
      "add": "新しいターゲットの最適化",
      "remove": "ターゲットの最適化を削除する",
      "ignoreCampaigns": "無視されるキャンペーン"
    },
    "hints": {
      "remove": "選択したアイテムは削除されます",
      "ignoreRemoveFromCampaigns": "配信の問題を回避するには、少なくとも 1 つの Adx を選択する必要があります。",
      "ignoreAddToCampaigns": "新しく追加された設定が広告の元の設定と競合する場合は、元の設定が保持されます。"
    }
  },
  "ignoreCampaignSummary": {
    "headers": {
      "name": "キャンペーン名",
      "limitation": "原設定",
      "originalSettings": "原設定"
    }
  },
  "limitationSummaryState": {
    "titles": {
      "add": "新しいターゲットの最適化",
      "remove": "ターゲットの最適化を削除しました"
    }
  },
  "channelGroupAdTypeForm": {
    "titles": { "addAdType": "新しいキャンペーンタイプ" },
    "labels": {
      "screenDisplayType": "再生特性",
      "name": "名前",
      "nameI18n": {
        "ja": "名前 (日本語)",
        "en": "名前 (英語)",
        "zh-tw": "名前 (繁体字中国語)"
      },
      "minDuration": "素材最短秒數",
      "maxDuration": "素材の最長秒数",
      "width": "素材の幅",
      "height": "素材高度",
      "outdoorType": "屋外広告の種類",
      "pricingModel": "価格モデル",
      "state": "キャンペーン タイプを有効にする",
      "duration": "素材秒数"
    },
    "errors": {
      "duplicateName": "他のキャンペーン名との競合",
      "durationOverlap": "クリエイティブの長さが他の広告タイプと競合しています: {{adTypes}}",
      "cannotUseRsPricingModelAlone": "RS 価格設定モードを単独で選択することはできません。",
      "adTypeUsed": "一度使用すると削除できない広告の種類: {{adTypes}}"
    }
  },
  "channelGroupAdTypeList": {
    "buttons": { "new": "+ キャンペーンタイプ" },
    "headers": {
      "id": "名前とID",
      "screenDisplayType": "再生特性",
      "duration": "素材秒數",
      "size": "素材サイズ",
      "state": "状態",
      "pricingModel": "価格モデル",
      "deliveryUnit": "配送単位",
      "supportedOutdoorTypes": "対応屋外広告タイプ"
    },
    "placeholders": {
      "noData": "現在、情報がありません。「+ キャンペーンタイプ」をクリックすると、新しい情報を追加できます。"
    },
    "labels": {
      "active": "有効にする",
      "inactive": "無効化",
      "deleted": "削除"
    },
    "hints": { "edit": "広告の種類を編集", "delete": "削除広告の種類" }
  },
  "outdoorCreativeSizeHint": {
    "labels": {
      "creativeInfoHint": "材料情報のリマインダー",
      "sizeInstruction": "サイズ説明する",
      "minSize": "最小サイズ",
      "maxSize": "最大サイズ"
    }
  },
  "outdoorDeviceReport": {
    "labels": {
      "metricType": "データタイプ",
      "scheduledTimeRange": "配信期間",
      "timeSlot": "時間",
      "ePublisherImpresTotal": "総人流数",
      "impresTotal": "総インプレッション数"
    },
    "headers": { "storeName": "店名", "deviceName": "機械名" },
    "title": "屋外機の納品実績",
    "errors": {
      "maxQueryHours": "{{days}}日間または{{hours}}時間を超えない期間を選択してください"
    }
  },
  "outdoorDeviceMetric": {
    "labels": { "ePublisherImpres": "人数", "impres": "インプレッション数" }
  },
  "outdoorDeviceGran": {
    "labels": {
      "day": "1日単位で時間ごとの累積表示",
      "hour": "日別・時間別表示"
    }
  },
  "outdoorDeviceReportChart": {
    "title": {
      "ePublisherImpres": "人流の分布",
      "impres": "インプレッション数の分布"
    }
  },
  "merchantList": {
    "labels": {
      "agencyOptionsTitle": "商家",
      "nodata": "現在、情報がありません。",
      "newMerchant": "+ 公式アカウント"
    },
    "title": "公式アカウント",
    "headers": { "name": "ブランド名", "officialAccount": "公式アカウント" },
    "placeholers": { "searchBar": "ブランド名、公式アカウントで検索..." }
  },
  "merchantDetail": {
    "labels": {
      "name": "ブランド名: {{name}}",
      "title": "公式アカウントと Beacon リスト",
      "editMerchant": "公式アカウントを編集"
    }
  },
  "merchantForm": {
    "titles": {
      "create": "公式アカウントを作成する",
      "edit": "公式アカウントを編集"
    },
    "labels": {
      "id": "公式アカウント ID",
      "name": "ブランド名",
      "website": "公式ウェブサイト",
      "category": "プリセット素材カテゴリ",
      "note": "その他の注意事項",
      "agency": "商家"
    }
  },
  "beaconMessageList": {
    "title": "Beacon メッセージ設定",
    "labels": {
      "restaurantOptionsTitle": "商家",
      "beaconConnectionOptionsTitle": "公式アカウント",
      "nodata": "現在データがありません。「+メッセージ」をクリックしてデータを追加してください。",
      "newBeaconMessage": "+ キャンペーンタイプ",
      "editHint": "Beacon メッセージを編集",
      "reportHint": "レポートを見る",
      "summaryHint": "メッセージの概要"
    },
    "headers": {
      "name": "Beacon メッセージ名",
      "merchant": "ブランド",
      "beaconConnection": "公式アカウント",
      "state": "広告ステータス",
      "endDate": "終了時間"
    },
    "buttons": { "activate": "有効にする", "deactivate": "無効化" },
    "placeholers": {
      "searchBar": "Beacon メッセージ名、ブランド名、公式アカウントで検索..."
    }
  },
  "beaconMessageSetupFlowPage": {
    "titles": {
      "create": "Beacon メッセージを作成する",
      "basicSection": "基本情報",
      "creativeSection": "メッセージ基本情報",
      "deviceSetupSection": "裝置設定",
      "formStep": "メッセージアクティビティ設定",
      "summaryStep": "情報の概要",
      "summarySection": "メッセージアクティビティの概要",
      "edit": "Beacon メッセージを編集",
      "summary": "Beacon メッセージの概要"
    }
  },
  "beaconMessageForm": {
    "labels": {
      "name": "メッセージアクティビティ名",
      "schedule": "配信期間",
      "dayparts": "配信時間を指定する",
      "channel": "配信チャネル"
    }
  },
  "restaurantDetail": { "labels": { "title": "商家" } },
  "restaurants": {
    "home": { "title": "商家", "searchPlaceholder": "商家で検索..." },
    "noDataAvailable": "データなし",
    "headers": { "name": "商家名" }
  },
  "beaconMessageFields": {
    "labels": {
      "frequencyCapSwitch": "送信頻度",
      "deviceSetting": "Beacon デバイスの設定"
    }
  },
  "screenDisplayType": {
    "movableOutdoor": { "single": "移動式単台" },
    "outdoor": { "single": "固定式単台" },
    "multiSpliced": "マルチ分割スクリーン",
    "synchronizedPlayback": "同時同期再生",
    "ePaper": { "single": "電子ペーパー単台" }
  },
  "multiSplicedCreativeDetail": {
    "labels": {
      "toggleSingleVideo": "元動画",
      "toggleMultiSplicedVideo": "分割動画",
      "toggleSingleImage": "元画像",
      "toggleMultiSplicedImage": "分割画像",
      "playAll": "再生",
      "pauseAll": "停止"
    }
  },
  "downloadOutdoorFinalReportPanel": {
    "title": "Outdoor 事件終結報告書",
    "buttons": { "generate": "生成" },
    "labels": {
      "targetImpressions": "目標インプレッション数",
      "showTop20Stores": "上位20店鋪の広告配信効果を表示すべきでしょうか"
    }
  },
  "deliveryUnit": { "device": "端末", "store": "店舗" },
  "collapsibleSection": {
    "labels": { "expand": "編集完了", "collapse": "設定の編集" }
  },
  "spaceHealth": {
    "labels": {
      "banned": "サービス停止",
      "warmingUp": "サービス起動中",
      "noData": "信号異常",
      "normal": "正常",
      "lastUpdated": "最終更新：{{time}}",
      "deleted": "削除済み"
    },
    "descriptions": {
      "warmingUp": "起動したばかりで、広告配信は徐々に正常に戻ります。",
      "noData": "この地点の広告配信が2時間以上中断しています。担当者が対応中です。"
    }
  },
  "addUrlModal": {
    "title": "外部リンクを挿入",
    "labels": { "clickUrl": "外部リンク", "addUrl": "外部リンクを追加" }
  },
  "siteAnnouncementForm": {
    "titles": {
      "create": "通知を追加",
      "edit": "通知を編集",
      "basicSettingSection": "基本情報設定",
      "agencySection": "ディーラー適用範囲",
      "contentSection": "通知内容",
      "advancedSection": "詳細設定"
    },
    "labels": {
      "name": "通知タイトル",
      "publishTime": "公開日時",
      "content": "通知内容",
      "duration": "通知表示期間",
      "prefix": { "duration": "通知を表示する期間" },
      "postfix": { "duration": "日後に非表示になります" },
      "chooseVendorStrategy": "ディーラー",
      "allAgencies": "全ディーラー",
      "partialAgencies": "ディーラーを指定",
      "shouldResend": "通知を再送信しますか",
      "attachmentUrls": "添付ファイル",
      "type": "通知種別",
      "imageUrl": "通知画像"
    },
    "placeholders": {
      "agencies": "ディーラーを選択してください",
      "attachmentUrls": "添付ファイルを選択してください"
    },
    "errors": {
      "nameLength": "通知タイトルは50文字以内で入力してください",
      "contentLength": "通知内容は300文字以内で入力してください",
      "nameInvalid": "通知タイトルには文字および句読点のみ使用できます。その他の特殊文字は通知に正しく表示されません。修正後に送信してください",
      "contentInvalid": "通知内容には文字および句読点のみ使用できます。その他の特殊文字は通知に正しく表示されません。修正後に送信してください",
      "publishTimeTooEarly": "現在より後の日時のみ設定できます"
    },
    "hints": {
      "allFileStorage": "すべてのファイルの合計サイズは {{storage}} 以下である必要があります",
      "fileType": "{{type}} 形式を使用できます"
    }
  },
  "siteAnnouncementList": {
    "title": "通知センター",
    "placeholders": {
      "adminNoData": "現在通知はありません。「＋通知」から追加できます。",
      "noData": "現在通知はありません",
      "adminSearchbar": "タイトル、内容、または通知ディーラーを検索…",
      "searchbar": "タイトルまたは内容を検索…"
    },
    "buttons": {
      "create": "+ 通知",
      "showDetail": "通知の詳細を表示",
      "activate": "有効",
      "deactivate": "無効"
    },
    "headers": {
      "name": "通知タイトル",
      "content": "通知内容",
      "agencyIds": "通知ディーラー",
      "publishTime": "公開日時",
      "status": "公開状態",
      "creator": "作成者",
      "attachmentUrls": "添付ファイル",
      "type": "通知種別",
      "imageUrl": "通知画像"
    },
    "labels": {
      "allAgencies": "全ディーラー",
      "published": "公開済み",
      "unpublished": "未公開",
      "inactive": "無効",
      "deleteModalTitle": "通知を削除",
      "deleteModalContent": "選択した通知をすべて削除してもよろしいですか？"
    },
    "hints": {
      "edit": "編集",
      "cannotDelete": "公開済みの通知は削除できません"
    },
    "messages": {
      "activateSuccess": "有効化しました",
      "deactivateSuccess": "無効化しました",
      "deleteSuccess": "削除しました",
      "deleteError": "削除に失敗しました"
    }
  },
  "siteAnnouncement": {
    "types": {
      "feature_update": "機能アップデート",
      "system_maintenance": "システムメンテナンス",
      "policy_announcement": "ポリシーのお知らせ",
      "incident_report": "障害通知",
      "general": "一般のお知らせ"
    }
  },
  "siteAnnouncementDetailModal": {
    "labels": { "publishedTime": "{{time}} に公開" }
  },
  "versionChecker": {
    "title": "新しいバージョン v{{version}} が利用可能です",
    "message": "現在表示しているページは古いバージョンです。エラーを防ぐため、ページを更新して最新バージョンを読み込んでください。",
    "reload": "今すぐ更新"
  },
  "adjustmentTags": {
    "noCreativeBound": "クリエイティブ未設定",
    "creativeRejected": "クリエイティブ審査不承認",
    "notDelivering": "配信未開始",
    "behindSchedule": "進捗遅延",
    "severelyBehind": "進捗大幅遅延",
    "storeBanned": "店舗閉鎖",
    "budgetUnderspendRisk": "予算未消化リスク"
  },
  "weatherVerification": {
    "labels": {
      "reportType": "レポート種別",
      "deliveryPerformance": "機器配信実績",
      "deliveryVerification": "機器配信検証",
      "timeSlot": "時間帯",
      "campaign": "広告キャンペーン",
      "store": "店舗",
      "maxQueryDaysHint": "最大{{days}}日間まで選択できます",
      "noConditions": "なし",
      "noStatusData": "機器ステータスが取得できません",
      "deviceStatus": "ステータス：{{status}}",
      "deviceStatusReason": "理由：{{reason}}",
      "exportCsv": "CSV エクスポート",
      "csvFileName": "機器配信検証_{{campaign}}_{{from}}_{{to}}_{{page}}ページ.csv"
    },
    "headers": {
      "dataTime": "時間",
      "storeName": "店舗",
      "result": "結果",
      "unmatchedReasons": "未配信の理由",
      "targetOf": "{{dimension}}の設定値"
    },
    "filters": {
      "all": "すべての時間帯",
      "delivered": "配信あり",
      "weatherUnmatched": "天気条件不一致・未配信",
      "deviceAbnormal": "機器異常・未配信"
    },
    "results": {
      "delivered": "配信あり",
      "weatherUnmatched": "天気条件不一致",
      "deviceAbnormal": "機器異常",
      "weatherAndDeviceAbnormal": "天気条件不一致・機器異常"
    },
    "reasons": {
      "weatherCode": "天気現象が不一致",
      "temperature": "気温が不一致",
      "relativeHumidity": "湿度が不一致",
      "uvIndex": "紫外線が不一致",
      "precipitation": "降水確率が不一致",
      "device": "機器異常"
    },
    "descriptions": {
      "deviceAbnormalTooltip": "天気条件は一致していますが、この時間帯に機器が配信していません。",
      "checkDevicePage": "機器管理ページでご確認ください。",
      "unmatchedTarget": "設定：{{target}}",
      "unmatchedActual": "実際：{{actual}}",
      "emptyTitle": "この広告グループには天気ターゲティングのキャンペーンがありません",
      "emptyHint": "天気ターゲティングを有効にすると、各時間帯の配信検証結果がここに表示されます",
      "weatherAndDeviceTooltip": "天気条件が一致せず、機器も異常のため配信していません。"
    },
    "errors": { "maxQueryDays": "{{days}}日以内の期間を選択してください" }
  },
  "deviceManagement": {
    "buttons": {
      "clearFilter": "フィルターをクリア",
      "downloadImportTemplate": "テンプレートをダウンロード",
      "exitListMode": "リストモードを終了",
      "export": "リストをエクスポート",
      "import": "リストをインポート",
      "loadImportSample": "サンプルリストを読み込む",
      "nextMonth": "翌月",
      "previousMonth": "前月",
      "startMatching": "照合を開始",
      "daypartAll": "すべて選択",
      "daypartCommute": "平日の通勤時間帯",
      "daypartNone": "クリア",
      "daypartWeekend": "週末終日"
    },
    "headers": {
      "address": "住所",
      "availabilityRate": "販売可能率",
      "availableSeconds": "販売可能秒数",
      "dailyAverageFootfall": "1日平均来店者数",
      "detail": "詳細",
      "deviceCharacteristic": "端末特性",
      "deviceName": "端末名",
      "healthState": "ステータス",
      "lastReportedAt": "最終報告",
      "soldSeconds": "販売済み秒数",
      "storeNum": "店舗番号",
      "unitName": "店舗名",
      "agencyName": "販売代理店名",
      "orderName": "注文名",
      "pmpFlight": "配信期間",
      "todayBusinessHours": "本日の営業時間"
    },
    "hints": {
      "administrativeArea": "都市を選択すると、その配下の行政区がすべて含まれます",
      "exportConditionsInFileName": "並び順とフィルター条件はファイル名に記録されます",
      "exportListColumnsOnly": "エクスポートされるファイルはリスト表示の列で構成され、配信期間と販売可能状況の集計は含まれません",
      "filterWithinList": "リスト内でさらに絞り込む",
      "healthState": "未選択の場合はすべてのステータスが対象です",
      "importFormat": "書式：都市_店舗番号_店舗名",
      "importMatchKey": "店舗番号で照合します。都市と店舗名は確認のみに使用されます",
      "placeCategory": "親を選択すると、その配下がすべて含まれます",
      "region": "単一階層",
      "daypartsOutsideBusinessHours": "選択した時間帯が一部の端末の営業時間外になる場合があります。各端末の営業時間をご確認ください。"
    },
    "labels": {
      "availabilityCalendar": "今後の販売可能状況",
      "basicInformation": "基本情報",
      "calendarRange": "{{startDate}} ~ {{endDate}}　計 {{days}} 日間",
      "coordinates": "緯度・経度",
      "dayparts": "配信時間帯",
      "deliverableDevices": "配信可能な端末",
      "deliverableStores": "配信可能な店舗",
      "detailTitle": "端末の詳細",
      "exportAll": "全 {{total}} 件",
      "exportCount": "件数",
      "exportDefaultSort": "既定の並び順（要確認のものを優先）",
      "exportFilterApplied": "フィルター {{total}} 項目を適用中",
      "exportListMode": "リストモード {{fileName}}",
      "exportNoFilter": "フィルター未適用",
      "exportScope": "エクスポート範囲",
      "exportSortAsc": "{{field}} 昇順",
      "exportSortBy": "<1>{{sort}}</1> で並べ替え",
      "exportSortDesc": "{{field}} 降順",
      "exportTopN": "現在の並び順で上位 N 件",
      "flightDayCount": "計 {{days}} 日間",
      "flightRange": "配信期間",
      "importPastedName": "貼り付けたリスト",
      "importReadCount": "{{fileName}}　{{total}} 件を読み込みました",
      "importRecognizedCount": "{{total}} 件を認識しました",
      "importSampleName": "サンプルリスト",
      "importTitle": "店舗リストをインポート",
      "lastReportedAtValue": "最終報告 {{value}}",
      "lastSynced": "最終同期 {{time}}",
      "listMode": "リストモード",
      "listModeCount": "計 {{total}} 件　該当 {{hit}} 件",
      "listModeIssueCount": "要確認 {{total}} 件",
      "overallAvailabilityRate": "全体の販売可能率",
      "region": "エリア",
      "resolution": "解像度",
      "secondsValue": "{{value}} 秒",
      "selectedHoursPerWeek": "週 {{hours}} 時間を選択中",
      "statusReason": "ステータスの説明",
      "weeklyFootTraffic": "過去 7 日間の来店者数",
      "pmpBookings": "PMP 購入履歴",
      "weeklyFootTrafficPeak": "最多は{{day}}の {{value}} 人",
      "businessHours": "営業時間",
      "openAllDay": "24時間",
      "closedForDay": "定休日",
      "weekdayShort": {
        "1": "月",
        "2": "火",
        "3": "水",
        "4": "木",
        "5": "金",
        "6": "土",
        "7": "日"
      }
    },
    "legends": {
      "ample": "十分",
      "low": "販売可能率 30% 未満",
      "medium": "販売可能率 60% 未満",
      "notScheduled": "配信時間帯外",
      "outOfRange": "配信期間外",
      "soldOut": "完売"
    },
    "messages": {
      "calendarNoBusinessHours": "この配信単位には営業時間のデータがないため、販売可能状況を計算できません",
      "exportInvalidCount": "0 より大きい件数を入力してください",
      "exportUnknownScope": "エクスポート範囲を選択してください",
      "calendarLoadFailed": "販売可能状況の読み込みに失敗しました",
      "noPmpBooking": "配信期間内にこの配信ポイントを購入した PMP はありません",
      "pmpBookingsLoadFailed": "PMP 購入履歴の読み込みに失敗しました",
      "listLoadFailed": "リストの読み込みに失敗しました",
      "importAmbiguous": "2 つの区切りではどちらが店舗番号か判別できません。「都市_店舗番号_店舗名」の形式にするか、店舗番号のみを入力してください",
      "importInvalidStoreNum": "店舗番号は数字で入力してください",
      "importMismatch": "都市または店舗名が、見つかった店舗と一致しません",
      "importNotFound": "この店舗番号は見つかりません",
      "insufficientBusinessHours": "データ不足",
      "loadingFilterOptions": "選択肢を読み込み中…",
      "missingBusinessHoursDevices": "ほかに {{total}} 台の端末がデータ不足です",
      "missingBusinessHoursStores": "ほかに {{total}} 件の店舗がデータ不足です",
      "noFilterOption": "該当する選択肢がありません",
      "noFootTrafficData": "来店者数のデータがありません",
      "noUnit": "現在の条件に該当するデータがありません",
      "selectChannelFirst": "先に配信チャネルを選択してください",
      "uncomputableCampaigns": "{{total}} 件のキャンペーンは販売済み秒数に計上できません",
      "filterOptionsLoadFailed": "選択肢の読み込みに失敗しました"
    },
    "placeholders": {
      "filterSearch": "選択肢を検索",
      "importPaste": "1 行につき 1 店舗。例：\n臺北市_177463_天福\nまたは店舗番号のみ：177463",
      "searchbar": "店舗名・店舗番号・住所で検索"
    },
    "tabs": {
      "availability": "端末の販売可能状況",
      "importFile": "ファイルをアップロード",
      "importPaste": "店舗番号を貼り付け",
      "list": "端末リスト表示"
    },
    "title": "端末管理"
  },
  "key": "jp"
}
